import { ref, computed, watch, nextTick, resolveComponent, openBlock, createElementBlock, createElementVNode, normalizeClass, createVNode, unref, createCommentVNode, withCtx, Fragment, renderList, createTextVNode, toDisplayString, createBlock, inject, mergeProps, onMounted, onUnmounted, normalizeProps, guardReactiveProps, Transition, normalizeStyle, pushScopeId, popScopeId, createStaticVNode } from 'vue';
import VueMultiselect from 'vue-multiselect';
import { useRoute, useRouter } from 'vue-router';
import { useDisplay } from 'vuetify';
import { select, scaleBand, axisLeft, scaleOrdinal, scaleLinear, axisBottom, stack, format } from 'd3';

var _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};

const _hoisted_1$h = /*#__PURE__*/createElementVNode("span", null, "Evaluation", -1 /* HOISTED */);
const _hoisted_2$h = /*#__PURE__*/createElementVNode("span", null, "Result Type", -1 /* HOISTED */);
const _hoisted_3$h = /*#__PURE__*/createElementVNode("span", null, "Scenario(s)", -1 /* HOISTED */);
const _hoisted_4$f = { key: 0 };
const _hoisted_5$e = { key: 1 };
const _hoisted_6$d = /*#__PURE__*/createElementVNode("span", null, "Participants", -1 /* HOISTED */);
const _hoisted_7$d = { class: "cohort-participants-container" };


const _sfc_main$j = {
  __name: 'GroupCohortSelects',
  props: {
  evaluations: Array,
  selectedEvaluation: Object,
  selectedResultType: Object,
  selectedScenarios: Array,
  resultTypes: Array,
  graphDataTypeSelected: String,
},
  emits: ['updateSelectedEvaluation', 'updateSelectedResultType', 'updateSelectedScenarios'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const route = useRoute();

const scenarios = ref([]);
const scenarioMultiSelect = ref(undefined);
const localSelectedEvaluation = ref(props.selectedEvaluation);
const localSelectedResultType = ref(props.selectedResultType);
const localSelectedScenarios = ref(props.selectedScenarios);
const resultTypeSelect = ref(null);
const evaluationSelect = ref(null);

const selectedScenariosSorted = computed(() => {
  return [...props.selectedScenarios].sort((a, b) => a.number - b.number);
});

const evaluationParticipants = computed(() => {
  if(props.selectedEvaluation){
    if(localSelectedResultType.value && localSelectedResultType.value.value === 'PROTECTION') {
      return props.selectedEvaluation.participants.filter(p => p.participant_capabilities.includes('Protection Capability'));
    }
    return props.selectedEvaluation.participants;
  }
  return [];
});

watch(() => props.selectedEvaluation, (newVal, oldVal) => {
  localSelectedEvaluation.value = props.selectedEvaluation;
  if(oldVal){
    scenarios.value = [];
  }
  if(newVal && !props.selectedResultType) {
    nextTick(() => {
      resultTypeSelect.value && resultTypeSelect.value.activate();
    });
  }
  if(!newVal) {
    nextTick(() => {
      evaluationSelect.value && evaluationSelect.value.activate();
    });
  }
},{immediate: true}
);

watch(() => props.selectedResultType, (newVal) => {
  localSelectedResultType.value = props.selectedResultType;
  if(newVal) {
    if(!route.query.scenarios) selectResultType();
    else setScenarios();
  }
}, {immediate: true});

watch(() => props.selectedScenarios, () => localSelectedScenarios.value = props.selectedScenarios);

watch(() => props.graphDataTypeSelected, () => setScenarios());

function removeScenario(option) {
  emit('updateSelectedScenarios', [...localSelectedScenarios.value.filter(scenario => scenario.number !== option.number)]);
  const scenarioToRemove = scenarios.value.find(scenario => scenario.number === option.number);
  scenarioToRemove.checked = false;
}

function setScenarios() {
  scenarios.value = props.selectedEvaluation.scenarios.filter((scenario) => {
    if (props.graphDataTypeSelected !== 'Noise') {
      return scenario.scenario_type === localSelectedResultType.value.value;
    }
    return true;
  }).sort((a,b) => a.number - b.number);
  scenarios.value.forEach(scenario => {
    if(props.selectedScenarios.find(s => s.number === scenario.number) || props.graphDataTypeSelected === 'Noise') {
      scenario.checked = true;
    }
    else {
      scenario.checked = false;
    }
  });
  if (props.graphDataTypeSelected === 'Noise') {
    setBaseNoiseScenarios();
  } else {
    if (localSelectedResultType.value?.value === 'PROTECTION' && localSelectedScenarios.value.find(s => s.scenario_type === 'DETECTION')) {
      localSelectedScenarios.value = localSelectedScenarios.value.filter(s => s.scenario_type === 'PROTECTION');
      emit('updateSelectedScenarios', localSelectedScenarios.value);
    }
    else if (localSelectedResultType.value?.value === 'DETECTION' && localSelectedScenarios.value.find(s => s.scenario_type === 'PROTECTION')) {
      localSelectedScenarios.value = localSelectedScenarios.value.filter(s => s.scenario_type === 'DETECTION');
      emit('updateSelectedScenarios', localSelectedScenarios.value);
    }
  }
}

function setBaseNoiseScenarios() {
  scenarios.value.forEach(scenario => {
    if (!localSelectedScenarios.value.find(s => s.number === scenario.number)) {
      selectScenario(scenario);
    }
  });
}

function selectResultType(){
  emit('updateSelectedResultType', localSelectedResultType.value);
  setScenarios();
  emit('updateSelectedScenarios', scenarios.value);
}

function selectScenarioFromCheck(option) {
  // makes sure the dropdown stays open when clicking adversary not on checkbox
  nextTick(() => {
    scenarioMultiSelect.value.activate();
  });
  if (option.checked) {
    selectScenario(option);
  } else if (!option.checked) {
    removeScenario(option);
  }
}

function selectScenario(option){
  localSelectedScenarios.value.push(option);
  emit('updateSelectedScenarios', localSelectedScenarios.value);
}

return (_ctx, _cache) => {
  const _component_v_chip = resolveComponent("v-chip");
  const _component_v_col = resolveComponent("v-col");
  const _component_v_row = resolveComponent("v-row");
  const _component_v_icon = resolveComponent("v-icon");
  const _component_v_checkbox = resolveComponent("v-checkbox");

  return (openBlock(), createElementBlock("div", null, [
    _hoisted_1$h,
    createElementVNode("div", {
      class: normalizeClass(_ctx.$vuetify.display.mobile ? '' : 'width-287')
    }, [
      createVNode(unref(VueMultiselect), {
        ref_key: "evaluationSelect",
        ref: evaluationSelect,
        modelValue: localSelectedEvaluation.value,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = $event => ((localSelectedEvaluation).value = $event)),
          _cache[1] || (_cache[1] = $event => (emit('updateSelectedEvaluation', localSelectedEvaluation.value)))
        ],
        options: __props.evaluations,
        placeholder: "Select evaluation",
        label: "display_name",
        class: "mk-vue-select result-select-menu",
        "data-id": "results.evaluationselect",
        selectLabel: "",
        deselectLabel: "",
        selectedLabel: ""
      }, null, 8 /* PROPS */, ["modelValue", "options"])
    ], 2 /* CLASS */),
    (__props.selectedEvaluation && __props.graphDataTypeSelected !== 'Noise')
      ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: normalizeClass({'text-left mt-2': true,  'width-287': !_ctx.$vuetify.display.mobile})
        }, [
          _hoisted_2$h,
          createVNode(unref(VueMultiselect), {
            ref_key: "resultTypeSelect",
            ref: resultTypeSelect,
            modelValue: localSelectedResultType.value,
            "onUpdate:modelValue": [
              _cache[2] || (_cache[2] = $event => ((localSelectedResultType).value = $event)),
              selectResultType
            ],
            options: __props.resultTypes,
            placeholder: "Select result type",
            class: "mk-vue-select result-select-menu",
            "data-id": "cohort.resulttypeselect",
            label: "label",
            selectLabel: "",
            deselectLabel: "",
            selectedLabel: ""
          }, null, 8 /* PROPS */, ["modelValue", "options"])
        ], 2 /* CLASS */))
      : createCommentVNode("v-if", true),
    (scenarios.value.length > 1)
      ? (openBlock(), createElementBlock("div", {
          key: 1,
          class: normalizeClass({'text-left mt-2': true,  'width-287': !_ctx.$vuetify.display.mobile})
        }, [
          _hoisted_3$h,
          createVNode(unref(VueMultiselect), {
            ref_key: "scenarioMultiSelect",
            ref: scenarioMultiSelect,
            options: scenarios.value,
            disabled: scenarios.value.length === 1,
            placeholder: "",
            onRemove: removeScenario,
            class: "mk-vue-select--multiple result-select-menu multi-scenario-select-menu",
            label: "name",
            selectLabel: "",
            deselectLabel: "",
            selectedLabel: "",
            "close-on-select": false,
            searchable: false
          }, {
            selection: withCtx(({ isOpen }) => [
              (!isOpen && __props.selectedScenarios.length)
                ? (openBlock(), createElementBlock("div", _hoisted_4$f, [
                    createVNode(_component_v_row, { class: "mk-vue-select-title-row" }, {
                      default: withCtx(() => [
                        createVNode(_component_v_col, { class: "mk-vue-select-title" }, {
                          default: withCtx(() => [
                            (openBlock(true), createElementBlock(Fragment, null, renderList(selectedScenariosSorted.value, (scenario) => {
                              return (openBlock(), createElementBlock("span", {
                                key: scenario.id
                              }, [
                                createVNode(_component_v_chip, {
                                  label: "",
                                  density: "comfortable",
                                  class: "px-2 mx-1"
                                }, {
                                  default: withCtx(() => [
                                    createTextVNode(toDisplayString(scenario.name), 1 /* TEXT */)
                                  ]),
                                  _: 2 /* DYNAMIC */
                                }, 1024 /* DYNAMIC_SLOTS */)
                              ]))
                            }), 128 /* KEYED_FRAGMENT */))
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]))
                : (openBlock(), createElementBlock("div", _hoisted_5$e, [
                    (openBlock(true), createElementBlock(Fragment, null, renderList(selectedScenariosSorted.value, (scenario) => {
                      return (openBlock(), createBlock(_component_v_chip, {
                        class: "mk-vue-select-chip px-2 mx-1 my-1",
                        key: scenario.id
                      }, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString(scenario.name) + " ", 1 /* TEXT */),
                          createVNode(_component_v_icon, {
                            onClick: $event => (removeScenario(scenario)),
                            size: "small",
                            class: "ml-1"
                          }, {
                            default: withCtx(() => [
                              createTextVNode("mdi-close")
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1024 /* DYNAMIC_SLOTS */))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]))
            ]),
            option: withCtx(({ option }) => [
              createVNode(_component_v_checkbox, {
                modelValue: option.checked,
                "onUpdate:modelValue": [$event => ((option.checked) = $event), $event => (selectScenarioFromCheck(option))],
                label: option.name,
                class: "mk-checkbox",
                "data-id": "cohort.scenarioselectcheckbox",
                disabled: scenarios.value.length === 0
              }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "label", "disabled"])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["options", "disabled"])
        ], 2 /* CLASS */))
      : createCommentVNode("v-if", true),
    (localSelectedScenarios.value.length)
      ? (openBlock(), createElementBlock("div", {
          key: 2,
          class: normalizeClass({
          'text-left mt-3': true, 
          'width-287': !_ctx.$vuetify.display.mobile
        })
        }, [
          _hoisted_6$d,
          createElementVNode("div", _hoisted_7$d, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(evaluationParticipants.value, (participant) => {
              return (openBlock(), createBlock(_component_v_chip, {
                label: "",
                class: "mx-1 my-1",
                key: participant.participant.initials
        
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(participant.participant.display_name), 1 /* TEXT */)
                ]),
                _: 2 /* DYNAMIC */
              }, 1024 /* DYNAMIC_SLOTS */))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ], 2 /* CLASS */))
      : createCommentVNode("v-if", true)
  ]))
}
}

};
var GroupCohortSelects = /*#__PURE__*/_export_sfc(_sfc_main$j, [['__file',"/home/runner/work/evals-website/evals-website/packages/enterprise-results/src/group-cohort-metrics/GroupCohortSelects.vue"]]);

function getModifierTypeCategory(modifierType) {
  let modifierTypeToCategoryMap = {
    "Alert": "Alert",
    "Configuration Change": "Configuration Change",
    "Configuration Change (Data Sources)": "Configuration Change",
    "Configuration Change (Detections)": "Configuration Change",
    "Configuration Change (Detection Logic)": "Configuration Change",
    "Configuration Change (UX)": "Configuration Change",
    "Correlated": "Correlated",
    "Correlation": "Correlation",
    "Delayed": "Delayed",
    "Delayed (Manual)": "Delayed",
    "Delayed (Processing)": "Delayed",
    "Final AAR": "Final AAR",
    "Host Interrogation": "Host Interrogation",
    "Innovative": "Innovative",
    "N/A": "N/A",
    "Residual Artifact": "Residual Artifact",
    "Tainted": "Tainted",
    "User Consent": "User Consent"
  };
  return modifierTypeToCategoryMap[modifierType];
}
function getEnrichedCriteriaText(questionText) {
  let enrichedCriteriaMap = {
    "Does the report accurately portray the Red Team activity chronologically and accurate sequence of events?": "Chronological breakdown of adverary's activities",
    "Does the report include a summary / executive summary?": "Executive summary",
    "Does the report include technical details?": "Technical details",
    "Does the report include remediation / recommendations?": "Recovery or remediation recommendations",
    "Does the report include threat intelligence / attribution?": "Attribution",
    "Does the report include MITRE ATT&CK enrichment?": "MITRE ATT&CK tactics and techniques mapping"
  };
  return enrichedCriteriaMap[questionText];
}
function getModifierColor(modifierCategory) {
  const modifierCategoryColorMap = {
    "Configuration Change": "#3E4A52",
    "Delayed": "#CED1D3",
    "Final AAR": "#3E4A52"
  };
  return modifierCategoryColorMap[modifierCategory];
}
function getResultCategoryColor(resultCategory) {
  let resultColorsDict = {
    Reported: "#403386",
    "Not reported": "#F7AC43",
    "Not Reported": "#F7AC43",
    "N/A": "#CED1D3",
    "Not applicable": "#CED1D3",
    Technique: "#403386",
    Tactic: "#89007D",
    General: "#D62150",
    Telemetry: "#FB7139",
    None: "#F7AC43",
    Blocked: "#403386",
    "Not blocked": "#F7AC43"
  };
  return resultColorsDict[resultCategory];
}
function getNoiseResultCategoryColor(resultCategory) {
  let resultColorsDict = {
    Reported: "#25333C",
    "Not reported": "#FFFFFF",
    "Not Reported": "#FFFFFF",
    "N/A": "#CED1D3",
    "Not applicable": "#CED1D3",
    None: "#F7AC43"
  };
  return resultColorsDict[resultCategory];
}
function getUniqueModifierTypeCategories(modifiers) {
  let modifierCategories = [];
  modifiers.forEach(modifier => {
    let category = getModifierTypeCategory(modifier);
    !modifierCategories.includes(category) && modifierCategories.push(category);
  });
  return modifierCategories;
}
function formatSubtechniqueLink(substep) {
  return substep.Subtechnique.Subtechnique_Id.replace('.', '/');
}
function isFillWhite(resultCategory) {
  return getNoiseResultCategoryColor(resultCategory) === "#FFFFFF";
}
function exportJSON(jsonData, filename) {
  // credit: https://www.bitdegree.org/learn/javascript-download
  let text = JSON.stringify(jsonData, null, 2);
  let element = document.createElement('a');
  element.setAttribute('href', 'data:application/json;charset=utf-8,' + encodeURIComponent(text));
  element.setAttribute('download', filename);
  element.style.display = 'none';
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
}
function exportCSV(csvData, filename) {
  const blob = new Blob([csvData], {
    type: 'text/csv;charset=utf-8;'
  });
  const url = URL.createObjectURL(blob);
  const element = document.createElement('a');
  element.setAttribute('href', url);
  element.setAttribute('download', filename);
  element.style.display = 'none';
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);

  // Release the object URL after the download
  URL.revokeObjectURL(url);
}

const _hoisted_1$g = { class: "mb-5" };
const _hoisted_2$g = { class: "mt-3" };
const _hoisted_3$g = {
  key: 0,
  class: "mt-3"
};
const _hoisted_4$e = /*#__PURE__*/createElementVNode("div", null, "Modifiers", -1 /* HOISTED */);


const _sfc_main$i = {
  __name: 'GroupCohortFilters',
  props: {
  resultCategoryFilters: Array,
  modifierFilters: Array,
  resultType: String,
  graphDataTypeSelected: String
},
  emits: ["filterByResultCategory", "filterByModifier"],
  setup(__props, { emit: __emit }) {



const emit = __emit;

function onResultCategoryFilterUpdate(event, resultCategoryName) {
  emit("filterByResultCategory", event, resultCategoryName);
}

function onModifierFilterUpdate(event, modifierName) {
  emit("filterByModifier", event, modifierName);
}


return (_ctx, _cache) => {
  const _component_v_icon = resolveComponent("v-icon");
  const _component_v_checkbox = resolveComponent("v-checkbox");
  const _component_v_switch = resolveComponent("v-switch");

  return (openBlock(), createElementBlock("div", _hoisted_1$g, [
    createElementVNode("div", _hoisted_2$g, [
      createElementVNode("div", null, toDisplayString(__props.resultType) + " Result Categories", 1 /* TEXT */),
      (openBlock(true), createElementBlock(Fragment, null, renderList(__props.resultCategoryFilters, (rc) => {
        return (openBlock(), createBlock(_component_v_checkbox, {
          key: rc.id,
          color: "primary",
          class: "mk-checkbox",
          density: "compact",
          "data-id": "cohortmetrics.filters.resultcategoryfilter",
          "hide-details": "",
          "onUpdate:modelValue": [$event => (onResultCategoryFilterUpdate($event, rc.label)), $event => ((rc.selected) = $event)],
          modelValue: rc.selected
        }, {
          label: withCtx(() => [
            (__props.graphDataTypeSelected !== 'Noise' || !unref(isFillWhite)(rc.label))
              ? (openBlock(), createBlock(_component_v_icon, {
                  key: 0,
                  size: "20px",
                  color: __props.graphDataTypeSelected === 'Noise' ? unref(getNoiseResultCategoryColor)(rc.label) : unref(getResultCategoryColor)(rc.label)
                }, {
                  default: withCtx(() => [
                    createTextVNode("mdi-square-rounded")
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["color"]))
              : (openBlock(), createBlock(_component_v_icon, {
                  key: 1,
                  size: "20px",
                  color: "#25333C"
                }, {
                  default: withCtx(() => [
                    createTextVNode("mdi-square-rounded-outline")
                  ]),
                  _: 1 /* STABLE */
                })),
            createTextVNode(" " + toDisplayString(rc.label), 1 /* TEXT */)
          ]),
          _: 2 /* DYNAMIC */
        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onUpdate:modelValue", "modelValue"]))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    (__props.modifierFilters.length)
      ? (openBlock(), createElementBlock("div", _hoisted_3$g, [
          _hoisted_4$e,
          (openBlock(true), createElementBlock(Fragment, null, renderList(__props.modifierFilters, (modifier) => {
            return (openBlock(), createBlock(_component_v_switch, {
              class: "modifier-switch",
              "hide-details": "",
              density: "compact",
              key: modifier.label,
              label: modifier.label,
              color: "primary",
              modelValue: modifier.selected,
              "onUpdate:modelValue": [$event => ((modifier.selected) = $event), $event => (onModifierFilterUpdate($event, modifier.label))]
            }, null, 8 /* PROPS */, ["label", "modelValue", "onUpdate:modelValue"]))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : createCommentVNode("v-if", true)
  ]))
}
}

};
var GroupCohortFilters = /*#__PURE__*/_export_sfc(_sfc_main$i, [['__file',"/home/runner/work/evals-website/evals-website/packages/enterprise-results/src/group-cohort-metrics/GroupCohortFilters.vue"]]);

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') {
    return;
  }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$d = "";
styleInject(css_248z$d);

const _hoisted_1$f = { class: "mk-text--grey60" };
const _hoisted_2$f = { class: "mk-text--h3" };
const _hoisted_3$f = { class: "mk-text--grey60" };
const _hoisted_4$d = { class: "mk-text--h3" };
const _hoisted_5$d = { class: "mk-text--grey60" };
const _hoisted_6$c = { class: "mk-text--h3" };
const _hoisted_7$c = { class: "mk-text--grey60" };
const _hoisted_8$b = { class: "mk-text--h3" };

  
const _sfc_main$h = {
  __name: 'GroupCohortGraphHeaders',
  props: {
    filteredTacticResultCategoryFrequencyData: Array,
    resultCategoryFilters: Array,
    graphDisplayTypeSelected: String,
    graphDataTypeSelected: String
  },
  setup(__props) {

  const route = useRoute();

  const props = __props;

  const firstRowHeaders = computed(() => {
    let headers = [];
    if(props.filteredTacticResultCategoryFrequencyData.length){
      const amountSteps = getAmountSteps();
      headers.push({
        title: "steps",
        value: amountSteps
      });
      const amountSubsteps = getAmountSubsteps();
      headers.push({
        title: "substeps",
        value: amountSubsteps
      });
      if(props.graphDataTypeSelected !== "Noise"){
        const amountTactics = route.query.tactic_name ? 1 : props.filteredTacticResultCategoryFrequencyData.length;
        headers.push({
          title: `MITRE ATT&CK Tactic${amountTactics > 1 ? 's' : ''}`,
          value: amountTactics
        });
        const amountTechniques = getAmountTechniques();
        headers.push({
          title: "MITRE ATT&CK Techniques",
          value: amountTechniques
        });
      }
      else {
        const amountTypesOfUserActivity = props.filteredTacticResultCategoryFrequencyData.length;
        headers.push({
          title: "Types of User Activity",
          value: amountTypesOfUserActivity
        });
      }

    }
    return headers;
  });

  const secondRowHeaders = computed(() => {
    if(props.filteredTacticResultCategoryFrequencyData.length){
      const detectionGraphDataTypes = ["Detections", "Protections"];
      if(isTechniqueChart.value) {
        return getSecondRowHeadersForTechniqueChart();
      }
      else if(props.graphDisplayTypeSelected === 'Frequency' && detectionGraphDataTypes.includes(props.graphDataTypeSelected)) {
        return getSecondRowHeadersForWholeDetectionChart();
      }
      else if(props.graphDisplayTypeSelected === "Percent" && detectionGraphDataTypes.includes(props.graphDataTypeSelected)) {
        return getSecondRowHeadersForPercentDetectionChart();
      }
      else if(props.graphDataTypeSelected === "Modifiers") {
        return getSecondRowHeadersForModifiersChart();
      }
      else if(props.graphDataTypeSelected === "Noise" && props.graphDisplayTypeSelected === 'Frequency') {
        return getSecondRowHeadersForWholeDetectionNoiseChart();
      }
      else if(props.graphDataTypeSelected === "Noise" && props.graphDisplayTypeSelected === 'Percent') {
        return getSecondRowHeadersForPercentNoiseChart();
      }
    }
  });

  function getSecondRowHeadersForPercentNoiseChart() {
    let headers = [];
    let userActivityWithMostPercentFPs;
    let amountOfMostPercentFPs = 0;
    let userActivityWithLeastPercentFPs;
    let amountOfLeastPercentFPs = 100;
    let userActivityWithMostPercentTNs;
    let amountOfMostPercentTNs = 0;
    let userActivityWithLeastPercentTNs;
    let amountOfLeastPercentTNs = 10000;
    props.filteredTacticResultCategoryFrequencyData.forEach(userActivityType => {
      const fpResultCategory = userActivityType.result_categories.find(rc => rc.result_category_name === "Reported");
      const tnResultCategory = userActivityType.result_categories.find(rc => rc.result_category_name === "Not reported");
      if(fpResultCategory && tnResultCategory){
        const totalResultCategoryResults = userActivityType.result_categories.reduce(
          (acc, rc) => acc + rc.results.length, 0
        );
        const percentFPResults = fpResultCategory.results.length / totalResultCategoryResults * 100;
        const percentTNResults = tnResultCategory.results.length / totalResultCategoryResults * 100;
        if(percentFPResults > amountOfMostPercentFPs) {
          userActivityWithMostPercentFPs = userActivityType;
          amountOfMostPercentFPs = percentFPResults;
        }
        if(percentFPResults < amountOfLeastPercentFPs) {
          userActivityWithLeastPercentFPs = userActivityType;
          amountOfLeastPercentFPs = percentFPResults;
        }
        if(percentTNResults > amountOfMostPercentTNs) {
          userActivityWithMostPercentTNs = userActivityType;
          amountOfMostPercentTNs = percentTNResults;
        }
        if(percentTNResults < amountOfLeastPercentTNs) {
          userActivityWithLeastPercentTNs = userActivityType;
          amountOfLeastPercentTNs = percentTNResults;
        }
      }
    });
    headers.push({
      title: `Most percentage of user activity reported as malicious/suspicious (Reported)`,
      value: `${userActivityWithMostPercentFPs?.name} (${Math.round(amountOfMostPercentFPs * 100) / 100}%)`
    },
    {
      title: `Least percentage of user activity reported as malicious/suspicious (Reported)`,
      value: `${userActivityWithLeastPercentFPs?.name} (${Math.round(amountOfLeastPercentFPs * 100) / 100}%)`
    },
    {
      title: `Most percentage of user activity identified as benign (Not Reported)`,
      value: `${userActivityWithMostPercentTNs?.name} (${Math.round(amountOfMostPercentTNs * 100) / 100}%)`
    },
    {
      title: `Least percentage of user activity identified as benign (Not Reported)`,
      value: `${userActivityWithLeastPercentTNs?.name} (${Math.round(amountOfLeastPercentTNs * 100) / 100}%)`
    });
    return headers;
  }

  function getSecondRowHeadersForWholeDetectionNoiseChart() {
    let headers = [];
    let userActivityWithMostFPs;
    let amountOfMostFPs = 0;
    let userActivityWithLeastFPs;
    let amountOfLeastFPs = 10000;
    let userActivityWithMostTNs;
    let amountOfMostTNs = 0;
    let userActivityWithLeastTNs;
    let amountOfLeastTNs = 10000;
    props.filteredTacticResultCategoryFrequencyData.forEach(userActivityType => {
      const fpResultCategory = userActivityType.result_categories.find(rc => rc.result_category_name === "Reported");
      const tnResultCategory = userActivityType.result_categories.find(rc => rc.result_category_name === "Not reported" || rc.result_category_name === "Not Reported");
      if(fpResultCategory && tnResultCategory){
        let amountOfResultsWithFPs = fpResultCategory.results.length;
        let amountOfResultsWithTNs = tnResultCategory.results.length;
        if(amountOfResultsWithFPs > amountOfMostFPs) {
          userActivityWithMostFPs = userActivityType;
          amountOfMostFPs = amountOfResultsWithFPs;
        }
        if(amountOfResultsWithFPs < amountOfLeastFPs) {
          userActivityWithLeastFPs = userActivityType;
          amountOfLeastFPs = amountOfResultsWithFPs;
        }
        if(amountOfResultsWithTNs > amountOfMostTNs) {
          userActivityWithMostTNs = userActivityType;
          amountOfMostTNs = amountOfResultsWithTNs;
        }
        if(amountOfResultsWithTNs < amountOfLeastTNs) {
          userActivityWithLeastTNs = userActivityType;
          amountOfLeastTNs = amountOfResultsWithTNs;
        }
      }
    });
    headers.push({
      title: `Most user activity reported as malicious/suspicious (Reported)`,
      value: userActivityWithMostFPs?.name
    },
    {
      title: `Least user activity reported as malicious/suspicious (Reported)`,
      value: userActivityWithLeastFPs?.name
    },
    {
      title: `Most user activity identified as benign (Not Reported)`,
      value: userActivityWithMostTNs?.name
    },
    {
      title: `Least user activity identified as benign (Not Reported)`,
      value: userActivityWithLeastTNs?.name
    });
    return headers;
  }

  const isTechniqueChart = computed(() => !!route.query.tactic_name);

  function getPercentResults(tactic, techniqueResults, technique) {
    const totalTechniqueResults = tactic.result_categories.flatMap(rc => rc.results.map(r => r.technique_name === technique));
    const percentTechniqueResults = Math.round((techniqueResults.length / totalTechniqueResults.length * 100) * 100) / 100;
    return percentTechniqueResults;
  }

  function getSecondRowHeadersForTechniqueChart() {
    const headers = [];
    const tactic = props.filteredTacticResultCategoryFrequencyData.find(t => t.name === route.query.tactic_name);
    let techniques = tactic.result_categories.flatMap(rc => rc.results.map(r => r.technique_name));
    techniques = [...new Set(techniques)];

    props.resultCategoryFilters.forEach((rc) => {
      let techniqueWithMostOfRc;
      let amountOfMostRcs = 0;
      const resultCategory = tactic.result_categories.find(resultCategory => resultCategory.result_category_name === rc.label);
      if(resultCategory){
        techniques.forEach(technique => {
          const techniqueResults = resultCategory.results.filter(r => r.technique_name === technique);
          let amountOfResults = props.graphDisplayTypeSelected === "Percent" ?
            getPercentResults(tactic, techniqueResults, technique) : techniqueResults.length;
          if(amountOfResults > amountOfMostRcs) {
            techniqueWithMostOfRc = technique;
            amountOfMostRcs = amountOfResults;
          }
        });
        if(amountOfMostRcs) {
          headers.push({
            title: `Most ${rc.label} results`,
            value: props.graphDisplayTypeSelected === "Frequency" ? techniqueWithMostOfRc : `${techniqueWithMostOfRc} (${amountOfMostRcs}%)`,
            rcName: rc.label
          });
        }
      }
    });
    return headers;
  }

  function getSecondRowHeadersForModifiersChart() {
    let headers = [];
    let tacticWithMostResultsWithModifiers;
    let amountOfMostResultsWithModifiers = 0;
    let tacticWithLeastResultsWithModifiers;
    let amountOfLeastResultsWithModifiers = 10000;
    props.filteredTacticResultCategoryFrequencyData.forEach(tactic => {
      let amountOfResultsWithModifiers = 0;
      tactic.result_categories.forEach(rc => {
        amountOfResultsWithModifiers += rc.results.filter(result => result.modifiers.length).length;
      });
      if(amountOfResultsWithModifiers > amountOfMostResultsWithModifiers) {
          tacticWithMostResultsWithModifiers = tactic;
          amountOfMostResultsWithModifiers = amountOfResultsWithModifiers;
      }
      if(amountOfResultsWithModifiers < amountOfLeastResultsWithModifiers) {
        tacticWithLeastResultsWithModifiers = tactic;
        amountOfLeastResultsWithModifiers = amountOfResultsWithModifiers;
      }
    });
    headers.push({
      title: `Tactic with most modifiers`,
      value: tacticWithMostResultsWithModifiers?.name
    },
    {
      title: `Tactic with least modifiers`,
      value: tacticWithLeastResultsWithModifiers?.name
    });
    return headers;
  }

  function getSecondRowHeadersForPercentDetectionChart() {
    let headers = [];
    props.resultCategoryFilters.forEach((rc) => {
      let tacticWithHighestPercentageOfRc;
      let highestPercentageOfRc = 0;
      props.filteredTacticResultCategoryFrequencyData.forEach(tactic => {
        const amountRcResults = tactic.result_categories.find(
          tactic_rc => tactic_rc.result_category_name === rc.label
        )?.results.length;
        const totalAmountTacticResults = tactic.result_categories.reduce(
          (acc, rc) => acc + rc.results.length, 0
        );
        const percentageOfRcResults = amountRcResults / totalAmountTacticResults * 100;
        if(percentageOfRcResults > highestPercentageOfRc) {
          highestPercentageOfRc = percentageOfRcResults;
          tacticWithHighestPercentageOfRc = tactic.name;
        }
      });
      if(highestPercentageOfRc) {
        headers.push({
          title: `Highest percentage of ${rc.label} results`,
          value: `${tacticWithHighestPercentageOfRc} (${Math.round(highestPercentageOfRc * 100) / 100}%)`,
          rcName: rc.label
        });
      }
    });
    return headers;
  }

  function getSecondRowHeadersForWholeDetectionChart() {
    const headers = [];
    props.resultCategoryFilters.forEach((rc) => {
      let tacticWithMostOfRc;
      let amountOfMostRcs = 0;
      props.filteredTacticResultCategoryFrequencyData.forEach(tactic => {
        const amountRcResults = tactic.result_categories.find(
          tactic_rc => tactic_rc.result_category_name === rc.label
        )?.results.length;
        if(amountRcResults && amountRcResults > amountOfMostRcs) {
          amountOfMostRcs = amountRcResults;
          tacticWithMostOfRc = tactic.name;
        }
      });
      if(amountOfMostRcs) {
        headers.push({
          title: `Most ${rc.label} results`,
          value: tacticWithMostOfRc,
          rcName: rc.label
        });
      }
    });
    return headers;
  }

  function getAmountSteps() {
    let steps;
    if(isTechniqueChart.value) {
      const tactic = props.filteredTacticResultCategoryFrequencyData.find(t => t.name === route.query.tactic_name);
      steps = tactic.result_categories.flatMap(rc => rc.results.map(r => r.step_id));
    }
    else {
      steps = props.filteredTacticResultCategoryFrequencyData.flatMap(tactic => {
        return tactic.result_categories.flatMap(rc => rc.results.map(r => r.step_id))
      });
    }
    return [...new Set(steps)].length;
  }

  function getAmountSubsteps() {
    let substeps;
    if(isTechniqueChart.value) {
      const tactic = props.filteredTacticResultCategoryFrequencyData.find(t => t.name === route.query.tactic_name);
      substeps = tactic.result_categories.flatMap(rc => rc.results.map(r => r.substep_id));
    }
    else {
      substeps = props.filteredTacticResultCategoryFrequencyData.flatMap(tactic => {
        return tactic.result_categories.flatMap(rc => rc.results.map(r => r.substep_id))
      });
    }
    return [...new Set(substeps)].length;
  }

  function getAmountTechniques() {
    let techniques;
    if(isTechniqueChart.value) {
      const tactic = props.filteredTacticResultCategoryFrequencyData.find(t => t.name === route.query.tactic_name);
      techniques = tactic.result_categories.flatMap(rc => rc.results.map(r => r.technique_id));
    }
    else {
      techniques = props.filteredTacticResultCategoryFrequencyData.flatMap(tactic => {
        return tactic.result_categories.flatMap(rc => rc.results.map(r => r.technique_id))
      });
    }
    return [...new Set(techniques)].length;
  }


return (_ctx, _cache) => {
  const _component_v_col = resolveComponent("v-col");
  const _component_v_row = resolveComponent("v-row");
  const _component_v_icon = resolveComponent("v-icon");

  return (openBlock(), createElementBlock("div", null, [
    (!_ctx.$vuetify.display.smAndDown)
      ? (openBlock(), createBlock(_component_v_row, {
          key: 0,
          class: "mx-1"
        }, {
          default: withCtx(() => [
            (openBlock(true), createElementBlock(Fragment, null, renderList(firstRowHeaders.value, (header) => {
              return (openBlock(), createBlock(_component_v_col, {
                key: header.title,
                class: "group-cohort-header mt-4"
              }, {
                default: withCtx(() => [
                  createElementVNode("div", _hoisted_1$f, toDisplayString(header.title.toUpperCase()), 1 /* TEXT */),
                  createElementVNode("div", _hoisted_2$f, toDisplayString(`${header.value} ${header.title}`), 1 /* TEXT */)
                ]),
                _: 2 /* DYNAMIC */
              }, 1024 /* DYNAMIC_SLOTS */))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _: 1 /* STABLE */
        }))
      : (openBlock(), createBlock(_component_v_row, {
          key: 1,
          class: "mx-1"
        }, {
          default: withCtx(() => [
            (openBlock(true), createElementBlock(Fragment, null, renderList(firstRowHeaders.value, (header) => {
              return (openBlock(), createBlock(_component_v_col, {
                key: header.title,
                class: "group-cohort-header mt-4",
                cols: "12"
              }, {
                default: withCtx(() => [
                  createElementVNode("div", _hoisted_3$f, toDisplayString(header.title.toUpperCase()), 1 /* TEXT */),
                  createElementVNode("div", _hoisted_4$d, toDisplayString(`${header.value} ${header.title}`), 1 /* TEXT */)
                ]),
                _: 2 /* DYNAMIC */
              }, 1024 /* DYNAMIC_SLOTS */))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _: 1 /* STABLE */
        })),
    (!_ctx.$vuetify.display.smAndDown)
      ? (openBlock(), createBlock(_component_v_row, {
          key: 2,
          class: "mx-1"
        }, {
          default: withCtx(() => [
            (openBlock(true), createElementBlock(Fragment, null, renderList(secondRowHeaders.value, (header) => {
              return (openBlock(), createBlock(_component_v_col, {
                key: header.title,
                class: "group-cohort-header"
              }, {
                default: withCtx(() => [
                  createElementVNode("div", _hoisted_5$d, [
                    (
              (__props.graphDataTypeSelected === 'Detections' || __props.graphDataTypeSelected === 'Protections') &&
              (__props.graphDataTypeSelected !== 'Noise' || !unref(isFillWhite)(header.rcName))
            )
                      ? (openBlock(), createBlock(_component_v_icon, {
                          key: 0,
                          size: "20px",
                          color: __props.graphDataTypeSelected === 'Noise' ? unref(getNoiseResultCategoryColor)(header.rcName) : unref(getResultCategoryColor)(header.rcName)
                        }, {
                          default: withCtx(() => [
                            createTextVNode("mdi-square-rounded")
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["color"]))
                      : (__props.graphDataTypeSelected === 'Noise' && unref(isFillWhite)(header.rcName))
                        ? (openBlock(), createBlock(_component_v_icon, {
                            key: 1,
                            size: "20px",
                            color: "#25333C"
                          }, {
                            default: withCtx(() => [
                              createTextVNode("mdi-square-rounded-outline")
                            ]),
                            _: 1 /* STABLE */
                          }))
                        : createCommentVNode("v-if", true),
                    createTextVNode(" " + toDisplayString(header.title.toUpperCase()), 1 /* TEXT */)
                  ]),
                  createElementVNode("div", _hoisted_6$c, toDisplayString(header.value), 1 /* TEXT */)
                ]),
                _: 2 /* DYNAMIC */
              }, 1024 /* DYNAMIC_SLOTS */))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _: 1 /* STABLE */
        }))
      : (openBlock(), createBlock(_component_v_row, {
          key: 3,
          class: "mx-1"
        }, {
          default: withCtx(() => [
            (openBlock(true), createElementBlock(Fragment, null, renderList(secondRowHeaders.value, (header) => {
              return (openBlock(), createBlock(_component_v_col, {
                key: header.title,
                class: "group-cohort-header",
                cols: "12"
              }, {
                default: withCtx(() => [
                  createElementVNode("div", _hoisted_7$c, [
                    (__props.graphDataTypeSelected === 'Detections' || __props.graphDataTypeSelected === 'Protections')
                      ? (openBlock(), createBlock(_component_v_icon, {
                          key: 0,
                          size: "20px",
                          class: "mr-1",
                          color: unref(getResultCategoryColor)(header.rcName)
                        }, {
                          default: withCtx(() => [
                            createTextVNode("mdi-square-rounded ")
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["color"]))
                      : createCommentVNode("v-if", true),
                    createTextVNode(" " + toDisplayString(header.title.toUpperCase()), 1 /* TEXT */)
                  ]),
                  createElementVNode("div", _hoisted_8$b, toDisplayString(header.value), 1 /* TEXT */)
                ]),
                _: 2 /* DYNAMIC */
              }, 1024 /* DYNAMIC_SLOTS */))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _: 1 /* STABLE */
        }))
  ]))
}
}

};
var GroupCohortGraphHeaders = /*#__PURE__*/_export_sfc(_sfc_main$h, [['__file',"/home/runner/work/evals-website/evals-website/packages/enterprise-results/src/group-cohort-metrics/GroupCohortGraphHeaders.vue"]]);

var css_248z$c = "";
styleInject(css_248z$c);

const _hoisted_1$e = /*#__PURE__*/createElementVNode("div", null, "File Format", -1 /* HOISTED */);
const _hoisted_2$e = {
  key: 2,
  class: "d-flex"
};
const _hoisted_3$e = { class: "mk-text--body" };
const _hoisted_4$c = /*#__PURE__*/createElementVNode("b", null, "File Format", -1 /* HOISTED */);
const _hoisted_5$c = { class: "mk-text--body" };

  
const _sfc_main$g = {
  __name: 'GroupCohortGraphNavigation',
  props: {
    filteredTacticResultCategoryFrequencyData: Array,
    graphDataTypeSelected: String,
    graphDisplayTypeSelected: String,
    graphDisplayTypes: Array,
    selectedResultType: Object,
    graphTypeButtons: Array,
    selectedEvaluation: Object
  },
  emits: ["selectGraphDataType", "selectGraphDisplayType"],
  setup(__props, { emit: __emit }) {

  const emit = __emit;

  const route = useRoute();

  const globalProperties = inject('globalProperties');

  const props = __props;

  function downloadJsonExport() {
    globalProperties.$api
    .get(`/export-cohort/?adversary=${props.selectedEvaluation.name}`)
    .then(response => {
      const jsonData = response.data[0];
      exportJSON(jsonData, `${props.selectedEvaluation.name}_cohort_results.json`);
    });
  }

  function downloadCsvExport() {
    globalProperties.$api
    .get(`/export-cohort/?adversary=${props.selectedEvaluation.name}`)
    .then(response => {
      const jsonData = response.data[0];
      const preConfig = jsonData.pre_config;
      const postConfig = jsonData.post_config;
      const preConfigCsv = jsonToCsv(preConfig);
      const postConfigCsv = jsonToCsv(postConfig);
      exportCSV(preConfigCsv, `${props.selectedEvaluation.name}_cohort_results_pre_config.csv`);
      exportCSV(postConfigCsv, `${props.selectedEvaluation.name}_cohort_results_post_config.csv`);
    });
  }

  function jsonToCsv(jsonData) {
    // Extract the keys (headers) from the first object in the array
    const headers = Object.keys(jsonData[0]).filter(h => h !== "Step_Description");

    // Map each object to a CSV row
    const csvRows = jsonData.map(obj => {
      return headers.map(header => {
        const value = obj[header];
        // Handle arrays by joining them into a string
        if (Array.isArray(value)) {
          return `"${value.join(', ')}"`;
        }
        // Handle null or undefined values
        return value !== null && value !== undefined ? `"${value}"` : '""';
      }).join(',');
    });

    // Combine headers and rows into a single CSV string
    const csvString = [headers.join(','), ...csvRows].join('\n');
    return csvString;
  }


return (_ctx, _cache) => {
  const _component_v_divider = resolveComponent("v-divider");
  const _component_v_btn = resolveComponent("v-btn");
  const _component_v_icon = resolveComponent("v-icon");
  const _component_v_list_item_title = resolveComponent("v-list-item-title");
  const _component_v_list_item = resolveComponent("v-list-item");
  const _component_v_list = resolveComponent("v-list");
  const _component_v_menu = resolveComponent("v-menu");
  const _component_v_col = resolveComponent("v-col");
  const _component_v_row = resolveComponent("v-row");

  return (openBlock(), createBlock(_component_v_row, {
    class: normalizeClass({'group-cohort-graph-navbar': true, 'mr-0': _ctx.$vuetify.display.smAndDown})
  }, {
    default: withCtx(() => [
      createVNode(_component_v_col, { class: "text-left" }, {
        default: withCtx(() => [
          (_ctx.$vuetify.display.smAndDown)
            ? (openBlock(), createBlock(_component_v_divider, {
                key: 0,
                class: "mobile-divider"
              }))
            : createCommentVNode("v-if", true),
          (openBlock(true), createElementBlock(Fragment, null, renderList(__props.graphTypeButtons, (btn) => {
            return (openBlock(), createBlock(_component_v_btn, {
              class: normalizeClass(["mr-2", {'graph-type-button': btn !== __props.graphDataTypeSelected}]),
              key: btn,
              onClick: $event => (emit('selectGraphDataType', btn)),
              flat: ""
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(btn), 1 /* TEXT */)
              ]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick", "class"]))
          }), 128 /* KEYED_FRAGMENT */)),
          createVNode(_component_v_menu, { "open-on-hover": "" }, {
            activator: withCtx(({ props }) => [
              (_ctx.$vuetify.display.smAndDown)
                ? (openBlock(), createBlock(_component_v_btn, {
                    key: 0,
                    flat: "",
                    color: "white"
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_v_icon, null, {
                        default: withCtx(() => [
                          createTextVNode("mdi-tray-arrow-down")
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  }))
                : createCommentVNode("v-if", true)
            ]),
            default: withCtx(() => [
              createVNode(_component_v_list, null, {
                default: withCtx(() => [
                  _hoisted_1$e,
                  createVNode(_component_v_list_item, null, {
                    default: withCtx(() => [
                      createVNode(_component_v_list_item, null, {
                        default: withCtx(() => [
                          createVNode(_component_v_list_item_title, { onClick: downloadJsonExport }, {
                            default: withCtx(() => [
                              createTextVNode(".json")
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      }),
                      createVNode(_component_v_list_item, null, {
                        default: withCtx(() => [
                          createVNode(_component_v_list_item_title, { onClick: downloadCsvExport }, {
                            default: withCtx(() => [
                              createTextVNode(".csv")
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }),
          (_ctx.$vuetify.display.smAndDown)
            ? (openBlock(), createBlock(_component_v_divider, {
                key: 1,
                class: "mobile-divider"
              }))
            : createCommentVNode("v-if", true),
          (_ctx.$vuetify.display.smAndDown)
            ? (openBlock(), createElementBlock("div", _hoisted_2$e, [
                createVNode(_component_v_menu, null, {
                  activator: withCtx(({ props }) => [
                    createVNode(_component_v_btn, mergeProps({
                      flat: "",
                      color: "white"
                    }, props), {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(__props.graphDisplayTypeSelected) + " ", 1 /* TEXT */),
                        createVNode(_component_v_icon, null, {
                          default: withCtx(() => [
                            createTextVNode("mdi-menu-down")
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */)
                  ]),
                  default: withCtx(() => [
                    createVNode(_component_v_list, { slim: "" }, {
                      default: withCtx(() => [
                        (openBlock(true), createElementBlock(Fragment, null, renderList(__props.graphDisplayTypes, (item) => {
                          return (openBlock(), createBlock(_component_v_list_item, {
                            key: item,
                            value: item,
                            density: "compact",
                            slim: "",
                            onClick: $event => (emit('selectGraphDisplayType', item)),
                            class: normalizeClass({'list-item--selected': __props.graphDisplayTypeSelected === item})
                          }, {
                            default: withCtx(() => [
                              createElementVNode("span", _hoisted_3$e, toDisplayString(item), 1 /* TEXT */)
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value", "onClick", "class"]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                }),
                createVNode(_component_v_btn, {
                  flat: "",
                  color: "white",
                  class: "by-mitre-attack-btn"
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(__props.graphDataTypeSelected === 'Noise' ? "By User Activity Type" :
            unref(route).query.tactic_name ? 'By MITRE ATT&CK Technique' :
            "By MITRE ATT&CK Tactic"), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                })
              ]))
            : (openBlock(), createElementBlock(Fragment, { key: 3 }, [
                createVNode(_component_v_menu, { "open-on-hover": "" }, {
                  activator: withCtx(({ props }) => [
                    createVNode(_component_v_btn, mergeProps({
                      flat: "",
                      color: "white",
                      class: "float-right"
                    }, props), {
                      default: withCtx(() => [
                        createVNode(_component_v_icon, null, {
                          default: withCtx(() => [
                            createTextVNode("mdi-tray-arrow-down")
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */)
                  ]),
                  default: withCtx(() => [
                    createVNode(_component_v_list, null, {
                      default: withCtx(() => [
                        createVNode(_component_v_list_item, null, {
                          default: withCtx(() => [
                            createVNode(_component_v_list_item_title, null, {
                              default: withCtx(() => [
                                _hoisted_4$c
                              ]),
                              _: 1 /* STABLE */
                            })
                          ]),
                          _: 1 /* STABLE */
                        }),
                        createVNode(_component_v_list_item, { value: "json" }, {
                          default: withCtx(() => [
                            createVNode(_component_v_list_item_title, { onClick: downloadJsonExport }, {
                              default: withCtx(() => [
                                createTextVNode(".json")
                              ]),
                              _: 1 /* STABLE */
                            })
                          ]),
                          _: 1 /* STABLE */
                        }),
                        createVNode(_component_v_list_item, { value: "csv" }, {
                          default: withCtx(() => [
                            createVNode(_component_v_list_item_title, { onClick: downloadCsvExport }, {
                              default: withCtx(() => [
                                createTextVNode(".csv")
                              ]),
                              _: 1 /* STABLE */
                            })
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                }),
                createVNode(_component_v_btn, {
                  flat: "",
                  color: "white",
                  class: "float-right by-mitre-attack-btn"
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(__props.graphDataTypeSelected === 'Noise' ? "By User Activity Type" :
            unref(route).query.tactic_name ? 'By MITRE ATT&CK Technique' :
            "By MITRE ATT&CK Tactic"), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }),
                createVNode(_component_v_menu, null, {
                  activator: withCtx(({ props }) => [
                    createVNode(_component_v_btn, mergeProps({
                      flat: "",
                      color: "white",
                      class: "float-right"
                    }, props), {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(__props.graphDisplayTypeSelected) + " ", 1 /* TEXT */),
                        createVNode(_component_v_icon, null, {
                          default: withCtx(() => [
                            createTextVNode("mdi-menu-down")
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */)
                  ]),
                  default: withCtx(() => [
                    createVNode(_component_v_list, { slim: "" }, {
                      default: withCtx(() => [
                        (openBlock(true), createElementBlock(Fragment, null, renderList(__props.graphDisplayTypes, (item) => {
                          return (openBlock(), createBlock(_component_v_list_item, {
                            key: item,
                            value: item,
                            density: "compact",
                            slim: "",
                            onClick: $event => (emit('selectGraphDisplayType', item)),
                            class: normalizeClass({'list-item--selected': __props.graphDisplayTypeSelected === item})
                          }, {
                            default: withCtx(() => [
                              createElementVNode("span", _hoisted_5$c, toDisplayString(item), 1 /* TEXT */)
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value", "onClick", "class"]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                })
              ], 64 /* STABLE_FRAGMENT */)),
          (_ctx.$vuetify.display.smAndDown)
            ? (openBlock(), createBlock(_component_v_divider, {
                key: 4,
                class: "mobile-divider"
              }))
            : createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["class"]))
}
}

};
var GroupCohortGraphNavigation = /*#__PURE__*/_export_sfc(_sfc_main$g, [['__file',"/home/runner/work/evals-website/evals-website/packages/enterprise-results/src/group-cohort-metrics/GroupCohortGraphNavigation.vue"]]);

const _hoisted_1$d = /*#__PURE__*/createElementVNode("span", { class: "mk-text--h3" }, "What is noise?", -1 /* HOISTED */);
const _hoisted_2$d = /*#__PURE__*/createElementVNode("p", null, " Benign activity (outside the emulation plan) was executed during the evaluation while malicious/suspicious activity was executed by the Red Team. ", -1 /* HOISTED */);
const _hoisted_3$d = /*#__PURE__*/createElementVNode("span", { class: "mk-text--grey-90" }, " Reported ", -1 /* HOISTED */);
const _hoisted_4$b = /*#__PURE__*/createElementVNode("span", { class: "mk-text--grey-90 mk-text--font-weight-400" }, " When a participant incorrectly alerts on or blocks benign activity as malicious or suspicious (via a detection or automated protection), resulting in a false positive report ", -1 /* HOISTED */);
const _hoisted_5$b = /*#__PURE__*/createElementVNode("span", { class: "mk-text--grey-90" }, " Not reported ", -1 /* HOISTED */);
const _hoisted_6$b = /*#__PURE__*/createElementVNode("span", { class: "mk-text--grey-90 mk-text--font-weight-400" }, " When a participant correctly determines benign activity as non-malicious activity, resulting in a true negative prediction ", -1 /* HOISTED */);
const _hoisted_7$b = /*#__PURE__*/createElementVNode("span", { class: "mk-text--grey-90" }, " N/A ", -1 /* HOISTED */);
const _hoisted_8$a = /*#__PURE__*/createElementVNode("span", { class: "mk-text--grey-90 mk-text--font-weight-400" }, " Noise step was not completed and therefore could not be evaluated ", -1 /* HOISTED */);

const _sfc_main$f = {
  __name: 'NoiseExplanationTooltip',
  setup(__props) {

 
return (_ctx, _cache) => {
  const _component_v_icon = resolveComponent("v-icon");
  const _component_v_col = resolveComponent("v-col");
  const _component_v_row = resolveComponent("v-row");

  return (openBlock(), createElementBlock("span", null, [
    _hoisted_1$d,
    _hoisted_2$d,
    createVNode(_component_v_row, { class: "m-spacing--top-3" }, {
      default: withCtx(() => [
        createVNode(_component_v_col, { cols: "3" }, {
          default: withCtx(() => [
            createVNode(_component_v_icon, {
              color: unref(getNoiseResultCategoryColor)('Reported')
            }, {
              default: withCtx(() => [
                createTextVNode("mdi-square")
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["color"]),
            _hoisted_3$d
          ]),
          _: 1 /* STABLE */
        }),
        createVNode(_component_v_col, null, {
          default: withCtx(() => [
            _hoisted_4$b
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }),
    createVNode(_component_v_row, null, {
      default: withCtx(() => [
        createVNode(_component_v_col, { cols: "3" }, {
          default: withCtx(() => [
            createVNode(_component_v_icon, {
              color: unref(getNoiseResultCategoryColor)('Reported')
            }, {
              default: withCtx(() => [
                createTextVNode("mdi-square-outline")
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["color"]),
            _hoisted_5$b
          ]),
          _: 1 /* STABLE */
        }),
        createVNode(_component_v_col, null, {
          default: withCtx(() => [
            _hoisted_6$b
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }),
    createVNode(_component_v_row, null, {
      default: withCtx(() => [
        createVNode(_component_v_col, { cols: "3" }, {
          default: withCtx(() => [
            createVNode(_component_v_icon, {
              color: unref(getNoiseResultCategoryColor)('N/A')
            }, {
              default: withCtx(() => [
                createTextVNode("mdi-square")
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["color"]),
            _hoisted_7$b
          ]),
          _: 1 /* STABLE */
        }),
        createVNode(_component_v_col, null, {
          default: withCtx(() => [
            _hoisted_8$a
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    })
  ]))
}
}

};
var NoiseExplanationTooltip = /*#__PURE__*/_export_sfc(_sfc_main$f, [['__file',"/home/runner/work/evals-website/evals-website/packages/enterprise-results/src/group-cohort-metrics/NoiseExplanationTooltip.vue"]]);

var css_248z$b = "";
styleInject(css_248z$b);

const _hoisted_1$c = { key: 0 };
const _hoisted_2$c = ["href"];
const _hoisted_3$c = { key: 1 };
const _hoisted_4$a = { key: 0 };
const _hoisted_5$a = /*#__PURE__*/createElementVNode("span", { class: "mk-text--body ml-1" }, " What is protections?", -1 /* HOISTED */);
const _hoisted_6$a = /*#__PURE__*/createElementVNode("span", { class: "mk-text--h3" }, "What is protections?", -1 /* HOISTED */);
const _hoisted_7$a = /*#__PURE__*/createElementVNode("p", null, " Enterprise 2024 brings a new format to the Protections evaluation for ATT&CK Evaluations. ", -1 /* HOISTED */);
const _hoisted_8$9 = /*#__PURE__*/createElementVNode("p", { class: "mt-3" }, [
  /*#__PURE__*/createTextVNode(" In prior rounds, the Protections evaluation reused the same emulation plan as Detections. This year, we introduced discrete micro emulation tests to evaluate protection mechanisms in post-compromised environments against: "),
  /*#__PURE__*/createElementVNode("ol", { class: "ml-6 mt-3" }, [
    /*#__PURE__*/createElementVNode("li", null, "common ransomware behaviors on Windows and Linux"),
    /*#__PURE__*/createElementVNode("li", null, "the DPRK’s targeting of macOS keychains. ")
  ])
], -1 /* HOISTED */);
const _hoisted_9$8 = /*#__PURE__*/createElementVNode("p", { class: "mt-3" }, [
  /*#__PURE__*/createTextVNode(" Each micro emulation ends when either: "),
  /*#__PURE__*/createElementVNode("ol", { class: "ml-6 mt-3" }, [
    /*#__PURE__*/createElementVNode("li", null, "execution of a test procedure is unsuccessful, and collected evidence confirms the solution blocked the behavior under test or"),
    /*#__PURE__*/createElementVNode("li", null, "execution of the micro emulation test is successful")
  ])
], -1 /* HOISTED */);
const _hoisted_10$7 = /*#__PURE__*/createElementVNode("div", { class: "mk-text--body ml-1 mt-1" }, " What is noise?", -1 /* HOISTED */);
const _hoisted_11$7 = { class: "mk-text--grey70" };
const _hoisted_12$7 = {
  key: 0,
  class: "mk-text--grey70"
};
const _hoisted_13$6 = /*#__PURE__*/createElementVNode("div", { id: "chart" }, null, -1 /* HOISTED */);


const _sfc_main$e = {
  __name: 'GroupCohortGraph',
  props: {
  selectedScenarios: Array,
  modifierFilters: Array,
  resultCategoryFilters: Array,
  filteredTacticResultCategoryFrequencyData: Array,
  graphDisplayTypeSelected: String,
  graphDataTypeSelected: String,
  modifiers: Array,
  selectedResultType: Object,
  selectedEvaluation: Object,
  isGraphLoading: Boolean
},
  setup(__props) {

const route = useRoute();
const router = useRouter();

const props = __props;

watch(() => props.filteredTacticResultCategoryFrequencyData, () => {
  if(!props.isGraphLoading){
    loadChart(props.filteredTacticResultCategoryFrequencyData);
  }
});
watch(() => props.graphDisplayTypeSelected, () => loadDataChart());
watch(() => route.query.tactic_name, () => loadDataChart());

const selectedModifierFilters = computed(() => props.modifierFilters.filter(filter => filter.selected));

const selectedScenarioNames = computed(() => {
  return props.selectedScenarios.map(scenario => scenario.name);
});

const isMobile = useDisplay().smAndDown;

const selectedModifierNames = computed(() => {
  const selectedModifiers = props.modifierFilters.filter(m => m.selected);
  return selectedModifiers.map(m => m.label)
});

const selectedResultCategoryFilters = computed(() => {
  return props.resultCategoryFilters.filter(rc => rc.selected);
});

const isTechniqueChart = computed(() => !!route.query.tactic_name);

const tacticTid = computed(() => {
  if(isTechniqueChart.value) {
    return props.filteredTacticResultCategoryFrequencyData.find(tactic => tactic.name === route.query.tactic_name).tid
  }
  return '';
});

const noiseCategoryDescriptions = {
  'Command Line': 'This category includes activities performed through command-line interfaces and scripting interpreters, such as cmd.exe and PowerShell. Command-line operations are integral to system administration tasks, such as configuring settings, transferring files, or managing services. However, due to their versatility and power, these operations often overlap with malicious behaviors used by adversaries to execute payloads, manipulate settings, or move laterally.',
  'Notepad': 'These activities involve using basic text editors like Notepad to create, edit, or manage files. Such actions may include documentation, note-taking, or generating text files. While typically benign and common in a user\'s workflow, creating or modifying files in certain directories may raise suspicion due to associations with file drops, script persistence mechanisms, or simple forms of obfuscation.',
  'RDP (Remote Desktop Protocol)': 'RDP-based activities involve the use of Remote Desktop Protocol to connect to remote hosts. This is a standard practice for administrators performing tasks on remote systems, but it can also mimic attacker behavior for lateral movement or persistence when used in specific contexts or outside of expected hours.',
  'User Execution': 'User Execution involves actions initiated by users that trigger the execution of scripts, files, or applications. These activities are commonplace in daily workflows, such as opening documents, launching software, or interacting with files. However, adversaries often exploit user execution behaviors, using crafted payloads or malicious attachments to gain initial access or execute commands. By simulating benign user execution activities, we aim to introduce noise that tests detection mechanisms for their ability to differentiate legitimate actions from potentially malicious ones.',
  'Browser': 'Web browser activities represent actions such as downloading software, accessing internal tools, or browsing the internet. Administrators and users frequently engage in these actions for legitimate purposes, such as software updates. However, web access and file downloads can also be used by attackers to introduce malicious payloads, access external resources, or pivot from within an organization’s network.'
};

function appendRectanglesToSvg(svg, stackedData, color, y, x, tooltip) {

  const mouseleave = function(d) {
    select("#chart").selectAll("rect").classed("hovered-rect", false);
    tooltip
      .style("opacity", 0);
  };

  const mousemove = function(event) {
    const tooltipWidth = tooltip.node().offsetWidth;
    const tooltipHeight = tooltip.node().offsetHeight;
    const pageWidth = window.innerWidth;
    const pageHeight = window.innerHeight;

    let left = event.pageX + 10;
    let top = event.pageY - window.scrollY + 10;

    if (left + tooltipWidth > pageWidth) {
      left = event.pageX - tooltipWidth - 10;
    }

    if (top + tooltipHeight > pageHeight) {
      top = event.pageY - window.scrollY - tooltipHeight - 10;
    }

    tooltip
      .style("left", left + "px")
      .style("top", top + "px");
  };

  function getModifiersTooltipHTML(tacticData) {
    const modifierLabelsToCount = {};
    selectedModifierFilters.value.forEach(m => {
      modifierLabelsToCount[m.label] = {count: 0}; 
    });
    tacticData.result_categories.forEach(rc => {
      rc.results.forEach(r => {
        r.modifiers.forEach(m => {
          const modifierName = props.modifiers.find(modifier => m === modifier.id).name;
          const modifierCat = getModifierTypeCategory(modifierName);
          if(props.modifierFilters.find(filter => filter.label === modifierCat)?.selected){
            modifierLabelsToCount[modifierCat].count ++;
          }
        });
      });
    });
    let totalModifiers = 0;
    Object.keys(modifierLabelsToCount).forEach(modifier => {
      totalModifiers += modifierLabelsToCount[modifier].count;
    });
    Object.keys(modifierLabelsToCount).forEach(modifier => {
      modifierLabelsToCount[modifier].percentage = ((modifierLabelsToCount[modifier].count / totalModifiers) * 100).toFixed(2);
    });


    let tooltipHTML = `<strong>${tacticData.name} ${!isTechniqueChart ? `(<span>${tacticData.tid}</span>)` : ''}</strong><br/>`;
    tooltipHTML += `<hr style="border: 1px solid #ccc; margin: 5px 0;">`;
    tooltipHTML += `<table style="width: 100%;">`;
    tooltipHTML += `<tr style="color: rgb(158, 164, 168);">
                      <td style="text-align: left;">&nbsp;</td>
                      <td style="text-align: left;">FREQUENCY</td>
                      <td style="text-align: left;">PERCENTAGE</td>
                    </tr>`;
    tooltipHTML += `<tr>
                      <td style="text-align: left;">Modifiers</td>
                      <td style="text-align: left;">${totalModifiers}</td>
                      <td style="text-align: left;">100%</td>
                    </tr>`;

    Object.keys(modifierLabelsToCount).forEach(item => {
      tooltipHTML += `<tr>
                        <td style="text-align: left;">
                          <span class="tooltip-square" style="color:${getModifierColor(item)};">
                          ■</span>
                          ${item}
                        </td>
                        <td style="text-align: left;">${modifierLabelsToCount[item].count}</td>
                        <td style="text-align: left;">${modifierLabelsToCount[item].percentage}%</td>
                      </tr>`;
    });
    return tooltipHTML += `</table>`;
  }

  function getTooltipHTML(tacticData) {
    const totalResults = tacticData.totalResults;
    const resultCategories = tacticData.result_categories;
    const resultsWithPercentages = resultCategories.map(rc => {
      const count = rc.results.length;
      const percentage = ((count / totalResults) * 100).toFixed(2);
      return {
        name: rc.result_category_name,
        count: count,
        percentage: percentage,
        tid: rc.tid
      };
    });

    let tooltipHTML = `<strong>${tacticData.name} ${props.graphDataTypeSelected !== 'Noise' ? `(<span>${tacticData.tid}</span>)` : ''}</strong><br/>`;    tooltipHTML += `<hr style="border: 1px solid #ccc; margin: 5px 0;">`;
    tooltipHTML += `<table style="width: 100%;">`;
    tooltipHTML += `<tr style="color: rgb(158, 164, 168);">
                      <td style="text-align: left;">&nbsp;</td>
                      <td style="text-align: left;">FREQUENCY</td>
                      <td style="text-align: left;">PERCENTAGE</td>
                    </tr>`;
    tooltipHTML += `<tr>
                      <td style="text-align: left;">Results</td>
                      <td style="text-align: left;">${totalResults}</td>
                      <td style="text-align: left;">100%</td>
                    </tr>`;

    resultsWithPercentages.forEach(item => {
      tooltipHTML += `<tr>
                        <td style="text-align: left;">
                          <span class="${props.graphDataTypeSelected === 'Noise' && isFillWhite(item.name) ? 'tooltip-square--outlined' : 'tooltip-square'}" style="color:${props.graphDataTypeSelected === 'Noise' ? getNoiseResultCategoryColor(item.name) : getResultCategoryColor(item.name)};">
                          ■</span>
                          ${item.name}
                        </td>
                        <td style="text-align: left;">${item.count}</td>
                        <td style="text-align: left;">${item.percentage}%</td>
                      </tr>`;
    });
    return tooltipHTML += `</table>`;
  }

  const mouseover = function(event, d) {
    let tooltipHTML = props.graphDataTypeSelected === 'Modifiers' ? getModifiersTooltipHTML(d.data) : getTooltipHTML(d.data);
    if(!isTechniqueChart.value && props.graphDataTypeSelected !== 'Noise'){
      select("#chart").selectAll("rect")
      .filter(function(rectData) {
        return rectData.data.name === d.data.name;
      })
      .classed("hovered-rect", true);
    }

    tooltip
      .style("opacity", 1)
      .style("position", "fixed")
      .html(tooltipHTML);
  };

  svg.append("g")
    .selectAll("g")
    .data(stackedData)
    .enter().append("g")
      .attr("fill", function(d) { return color(d.key); })
      .attr("stroke", function(d) {
        return props.graphDataTypeSelected === "Noise" ? "#25333C" : color(d.key);
      })
      .attr("stroke-width", 0.5)
      .selectAll("rect")
      .data(function(d) { return d; })
      .enter().append("rect")
        .attr("y", function(d) { return y(d.data.name); })
        .attr("x", function(d) { return x(d[0]); })
        .attr("width", function(d) { return x(d[1]) - x(d[0]); })
        .attr("height", isMobile.value ? y.bandwidth() - 10 : y.bandwidth())
      .on("mouseover", mouseover)
      .on("mousemove", mousemove)
      .on("mouseleave", mouseleave)
      .on("click", function(_, d) {
        if(!isTechniqueChart.value && props.graphDataTypeSelected !== 'Noise') {
          router.push({query: {
            view: "cohort",
            evaluation: props.selectedEvaluation.name,
            result_type: props.selectedResultType.value,
            scenarios: props.selectedScenarios.map(s => s.number).join(","),
            tactic_name: d.data.name
          }});
        }
      });
}

function loadDataChart() {
  if(isTechniqueChart.value) {
    loadTechniqueChart(route.query.tactic_name);
  }
  else loadChart(JSON.parse(JSON.stringify(props.filteredTacticResultCategoryFrequencyData)));
}

function loadChart(data) {
  // set the dimensions and margins of the graph
  const graphContainer = document.getElementById('graph-container');
  let amountMostCharsInTacticName = 0;
  data.forEach(tactic => {
    if(tactic.name.length > amountMostCharsInTacticName) {
      amountMostCharsInTacticName = tactic.name.length;
      }
    });
  const charWidth = isTechniqueChart.value ? 5 : 6.5;
  const spaceForTacticNames = !isMobile.value ? amountMostCharsInTacticName * charWidth : 0;
  const extraLeftSpace = 75;
  const extraRightSpace = props.graphDisplayTypeSelected === 'Frequency' ? 0 : 50;

  const margin = {top: 10, right: 30 + extraRightSpace, bottom: 20, left: spaceForTacticNames},
    width = graphContainer.offsetWidth - margin.left - margin.right - extraLeftSpace,
    height = !isMobile.value? 400 - margin.top - margin.bottom : 800 - margin.top - margin.bottom;

  // remove outdated chart if there is already a chart rendered
  select("#chart").selectAll("svg, div").remove();

  const tooltip = select("#chart")
    .append("div")
    .style("opacity", 0)
    .attr("class", "cohort-graph-tooltip")
    .style("padding", "10px")
    .style("position", "fixed");

  if(props.graphDataTypeSelected === "Detections" || props.graphDataTypeSelected === "Protections" || props.graphDataTypeSelected === "Noise") {
    loadDetectionsChart(data, width, height, margin, tooltip);
  }
  else if(props.graphDataTypeSelected === "Modifiers") {
    loadModifiersChart(data, width, height, margin, tooltip);
  }
}

function loadDetectionsChart(data, width, height, margin, tooltip) {
  // Calculate the number of results in each category
  data.forEach(tactic => {
    tactic.totalResults = tactic.result_categories.reduce(
      (accumulator, currentValue) => accumulator + currentValue.results.length,
      0
    );
  });

  // sort tactics by amount of results
  data = data.sort((a,b) => b.totalResults - a.totalResults);

  // append the svg object to the body of the page
  const svg = select("#chart")
    .append("svg")
      .attr("width", !isMobile.value ? width + margin.left + margin.right: "100%")
      .attr("height", height + margin.top + margin.bottom)
    .append("g")
      .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

  const groups = data.map(d => d.name);
  const subgroups = props.resultCategoryFilters.map(rc => rc.label);

  // Create a y scale for the groups
  const y = scaleBand()
    .domain(groups)
    .range([0, height])
    .padding([0.2]);

  if (!isMobile.value) {
    if (props.graphDataTypeSelected !== 'Noise') {
      svg.append("g")
        .call(axisLeft(y).tickSizeOuter(0));
    } else {
      const yAxis = axisLeft(y)
      .tickSize(0)
      .tickFormat("");

      const noiseCategoryTooltipHTML = (category) => {
        return (`<span class='mk-text--h3'>${category}</span><br/>
              ${noiseCategoryDescriptions[category]}`);
      };

      svg.append("g")
        .call(yAxis)
        .selectAll(".tick")
        .data(groups)
        .join("g")
        .attr("transform", d => `translate(0,${y(d) + y.bandwidth() / 2})`)
        .each(function(d) {
          const g = select(this);
          g.append("text")
            .attr("x", -30)
            .attr("dy", "0.32em")
            .attr("fill", "#000")
            .attr("font-size", "11px")
            .text(d);

          const iconG = g.append("g");
            iconG
            .append("path")
            .attr("d", "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M11,17H13V11H11V17Z")
            .attr("x", 3)
            .attr("transform", "translate(-25, -9) scale(0.75)")
            .attr("dy", "0.32em")
            .attr("fill", "#000")
            .clone()
            .attr('stroke', 'transparent').attr('stroke-width', 10);
            iconG
            .style("cursor", "help")
            .on("mouseover", function(event) {
              tooltip.style("opacity", 1)
                .html(noiseCategoryTooltipHTML(d))
                .style("left", `${iconG.node().getBoundingClientRect().left + 35}px`)
                .style("top", `${iconG.node().getBoundingClientRect().top - 30}px`)
                .style("max-width", "500px");

              const tooltipRect = tooltip.node().getBoundingClientRect();
              const viewportHeight = window.innerHeight;
              const viewportWidth = window.innerWidth;

              if (tooltipRect.bottom > viewportHeight) {
                tooltip.style("top", `${viewportHeight - tooltipRect.height - 10}px`);
              }
              if (tooltipRect.right > viewportWidth) {
                tooltip.style("left", `${viewportWidth - tooltipRect.width - 10}px`);
              }
            })
            .on("mouseout", function() {
              tooltip.style("opacity", 0);
            });
        });
    }
  }

  // color palette = one color per subgroup
  const selectedResultCategoryNames = selectedResultCategoryFilters.value.map(rc => rc.label);
  const colors = selectedResultCategoryNames.map(rc => {
    return props.graphDataTypeSelected === 'Noise' ? getNoiseResultCategoryColor(rc) : getResultCategoryColor(rc)
  });
  let color = scaleOrdinal()
    .domain(selectedResultCategoryNames)
    .range(colors);

  if(props.graphDisplayTypeSelected === 'Frequency') {
    loadWholeValueChart(data, subgroups, width, svg, height, y, color, tooltip);
  }
  else if(props.graphDisplayTypeSelected === 'Percent') {
    loadPercentChart(data, subgroups, width, svg, height, y, color, tooltip);
  }
}

function loadPercentChart(data, subgroups, width, svg, height, y, color, tooltip) {
  // Calculate the percentage of results in each category
  data.forEach(tactic => {
    tactic.result_categories.forEach(category => {
      category.percentage = (category.results.length / tactic.totalResults) * 100;
    });
  });

  // Create an x scale for the percentage values
  const x = scaleLinear()
    .domain([0, 100]) // Percent scale from 0 to 100
    .range([0, width]);

  if (!isMobile.value) {
    svg.append("g")
      .attr("transform", "translate(0," + height + ")")
      .call(axisBottom(x).tickFormat(d => d + "%"));
  }

  // Update the stacked data to use percentages
  const stackedData = stack()
    .keys(subgroups)
    .value((d, key) => {
      const resultCategory = d.result_categories.find(rc => rc.result_category_name === key);
      if(resultCategory) {
        return resultCategory.percentage;
      }
    })
    (data);

  appendRectanglesToSvg(svg, stackedData, color, y, x, tooltip);

  // Add labels for each row with the amount of results
  svg.append("g")
    .selectAll("text")
    .data(data)
    .enter()
    .append("text")
    .attr("y", d => !isMobile.value ? y(d.name) + y.bandwidth() / 2 : y(d.name) + 15)
    .attr("x", d => width + 5) // Position the label at the end of the bar
    .attr("dy", ".35em")
    .text(d => `${d.totalResults} results`)
    .style("font-size", "12px")
    .style("fill", "#556067");

  // add key names above rectangles
  if (isMobile.value) {
    svg.append("g")
      .selectAll("text")
      .data(data)
      .enter()
      .append("text")
      .attr("x", 0)
      .attr("y", (d, i) => y(d.name) - 5)
      .text(d => d.name)
      .style("font-size", "15px")
      .style("fill", "#000");
  }
}

function loadWholeValueChart(data, subgroups, width, svg, height, y, color, tooltip) {

  // Create an x scale for the values
  let amountMostResults = 0;
  data.forEach(tactic => {
    if(tactic.totalResults > amountMostResults) {
      amountMostResults = tactic.totalResults;
    }
  });

  const x = scaleLinear()
    .domain([0, amountMostResults * 1.1]) // Extend by 10% for extra space
    .range([0, width]);

  if (!isMobile.value) {
    svg.append("g")
      .attr("transform", "translate(0," + height + ")")
      .call(axisBottom(x));
  }

  const stackedData = stack()
    .keys(subgroups)
    .value((d, key) => {
      if(d.result_categories.find(rc => rc.result_category_name === key)) {
        return d.result_categories.find(rc => rc.result_category_name === key).results.length
      }
    })
    (data);

  appendRectanglesToSvg(svg, stackedData, color, y, x, tooltip);

  // add amount result labels
  const fontSize = isMobile.value ? "12px" : "15px";
  svg.append("g")
    .selectAll("text")
    .data(data)
    .enter()
    .append("text")
      .attr("y", d => !isMobile.value ? y(d.name) + y.bandwidth() / 2 : y(d.name) + 15)
      .attr("x", d => x(d.totalResults) + 5)
      .attr("dy", ".35em")
      .text(d => `${d.totalResults} results`)
      .style("font-size", fontSize)
      .style("fill", "#556067");

  // add tactic names above rectangles for mobile
  if (isMobile.value) {
    svg.append("g")
      .selectAll("text")
      .data(data)
      .enter()
      .append("text")
      .attr("x", 0)
      .attr("y", (d, i) => y(d.name) - 5)
      .text(d => d.name)
      .style("font-size", "15px")
      .style("fill", "#000");

  }
}

function loadModifiersChart(data, width, height, margin, tooltip) {
  if (!props.modifierFilters.length) {
    return;
  }
  data.forEach(tactic => {
    tactic.totalResults = tactic.result_categories.reduce((sum, rc) => {
      return sum + rc.results.reduce((rcSum, r) => {
        const modifierNames = r.modifiers.map(m => props.modifiers.find(modifier => modifier.id === m).name);
        const modifierCategories = modifierNames.map(m => getModifierTypeCategory(m));
        const uniqueModifierCategories = [ ... new Set(modifierCategories)].filter(mc => props.modifierFilters.find(mf => mf.label === mc).selected);
        return rcSum + uniqueModifierCategories.length;
      }, 0);
    }, 0);
  });

  // sort tactics by amount of results
  data = data.sort((a,b) => b.totalResults - a.totalResults);

  // append the svg object to the body of the page
  const svg = select("#chart")
    .append("svg")
      .attr("width", !isMobile.value ? width + margin.left + margin.right : "100%")
      .attr("height", height + margin.top + margin.bottom)
    .append("g")
      .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

  const groups = data.map(d => d.name);
  const subgroups = props.modifierFilters.map(m => m.label);

  // Create a y scale for the groups
  const y = scaleBand()
    .domain(groups)
    .range([0, height])
    .padding([0.2]);

  if (!isMobile.value) {
    svg.append("g")
      .call(axisLeft(y).tickSizeOuter(0));
  }

  // color palette = one color per subgroup
  const modifierCategoryNames = props.modifierFilters.map(m => m.label);
  const colors = modifierCategoryNames.map(m => getModifierColor(m));
  let color = scaleOrdinal()
    .domain(modifierCategoryNames)
    .range(colors);

  if(props.graphDisplayTypeSelected === 'Frequency') {
    loadWholeValueModifiersChart(data, subgroups, width, svg, height, y, color, tooltip);
  }
  else if(props.graphDisplayTypeSelected === 'Percent') {
    loadPercentModifiersChart(data, subgroups, width, svg, height, y, color, tooltip);
  }
}

function loadWholeValueModifiersChart(data, subgroups, width, svg, height, y, color, tooltip) {

  // Create an x scale for the values
  let amountMostResults = 0;
  data.forEach(tactic => {
    if(tactic.totalResults > amountMostResults) {
      amountMostResults = tactic.totalResults;
    }
  });

  const x = scaleLinear()
    .domain([0, amountMostResults * 1.1]) // Extend by 10% for extra space
    .range([0, width]);

  if (!isMobile.value) {
    svg.append("g")
      .attr("transform", "translate(0," + height + ")")
      .call(axisBottom(x));
  }

  const stackedData = stack()
    .keys(subgroups)
    .value((d, key) => {
      let amountResultsWithModifier = 0;
      d.result_categories.forEach(rc => {
        rc.results.forEach(r => {
          const uniqueModifierCategories = getUniqueModifierCategories(r);
          uniqueModifierCategories.forEach(modifierCategory => {
            if(modifierCategory === key && props.modifierFilters.find(mf => mf.label === modifierCategory).selected) {
              amountResultsWithModifier++;
            }
          });
        });
      });
      return amountResultsWithModifier;
    })
    (data);

  appendRectanglesToSvg(svg, stackedData, color, y, x, tooltip);

  // add amount result labels
  svg.append("g")
    .selectAll("text")
    .data(data)
    .enter()
    .append("text")
      .attr("y", d => !isMobile.value ? y(d.name) + y.bandwidth() / 2 : y(d.name) + 15)
      .attr("x", d => x(d.totalResults) + 5) // Add some padding to the right
      .attr("dy", ".35em") // Vertical alignment
      .text(d => `${d.totalResults} items`)
      .style("font-size", "12px")
      .style("fill", "#556067");

  // add tactic names above rectangles for mobile
  if (isMobile.value) {
    svg.append("g")
      .selectAll("text")
      .data(data)
      .enter()
      .append("text")
      .attr("x", 0)
      .attr("y", (d, i) => y(d.name) - 5)
      .text(d => d.name)
      .style("font-size", "15px")
      .style("fill", "#000");
  }
}

function loadPercentModifiersChart(data, subgroups, width, svg, height, y, color, tooltip) {

  // Normalize the data to percentages
  const stackedData = stack()
    .keys(subgroups)
    .value((d, key) => {
      let amountResultsWithModifier = 0;
      d.result_categories.forEach(rc => {
        rc.results.forEach(r => {
          const uniqueModifierCategories = getUniqueModifierCategories(r);
          uniqueModifierCategories.forEach(modifierCategory => {
            if(modifierCategory === key && props.modifierFilters.find(mf => mf.label === modifierCategory).selected) {
              amountResultsWithModifier++;
            }
          });
        });
      });
      return amountResultsWithModifier / d.totalResults; // Normalize to percentage
    })
    (data);

  // Adjust the x scale to represent percentages
  const x = scaleLinear()
    .domain([0, 1]) // From 0% to 100%
    .range([0, width]);

  if (!isMobile.value) {
    svg.append("g")
      .attr("transform", "translate(0," + height + ")")
      .call(axisBottom(x).tickFormat(format(".0%"))); // Format ticks as percentages
  }

  // Function to append rectangles (bars) to the SVG
  appendRectanglesToSvg(svg, stackedData, color, y, x, tooltip);

  // Add percentage labels instead of absolute result labels
  svg.append("g")
    .selectAll("text")
    .data(data)
    .enter()
    .append("text")
      .attr("y", d => !isMobile.value ? y(d.name) + y.bandwidth() / 2 : y(d.name) + 15)
      .attr("x", d => x(1) + 5) // Position at the end of the bar
      .attr("dy", ".35em") // Vertical alignment
      .text(d => `${d.totalResults} items`)
      .style("font-size", "12px")
      .style("fill", "#556067");

  // add tactic names above rectangles for mobile
  if (isMobile.value) {
    svg.append("g")
      .selectAll("text")
      .data(data)
      .enter()
      .append("text")
      .attr("x", 0)
      .attr("y", (d, i) => y(d.name) - 5)
      .text(d => d.name)
      .style("font-size", "15px")
      .style("fill", "#000");

  }
}

function loadTechniqueChart(tacticName) {
  const data = JSON.parse(JSON.stringify(props.filteredTacticResultCategoryFrequencyData.find(tactic => tactic.name === tacticName)));
  const structuredData = [];
  data.result_categories.forEach(rc => {
    rc.results.forEach(r => {
      if(r.technique_name){
        const resultTechnique = structuredData.find(technique => technique.name === r.technique_name);
        if(resultTechnique) {
          const rcGroup = resultTechnique.result_categories.find(category => category.result_category_name === rc.result_category_name);
          if(rcGroup) {
            rcGroup.results.push(r);
          }
          else {
            resultTechnique.result_categories.push({
              result_category_name: rc.result_category_name,
              results: [r]
            });
          }
        }
        else {
          structuredData.push({
            name: r.technique_name,
            tid: r.technique_tid,
            result_categories: [
              {
                result_category_name: rc.result_category_name,
                results: [r]
              }
            ]
          });
        }
      }
    });
  });
  loadChart(structuredData);
}

function getUniqueModifierCategories(result) {
  const modifierNames = result.modifiers.map(m => props.modifiers.find(modifier => modifier.id === m).name);
  const modifierCategories = modifierNames.map(m => getModifierTypeCategory(m));
  return [ ... new Set(modifierCategories)];
}

onMounted(() => {
  loadDataChart();
  window.addEventListener("resize", loadDataChart);
});

onUnmounted(() => {
  window.removeEventListener("resize", loadDataChart);
});

return (_ctx, _cache) => {
  const _component_v_progress_circular = resolveComponent("v-progress-circular");
  const _component_v_overlay = resolveComponent("v-overlay");
  const _component_v_icon = resolveComponent("v-icon");
  const _component_v_tooltip = resolveComponent("v-tooltip");

  return (openBlock(), createElementBlock("div", null, [
    createVNode(_component_v_overlay, { "model-value": __props.isGraphLoading }, {
      default: withCtx(() => [
        createVNode(_component_v_progress_circular, {
          color: "white",
          indeterminate: "",
          size: "64"
        })
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["model-value"]),
    createElementVNode("div", {
      class: normalizeClass({'cohort-group-graph-container': true, 'mr-0': _ctx.$vuetify.display.smAndDown}),
      id: "graph-container"
    }, [
      createElementVNode("div", {
        class: normalizeClass({'mk-text--h2': true, 'd-flex': __props.graphDataTypeSelected === 'Noise' || __props.selectedResultType.value === 'PROTECTION'})
      }, [
        createTextVNode(toDisplayString(__props.graphDisplayTypeSelected.charAt(0).toUpperCase() + __props.graphDisplayTypeSelected.slice(1)) + " of " + toDisplayString(__props.graphDataTypeSelected === 'Noise' ? 'Noise' : __props.graphDataTypeSelected ==='Modifiers'? 'Modifiers' : 'Results') + " ", 1 /* TEXT */),
        (isTechniqueChart.value && __props.graphDataTypeSelected !== 'Noise')
          ? (openBlock(), createElementBlock("span", _hoisted_1$c, [
              createTextVNode(" for MITRE ATT&CK Tactic: " + toDisplayString(unref(route).query.tactic_name) + " (", 1 /* TEXT */),
              createElementVNode("a", {
                class: "c-text--hover",
                href: `${_ctx.$mitreAttackExternalLink}tactics/${tacticTid.value}`,
                target: "_blank",
                rel: "noopener"
              }, toDisplayString(tacticTid.value), 9 /* TEXT, PROPS */, _hoisted_2$c),
              createTextVNode(") ")
            ]))
          : (__props.graphDataTypeSelected !== 'Noise')
            ? (openBlock(), createElementBlock("span", _hoisted_3$c, [
                (__props.selectedResultType.value === 'PROTECTION')
                  ? (openBlock(), createElementBlock("span", _hoisted_4$a, " "))
                  : createCommentVNode("v-if", true),
                createTextVNode("for MITRE ATT&CK Tactics "),
                (__props.selectedResultType.value === 'PROTECTION' && __props.selectedEvaluation.name === 'er6')
                  ? (openBlock(), createBlock(_component_v_tooltip, {
                      key: 1,
                      location: "right",
                      "content-class": "mk-tooltip--cohort-noise"
                    }, {
                      activator: withCtx(({ props }) => [
                        createElementVNode("span", mergeProps(props, { class: "cursor-help c-text--primary m-spacing--left-3" }), [
                          createVNode(_component_v_icon, { size: "20px" }, {
                            default: withCtx(() => [
                              createTextVNode("mdi-help-circle-outline")
                            ]),
                            _: 1 /* STABLE */
                          }),
                          _hoisted_5$a
                        ], 16 /* FULL_PROPS */)
                      ]),
                      default: withCtx(() => [
                        _hoisted_6$a,
                        _hoisted_7$a,
                        _hoisted_8$9,
                        _hoisted_9$8
                      ]),
                      _: 1 /* STABLE */
                    }))
                  : createCommentVNode("v-if", true)
              ]))
            : (__props.graphDataTypeSelected === 'Noise')
              ? (openBlock(), createBlock(_component_v_tooltip, {
                  key: 2,
                  "content-class": "mk-tooltip--cohort-noise",
                  location: "right"
                }, {
                  activator: withCtx(({ props }) => [
                    createElementVNode("div", mergeProps(props, { class: "cursor-help c-text--primary m-spacing--left-3 d-flex align-center text-center" }), [
                      createVNode(_component_v_icon, { size: "20px" }, {
                        default: withCtx(() => [
                          createTextVNode("mdi-help-circle-outline")
                        ]),
                        _: 1 /* STABLE */
                      }),
                      _hoisted_10$7
                    ], 16 /* FULL_PROPS */)
                  ]),
                  default: withCtx(() => [
                    createVNode(NoiseExplanationTooltip)
                  ]),
                  _: 1 /* STABLE */
                }))
              : createCommentVNode("v-if", true)
      ], 2 /* CLASS */),
      createElementVNode("div", _hoisted_11$7, [
        createElementVNode("span", null, toDisplayString(`Scenario${selectedScenarioNames.value.length > 1 ? 's' : ''}: `), 1 /* TEXT */),
        (openBlock(true), createElementBlock(Fragment, null, renderList(selectedScenarioNames.value, (scenarioName, index) => {
          return (openBlock(), createElementBlock("span", { key: scenarioName }, toDisplayString(`${scenarioName}${index < selectedScenarioNames.value.length - 1 ? ', ' : ''}`), 1 /* TEXT */))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      (selectedModifierNames.value.length)
        ? (openBlock(), createElementBlock("div", _hoisted_12$7, [
            createElementVNode("span", null, toDisplayString(`Modifier${selectedModifierNames.value.length > 1 ? 's' : ''}: `), 1 /* TEXT */),
            (openBlock(true), createElementBlock(Fragment, null, renderList(selectedModifierNames.value, (modifierName, index) => {
              return (openBlock(), createElementBlock("span", { key: modifierName }, toDisplayString(`${modifierName}${index < selectedModifierNames.value.length - 1 ? ', ' : ''}`), 1 /* TEXT */))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
        : createCommentVNode("v-if", true),
      (__props.graphDataTypeSelected === 'Detections' || __props.graphDataTypeSelected === 'Protections')
        ? (openBlock(), createElementBlock("div", {
            key: 1,
            class: normalizeClass({'d-flex key-container mt-5': true, 'flex-wrap justify-start': _ctx.$vuetify.display.smAndDown})
          }, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(selectedResultCategoryFilters.value, (rc) => {
              return (openBlock(), createElementBlock("div", {
                key: rc.id,
                class: normalizeClass({'mr-4': true, 'd-flex': _ctx.$vuetify.display.smAndDown})
              }, [
                (__props.graphDataTypeSelected !== 'Noise' || !unref(isFillWhite)(rc.label))
                  ? (openBlock(), createBlock(_component_v_icon, {
                      key: 0,
                      size: "20px",
                      color: __props.graphDataTypeSelected === 'Noise' ? unref(getNoiseResultCategoryColor)(rc.label) : unref(getResultCategoryColor)(rc.label)
                    }, {
                      default: withCtx(() => [
                        createTextVNode("mdi-square-rounded")
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["color"]))
                  : (openBlock(), createBlock(_component_v_icon, {
                      key: 1,
                      size: "20px",
                      color: "#25333C"
                    }, {
                      default: withCtx(() => [
                        createTextVNode("mdi-square-rounded-outline")
                      ]),
                      _: 1 /* STABLE */
                    })),
                createTextVNode(" " + toDisplayString(rc.label), 1 /* TEXT */)
              ], 2 /* CLASS */))
            }), 128 /* KEYED_FRAGMENT */))
          ], 2 /* CLASS */))
        : (__props.graphDataTypeSelected === 'Modifiers')
          ? (openBlock(), createElementBlock("div", {
              key: 2,
              class: normalizeClass({'d-flex key-container mt-5': true, 'flex-wrap justify-start': _ctx.$vuetify.display.smAndDown})
            }, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(selectedModifierFilters.value, (modifier) => {
                return (openBlock(), createElementBlock("div", {
                  key: modifier.label,
                  class: normalizeClass({'mr-4': true, 'd-flex': _ctx.$vuetify.display.smAndDown})
                }, [
                  createVNode(_component_v_icon, {
                    size: "20px",
                    color: unref(getModifierColor)(modifier.label)
                  }, {
                    default: withCtx(() => [
                      createTextVNode("mdi-square-rounded")
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["color"]),
                  createTextVNode(" " + toDisplayString(modifier.label), 1 /* TEXT */)
                ], 2 /* CLASS */))
              }), 128 /* KEYED_FRAGMENT */))
            ], 2 /* CLASS */))
          : createCommentVNode("v-if", true),
      _hoisted_13$6
    ], 2 /* CLASS */)
  ]))
}
}

};
var GroupCohortGraph = /*#__PURE__*/_export_sfc(_sfc_main$e, [['__file',"/home/runner/work/evals-website/evals-website/packages/enterprise-results/src/group-cohort-metrics/GroupCohortGraph.vue"]]);

var css_248z$a = "";
styleInject(css_248z$a);

const _hoisted_1$b = /*#__PURE__*/createElementVNode("div", { class: "mk-text--h5" }, "Results", -1 /* HOISTED */);
const _hoisted_2$b = { class: "toggle-container" };
const _hoisted_3$b = {
  key: 4,
  class: "empty-noise-state"
};


const _sfc_main$d = {
  __name: 'GroupCohort',
  props: {
  evaluations: Array
},
  emits: ["toggle"],
  setup(__props, { emit: __emit }) {

const route = useRoute();
const router = useRouter();

const emit = __emit;

const toggleValue = ref("cohort");
const selectedEvaluation = ref(undefined);
const selectedResultType = ref(undefined);
const selectedScenarios = ref([]);
const tacticResultCategoryFrequencyData = ref([]);
const resultCategoryFilters = ref([]);
const modifierFilters = ref([]);
const modifiers = ref([]);
const graphDataTypeSelected = ref(undefined);
const isGraphLoading = ref(false);
const graphDisplayTypeSelected = ref('Frequency');
const graphDisplayTypes = ref(["Frequency", "Percent"]);
const cachedData = ref({});
const globalProperties = inject('globalProperties');

const props = __props;

const graphTypeButtons = computed(() => {
  if (selectedResultType.value) {
    let buttons = [];
    if(!route.query.tactic_name) {
      buttons.push("Noise");
    }
    if(selectedResultType.value.value === "DETECTION" && selectedEvaluation.value.domain !== "MANAGED_SERVICES"){
      buttons.push("Modifiers");
    }
    buttons.unshift(selectedResultType.value.label);
    return buttons;
  }
  return [];
});

const resultTypes = computed(() => {
  if(selectedEvaluation.value){
    const scenarioResultTypes = selectedEvaluation.value.scenarios.sort((a,b) => a.number - b.number)
                                .map(scenario => scenario.scenario_type);
    const uniqueScenarioResultTypes = [...new Set(scenarioResultTypes)];
    const resultTypesLabelAndValueMap = uniqueScenarioResultTypes.map(resultType => {
      return {
        label: `${resultType.charAt(0)}${resultType.slice(1).toLowerCase()}s`,
        value: resultType
      }
    });
    return resultTypesLabelAndValueMap;
  }
  return [];
});

const filteredTacticResultCategoryFrequencyData = computed(()=> {
  if(
    tacticResultCategoryFrequencyData.value.length &&
    resultCategoryFilters.value.length &&
    graphDataTypeSelected.value &&
    selectedResultType.value
  ) {
    let filteredData = JSON.parse(JSON.stringify(tacticResultCategoryFrequencyData.value));
    if(graphDataTypeSelected.value === "Modifiers") {
      filterResultsWithoutModifiers(filteredData);
    }
    if(selectedResultType.value.value === "PROTECTION" && graphDataTypeSelected.value !== "Noise") {
      filterOutNAResults(filteredData);
    }
    filterDataByResultCategories(filteredData);
    filterDataByModifiers(filteredData);
    filteredData = filterDataByScenarios(filteredData);
    onlyDisplayMostSpecificResult(filteredData);
    return filteredData;
  }
  return [];
});

const adversaryHasNoiseSteps = computed(() => {
  return selectedEvaluation.value.operational_flow.some(substep => substep.noise_category);
});

watch(() => route.query.view, () => setSelectsAccordingToQueryParams(), { immediate: true });
watch(() => route.query.evaluation, () => setSelectsAccordingToQueryParams());

watch(selectedScenarios, (newVal, oldVal) => {
  if(!oldVal.length && newVal.length){
    getTacticResultCategoryFrequencyData();
  }
});

watch(graphTypeButtons, (newVal, oldVal) => {
  if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
    graphDataTypeSelected.value = newVal[0];
  }
}, {immediate: true});

watch(graphDataTypeSelected, (newVal, oldVal) => {
  if(oldVal && (newVal === "Noise" || oldVal === "Noise")) {
    getTacticResultCategoryFrequencyData();
  }
});

watch(selectedEvaluation, (_, oldVal) => {
  if(oldVal || !route.query.result_type) {
    selectedResultType.value = undefined;
    selectedScenarios.value = [];
    router.push({
      query: {
        view: 'cohort',
        evaluation: selectedEvaluation.value.name
      }
    });
  }
});

watch(selectedResultType, (newVal, oldVal) => {
  if(newVal && (oldVal || !route.query.scenarios)) {
    router.push({
      query: {
        view: 'cohort',
        evaluation: selectedEvaluation.value.name,
        result_type: selectedResultType.value.value
      }
    });
    getTacticResultCategoryFrequencyData();
  }
});

watch(selectedScenarios, (newVal) => {
  if(newVal && selectedResultType.value) {
    const query = {
      view: 'cohort',
      evaluation: selectedEvaluation.value.name,
      result_type: selectedResultType.value.value
    };
    if(newVal.length) {
      query.scenarios = selectedScenarios.value.map(scenario => scenario.number).join(',');
    }
    router.push({query: query});
  }
});

watch(tacticResultCategoryFrequencyData, (newValue) => {
  if(newValue.length) {
    if(tacticResultCategoryFrequencyData.value.length){
      resultCategoryFilters.value = getResultCategoryFilters();
      getModifierFilters().then(response => {
        modifierFilters.value = response;
      });
    }
  }
  else {
    resultCategoryFilters.value = [];
    modifierFilters.value = [];
  }
});

function goBackToTacticView() {
  router.push({query: {
    view: 'cohort',
    evaluation: selectedEvaluation.value.name,
    result_type: selectedResultType.value.value,
    scenarios: selectedScenarios.value.map(s => s.number).join(",")
  }});
}

function getModifierFilters() {
  return globalProperties.$api
    .get(`/modifier-types/?adversary__name=${selectedEvaluation.value.name}&result_type=${selectedResultType.value.value}`)
    .then(response => {
      modifiers.value = response.data;
      const uniqueModifierTypeCategories = getUniqueModifierTypeCategories(response.data.map(m => m.name));
      return uniqueModifierTypeCategories.map((modifier) => {
        return {
          "label": modifier,
          "selected": false
        }
      })
    })
}

function getResultCategoryFilters() {
  return tacticResultCategoryFrequencyData.value[0].result_categories.map(rc => {
    if((selectedResultType.value?.value !== "PROTECTION" || rc.result_category_name !== "N/A") || graphDataTypeSelected.value === "Noise"){
      return {
        "label": rc.result_category_name,
        "selected": true
      }
    }
  }).filter(rc => rc);
}

function filterOutNAResults(filteredData) {
  filteredData.forEach(tactic => {
    tactic.result_categories = tactic.result_categories.filter(rc => rc.result_category_name !== "N/A");
  });
}

function filterResultsWithoutModifiers(filteredData) {
  filteredData.forEach(tactic => tactic.result_categories.forEach(rc => {
    rc.results = rc.results.filter(r => r.modifiers.length);
  }));
}

function filterDataByModifiers(filteredData) {
  const modifiersDeselected = modifierFilters.value
    .filter(m => !m.selected)
    .map(m => m.label);
  if(modifiersDeselected.length) {
    filteredData.forEach(tactic => {
      tactic.result_categories.forEach((rc) => {
        rc.results = rc.results.filter(result => !result.modifiers.length || result.modifiers.some(m => {
          const modifier = modifiers.value.find(modifier => modifier.id === m);
          if(modifier) {
            const modifierName = modifier.name;
            const modifierCategory = getModifierTypeCategory(modifierName);
            return !modifiersDeselected.includes(modifierCategory);
          }
        }));
      });
    });
  }
}

function filterDataByResultCategories(filteredData) {
  const resultCategoryIdsDeSelected = resultCategoryFilters.value
    .filter(rc => !rc.selected)
    .map(rc => rc.label);
  if(resultCategoryIdsDeSelected.length) {
    filteredData.forEach(tactic => {
      tactic.result_categories = tactic.result_categories
        .filter(rc => !resultCategoryIdsDeSelected.includes(rc.result_category_name));
    });
  }
}

function filterDataByScenarios(filteredData) {
  const evaluationScenarios = selectedEvaluation.value.scenarios;
  const selectedScenarioNumbers = selectedScenarios.value.map(s => s.number);
  const scenariosDeselected = evaluationScenarios.filter(
    s => !selectedScenarioNumbers.includes(s.number) && s.scenario_type === selectedResultType.value.value
  );
  const selectedScenarioIds = selectedScenarios.value.map(s => s.id);
  const deselectedScenarioIds = scenariosDeselected.map(s => s.id);
  if(scenariosDeselected.length && graphDataTypeSelected.value !== "Noise") {
    filteredData = filteredData.filter(tactic => {
      return !tactic.result_categories.every(rc => rc.results.every(result => deselectedScenarioIds.includes(result.scenario_id)));
    });
    filteredData.forEach(tactic => {
      tactic.result_categories.forEach((rc) => {
        rc.results = rc.results.filter(result => !deselectedScenarioIds.includes(result.scenario_id));
      });
    });
  } else if (graphDataTypeSelected.value === "Noise") {
    // make sure to only include results that have a scenario id that is in the selected scenario ids
    filteredData.forEach(tactic => {
      tactic.result_categories.forEach((rc) => {
        rc.results = rc.results.filter(result => selectedScenarioIds.includes(result.scenario_id));
      });
    });
  }
  return filteredData;
}

function onlyDisplayMostSpecificResult(filteredData) {
  filteredData.forEach(tactic => {
    const tacticEvalSubsteps = [...new Set(tactic.result_categories.flatMap(rc => rc.results.flatMap(r => r.eval_substep_id)))];
    const tacticResults = tactic.result_categories.flatMap(rc => rc.results);
    let mostSpecificResultIds = [];
    tacticEvalSubsteps.forEach(evalSubstepId => {
      let resultsForSubstepAndEval = tacticResults.filter(r => r.eval_substep_id === evalSubstepId);
      if(resultsForSubstepAndEval.length > 1) {
        const mostSpecificResult = resultsForSubstepAndEval.reduce(
          (prev, current) => {
            if(graphDataTypeSelected.value === "Noise") {
              if(prev.modifiers.length > current.modifiers.length) {
                return prev;
              }
              else if(prev.modifiers.length < current.modifiers.length) {
                return current;
              }
            }
            return prev.result_category_order_num < current.result_category_order_num ? current : prev
        });
        mostSpecificResultIds.push(mostSpecificResult.result_id);
      }
      else if(resultsForSubstepAndEval.length === 1){
        mostSpecificResultIds.push(resultsForSubstepAndEval[0].result_id);
      }
    });
    tactic.result_categories.forEach(rc => {
      rc.results = rc.results.filter(r => mostSpecificResultIds.includes(r.result_id));
    });
  });
}

function filterByResultCategory(value, resultCategoryName) {
  const resultCategoryChanged = resultCategoryFilters.value.find(rc => rc.label === resultCategoryName);
  resultCategoryChanged.selected = value;
}

function filterByModifier(value, modifierName) {
  const modifierChanged = modifierFilters.value.find(m => m.label === modifierName);
  modifierChanged.selected = value;
}

function getTacticResultCategoryFrequencyData() {
  const dataType = graphDataTypeSelected.value !== "Noise" ? selectedResultType.value.value : "Noise";
  if(cachedData.value[selectedEvaluation.value.name] && cachedData.value[selectedEvaluation.value.name][dataType]){
    tacticResultCategoryFrequencyData.value = cachedData.value[selectedEvaluation.value.name][dataType];
  }
  else {
    isGraphLoading.value = true;
    let url;
    if(graphDataTypeSelected.value !== "Noise") {
      url = `/tactic-result-category-frequency/?adversary=${selectedEvaluation.value.name}&result_type=${selectedResultType.value.value}`;
    }
    else {
      url = `/adversary-noise-category-frequency/?name=${selectedEvaluation.value.name}`;
    }
    globalProperties.$api
      .get(url)
      .then(response => {
        tacticResultCategoryFrequencyData.value = graphDataTypeSelected.value === "Noise" ? response.data[0].noise_categories : response.data;
        if(!cachedData.value[selectedEvaluation.value.name]) cachedData.value[selectedEvaluation.value.name] = {};
        cachedData.value[selectedEvaluation.value.name][dataType] = tacticResultCategoryFrequencyData.value;
        isGraphLoading.value = false;
      })
      .catch(() => isGraphLoading.value = false);
    }
}

function setSelectsAccordingToQueryParams() {
  const evalQueryParam = route.query.evaluation;
  if(evalQueryParam) {
    const evaluation = props.evaluations.find(e => e.name === evalQueryParam);
    if(evaluation) {
      selectedEvaluation.value = evaluation;
      const resultTypeQueryParam = route.query.result_type;
      const resultType = resultTypes.value.find(rt => rt.value === resultTypeQueryParam);
      if(resultType) {
        selectedResultType.value = resultType;
        let scenariosQueryParam = route.query.scenarios;
        if(scenariosQueryParam) {
          let scenarioNums = scenariosQueryParam.split(',').map(scenarioNum => scenarioNum);
          const scenarioObjs = scenarioNums
            .map(scenarioNum => selectedEvaluation.value.scenarios
              .find(s => s.number.toString() === scenarioNum && s.scenario_type === selectedResultType.value.value))
            .filter(s => s);
          if(scenarioObjs.length) {
            selectedScenarios.value = scenarioObjs;
            getTacticResultCategoryFrequencyData();
          }
        }
      }
    }
  }
}


return (_ctx, _cache) => {
  const _component_v_btn = resolveComponent("v-btn");
  const _component_v_btn_toggle = resolveComponent("v-btn-toggle");
  const _component_v_divider = resolveComponent("v-divider");
  const _component_v_col = resolveComponent("v-col");
  const _component_v_icon = resolveComponent("v-icon");
  const _component_v_row = resolveComponent("v-row");

  return (openBlock(), createBlock(_component_v_row, {
    class: normalizeClass({'off-white-background' : selectedScenarios.value.length})
  }, {
    default: withCtx(() => [
      createVNode(_component_v_col, {
        cols: _ctx.$vuetify.display.mobile ? '12' : 'auto',
        class: normalizeClass({
        'text-left pl-9 white-background': true,
        'fixed-scroll': !_ctx.$vuetify.display.mobile,
        'pr-9': _ctx.$vuetify.display.mobile
      })
      }, {
        default: withCtx(() => [
          _hoisted_1$b,
          createElementVNode("div", _hoisted_2$b, [
            createVNode(_component_v_btn_toggle, {
              class: "cohort-or-individual-participant-toggle w-100",
              density: "compact",
              color: "primary",
              modelValue: toggleValue.value,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = $event => ((toggleValue).value = $event)),
                _cache[1] || (_cache[1] = $event => (emit('toggle')))
              ]
            }, {
              default: withCtx(() => [
                createVNode(_component_v_btn, {
                  value: "cohort",
                  class: normalizeClass(_ctx.$vuetify.display.smAndDown ? 'w-50' : '')
                }, {
                  default: withCtx(() => [
                    createTextVNode("Cohort")
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["class"]),
                createVNode(_component_v_btn, {
                  value: "individualParticipant",
                  class: normalizeClass(_ctx.$vuetify.display.smAndDown ? 'w-50' : '')
                }, {
                  default: withCtx(() => [
                    createTextVNode("Individual")
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["class"])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["modelValue"])
          ]),
          createVNode(_component_v_divider, { class: "my-3" }),
          createVNode(GroupCohortSelects, {
            evaluations: __props.evaluations,
            selectedEvaluation: selectedEvaluation.value,
            selectedResultType: selectedResultType.value,
            selectedScenarios: selectedScenarios.value,
            resultTypes: resultTypes.value,
            graphDataTypeSelected: graphDataTypeSelected.value,
            onUpdateSelectedEvaluation: _cache[2] || (_cache[2] = value => selectedEvaluation.value = value),
            onUpdateSelectedResultType: _cache[3] || (_cache[3] = value => selectedResultType.value = value),
            onUpdateSelectedScenarios: _cache[4] || (_cache[4] = value => selectedScenarios.value = [...value])
          }, null, 8 /* PROPS */, ["evaluations", "selectedEvaluation", "selectedResultType", "selectedScenarios", "resultTypes", "graphDataTypeSelected"]),
          createVNode(_component_v_divider, { class: "my-3" }),
          (selectedScenarios.value.length && selectedResultType.value)
            ? (openBlock(), createBlock(GroupCohortFilters, {
                key: 0,
                resultCategoryFilters: resultCategoryFilters.value,
                modifierFilters: modifierFilters.value,
                resultType: selectedResultType.value.label,
                graphDataTypeSelected: graphDataTypeSelected.value,
                onFilterByResultCategory: filterByResultCategory,
                onFilterByModifier: filterByModifier
              }, null, 8 /* PROPS */, ["resultCategoryFilters", "modifierFilters", "resultType", "graphDataTypeSelected"]))
            : createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["cols", "class"]),
      (selectedScenarios.value.length)
        ? (openBlock(), createBlock(_component_v_col, {
            key: 0,
            class: normalizeClass({'text-left group-cohort-nav-col pr-7': true, 'fixed-scroll': !_ctx.$vuetify.display.mobile })
          }, {
            default: withCtx(() => [
              (unref(route).query.tactic_name)
                ? (openBlock(), createElementBlock("div", {
                    key: 0,
                    onClick: goBackToTacticView,
                    class: "c-text--primary ml-2 c-text--cursor-pointer c-text--hover"
                  }, [
                    createVNode(_component_v_icon, {
                      size: "small",
                      color: "primary"
                    }, {
                      default: withCtx(() => [
                        createTextVNode("mdi-arrow-left")
                      ]),
                      _: 1 /* STABLE */
                    }),
                    createTextVNode(" Return to All ATT&CK Tactics ")
                  ]))
                : createCommentVNode("v-if", true),
              (selectedScenarios.value.length)
                ? (openBlock(), createBlock(GroupCohortGraphNavigation, {
                    key: 1,
                    filteredTacticResultCategoryFrequencyData: filteredTacticResultCategoryFrequencyData.value,
                    graphDataTypeSelected: graphDataTypeSelected.value,
                    graphTypeButtons: graphTypeButtons.value,
                    graphDisplayTypeSelected: graphDisplayTypeSelected.value,
                    graphDisplayTypes: graphDisplayTypes.value,
                    selectedEvaluation: selectedEvaluation.value,
                    onSelectGraphDisplayType: _cache[5] || (_cache[5] = value => graphDisplayTypeSelected.value = value),
                    onSelectGraphDataType: _cache[6] || (_cache[6] = value => graphDataTypeSelected.value = value)
                  }, null, 8 /* PROPS */, ["filteredTacticResultCategoryFrequencyData", "graphDataTypeSelected", "graphTypeButtons", "graphDisplayTypeSelected", "graphDisplayTypes", "selectedEvaluation"]))
                : createCommentVNode("v-if", true),
              (selectedScenarios.value.length && (graphDataTypeSelected.value !== 'Noise' || adversaryHasNoiseSteps.value))
                ? (openBlock(), createBlock(GroupCohortGraphHeaders, {
                    key: 2,
                    filteredTacticResultCategoryFrequencyData: filteredTacticResultCategoryFrequencyData.value,
                    resultCategoryFilters: resultCategoryFilters.value,
                    graphDisplayTypeSelected: graphDisplayTypeSelected.value,
                    graphDataTypeSelected: graphDataTypeSelected.value
                  }, null, 8 /* PROPS */, ["filteredTacticResultCategoryFrequencyData", "resultCategoryFilters", "graphDisplayTypeSelected", "graphDataTypeSelected"]))
                : createCommentVNode("v-if", true),
              (filteredTacticResultCategoryFrequencyData.value.length && (graphDataTypeSelected.value !== 'Noise' || adversaryHasNoiseSteps.value))
                ? (openBlock(), createBlock(GroupCohortGraph, {
                    key: 3,
                    filteredTacticResultCategoryFrequencyData: filteredTacticResultCategoryFrequencyData.value,
                    selectedScenarios: selectedScenarios.value,
                    modifierFilters: modifierFilters.value,
                    resultCategoryFilters: resultCategoryFilters.value,
                    graphDisplayTypeSelected: graphDisplayTypeSelected.value,
                    graphDataTypeSelected: graphDataTypeSelected.value,
                    modifiers: modifiers.value,
                    selectedResultType: selectedResultType.value,
                    isGraphLoading: isGraphLoading.value,
                    selectedEvaluation: selectedEvaluation.value
                  }, null, 8 /* PROPS */, ["filteredTacticResultCategoryFrequencyData", "selectedScenarios", "modifierFilters", "resultCategoryFilters", "graphDisplayTypeSelected", "graphDataTypeSelected", "modifiers", "selectedResultType", "isGraphLoading", "selectedEvaluation"]))
                : (graphDataTypeSelected.value === 'Noise' && !adversaryHasNoiseSteps.value)
                  ? (openBlock(), createElementBlock("div", _hoisted_3$b, " This evaluation did not evaluate noise "))
                  : createCommentVNode("v-if", true)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["class"]))
        : (!selectedEvaluation.value)
          ? (openBlock(), createBlock(_component_v_col, { key: 1 }, {
              default: withCtx(() => [
                createTextVNode(" No evaluation selected ")
              ]),
              _: 1 /* STABLE */
            }))
          : (!selectedResultType.value)
            ? (openBlock(), createBlock(_component_v_col, { key: 2 }, {
                default: withCtx(() => [
                  createTextVNode(" No result type selected ")
                ]),
                _: 1 /* STABLE */
              }))
            : (!selectedScenarios.value.length)
              ? (openBlock(), createBlock(_component_v_col, { key: 3 }, {
                  default: withCtx(() => [
                    createTextVNode(" No scenarios selected ")
                  ]),
                  _: 1 /* STABLE */
                }))
              : createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["class"]))
}
}

};
var GroupCohort = /*#__PURE__*/_export_sfc(_sfc_main$d, [['__file',"/home/runner/work/evals-website/evals-website/packages/enterprise-results/src/group-cohort-metrics/GroupCohort.vue"]]);

var css_248z$9 = "";
styleInject(css_248z$9);

const _sfc_main$c = {
  name: "ModalCarousel",
  props: {
    screenshots: Array,
    screenshotUrl: String,
    preview: Boolean,
  },
  data: () => ({
    screenshotDisplayed: undefined,
  }),
  methods: {
    getScreenshotNameWebp(screenshot) {
      let screenshotName = screenshot.Name || screenshot;
      if (!this.preview) screenshotName.replace(".png", ".webp");
      return screenshotName;
    },
    closeModal() {
      this.$emit("closeModal", false);
    },
  },
  watch: {
    screenshotDisplayed(value) {
      this.$emit("updateScreenshotDisplayed", value);
    },
  },
};

const _hoisted_1$a = { class: "modal-container" };
const _hoisted_2$a = {
  key: 1,
  class: "mobile-modal-details"
};
const _hoisted_3$a = { key: 1 };

function _sfc_render$a(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_carousel_item = resolveComponent("v-carousel-item");
  const _component_v_btn = resolveComponent("v-btn");
  const _component_v_col = resolveComponent("v-col");
  const _component_v_spacer = resolveComponent("v-spacer");
  const _component_v_row = resolveComponent("v-row");
  const _component_v_carousel = resolveComponent("v-carousel");

  return (openBlock(), createElementBlock("div", _hoisted_1$a, [
    createVNode(_component_v_carousel, {
      class: normalizeClass(_ctx.$vuetify.display.mobile ? 'mobile' : 'desktop'),
      "hide-delimiters": "",
      modelValue: _ctx.screenshotDisplayed,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.screenshotDisplayed) = $event))
    }, {
      next: withCtx(() => [
        (_ctx.screenshotDisplayed !== $props.screenshots.length - 1)
          ? (openBlock(), createBlock(_component_v_btn, {
              key: 0,
              icon: "mdi-chevron-right",
              class: "carousel-btn",
              density: "compact",
              "data-id": "results.modalcarousel.nextbutton",
              onClick: _cache[0] || (_cache[0] = $event => (_ctx.screenshotDisplayed++))
            }))
          : createCommentVNode("v-if", true)
      ]),
      prev: withCtx(() => [
        (_ctx.screenshotDisplayed !== 0)
          ? (openBlock(), createBlock(_component_v_btn, {
              key: 0,
              icon: "mdi-chevron-left",
              class: "carousel-btn",
              "data-id": "results.modalcarousel.previousbutton",
              density: "compact",
              onClick: _cache[1] || (_cache[1] = $event => (_ctx.screenshotDisplayed--))
            }))
          : (openBlock(), createElementBlock("div", _hoisted_3$a))
      ]),
      default: withCtx(() => [
        (openBlock(true), createElementBlock(Fragment, null, renderList($props.screenshots, (screenshot) => {
          return (openBlock(), createBlock(_component_v_carousel_item, {
            key: $options.getScreenshotNameWebp(screenshot),
            src: `${$props.screenshotUrl}${$options.getScreenshotNameWebp(screenshot)}`,
            eager: ""
          }, null, 8 /* PROPS */, ["src"]))
        }), 128 /* KEYED_FRAGMENT */)),
        (_ctx.$vuetify.display.mobile)
          ? (openBlock(), createBlock(_component_v_btn, {
              key: 0,
              icon: "mdi-close",
              class: "carousel-btn modal-mobile-close",
              density: "compact",
              onClick: $options.closeModal
            }, null, 8 /* PROPS */, ["onClick"]))
          : createCommentVNode("v-if", true),
        (_ctx.$vuetify.display.mobile && $props.screenshots[_ctx.screenshotDisplayed])
          ? (openBlock(), createElementBlock("div", _hoisted_2$a, [
              createVNode(_component_v_row, { class: "m-spacing--top-2 m-spacing--bottom-2 m-spacing--left-5 m-spacing--right-5 mk-text--body" }, {
                default: withCtx(() => [
                  createVNode(_component_v_col, { cols: "4" }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString($props.screenshots[_ctx.screenshotDisplayed].Detection_Type) + " Detection ", 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }),
                  createVNode(_component_v_spacer),
                  (
              $props.screenshots[_ctx.screenshotDisplayed].Modifiers &&
              $props.screenshots[_ctx.screenshotDisplayed].Modifiers.length
            )
                    ? (openBlock(), createBlock(_component_v_col, {
                        key: 0,
                        cols: "7",
                        class: "text-right"
                      }, {
                        default: withCtx(() => [
                          createTextVNode(" Modifier - " + toDisplayString($props.screenshots[_ctx.screenshotDisplayed].Modifiers[0]), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      }))
                    : createCommentVNode("v-if", true)
                ]),
                _: 1 /* STABLE */
              })
            ]))
          : createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["class", "modelValue"])
  ]))
}
var ModalCarousel = /*#__PURE__*/_export_sfc(_sfc_main$c, [['render',_sfc_render$a],['__file',"/home/runner/work/evals-website/evals-website/packages/enterprise-results/src/ModalCarousel.vue"]]);

const _sfc_main$b = {
    name: 'Linux Chip',
    props: {
      tooltipText: String
    }
  };

function _sfc_render$9(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_chip = resolveComponent("v-chip");
  const _component_v_tooltip = resolveComponent("v-tooltip");

  return (openBlock(), createBlock(_component_v_tooltip, {
    text: $props.tooltipText,
    "content-class": "mk-tooltip--top",
    location: "top"
  }, {
    activator: withCtx(({ props }) => [
      createVNode(_component_v_chip, mergeProps(props, { class: "mk-vue-select-chip ml-2" }), {
        default: withCtx(() => [
          createTextVNode("Linux")
        ]),
        _: 2 /* DYNAMIC */
      }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["text"]))
}
var LinuxChip = /*#__PURE__*/_export_sfc(_sfc_main$b, [['render',_sfc_render$9],['__file',"/home/runner/work/evals-website/evals-website/packages/enterprise-results/src/LinuxChip.vue"]]);

var css_248z$8 = "";
styleInject(css_248z$8);

const _sfc_main$a = {
  name: 'SubstepHeader',
  data: () => ({
  }),
  components: {
    LinuxChip
  },
  props: {
    substep: Object,
    substepNameSpacing: String,
    criteriaSpacing: String,
    selectedScenario: Object
  },
  created(){
    this.formatSubtechniqueLink = formatSubtechniqueLink;
  }
};
const _hoisted_1$9 = { key: 0 };
const _hoisted_2$9 = { key: 1 };
const _hoisted_3$9 = {
  key: 0,
  class: "mk-text--h4 mk-text--medium"
};
const _hoisted_4$9 = ["href"];
const _hoisted_5$9 = {
  key: 0,
  class: "mk-text--h4 mk-text--medium"
};
const _hoisted_6$9 = { key: 0 };
const _hoisted_7$9 = { key: 1 };
const _hoisted_8$8 = ["href"];
const _hoisted_9$7 = {
  key: 2,
  class: "m-spacing--top-3"
};
const _hoisted_10$6 = { class: "mk-vue-select-chip substep-chips pr-2 mr-1" };
const _hoisted_11$6 = ["href"];
const _hoisted_12$6 = {
  key: 0,
  class: "mk-vue-select-chip substep-chips pr-2 mr-1"
};
const _hoisted_13$5 = ["href"];
const _hoisted_14$5 = {
  key: 1,
  class: "mk-vue-select-chip substep-chips pr-2 mr-1"
};
const _hoisted_15$5 = ["href"];

function _sfc_render$8(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LinuxChip = resolveComponent("LinuxChip");
  const _component_v_chip = resolveComponent("v-chip");
  const _component_v_tooltip = resolveComponent("v-tooltip");

  return (openBlock(), createElementBlock("div", null, [
    ($props.selectedScenario.scenario_type === 'DETECTION')
      ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: normalizeClass($props.substepNameSpacing)
        }, [
          createElementVNode("div", null, [
            createElementVNode("span", {
              class: normalizeClass({'mk-text--grey60': $props.substep.Is_Setup, 'mk-text--h4': true, 'mk-text--medium': true})
            }, [
              createTextVNode(toDisplayString($props.substep.Substep) + " ", 1 /* TEXT */),
              ($props.substep.Subtechnique.Subtechnique_Name)
                ? (openBlock(), createElementBlock("span", _hoisted_1$9, " - " + toDisplayString($props.substep.Subtechnique.Subtechnique_Name), 1 /* TEXT */))
                : ($props.substep.Technique.Technique_Name)
                  ? (openBlock(), createElementBlock("span", _hoisted_2$9, " - " + toDisplayString($props.substep.Technique.Technique_Name), 1 /* TEXT */))
                  : createCommentVNode("v-if", true)
            ], 2 /* CLASS */),
            ($props.substep.Technique.Technique_Id)
              ? (openBlock(), createElementBlock("span", _hoisted_3$9, [
                  createTextVNode(" ("),
                  createElementVNode("a", {
                    class: "mk-text--hover",
                    href: `${_ctx.$mitreAttackExternalLink}techniques/${$props.substep.Subtechnique.Subtechnique_Id 
          ? _ctx.formatSubtechniqueLink($props.substep) : $props.substep.Technique.Technique_Id}`,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    "data-id": "results.evaluationdetails.substepheader.techniquelink"
                  }, toDisplayString($props.substep.Subtechnique.Subtechnique_Id || $props.substep.Technique.Technique_Id), 9 /* TEXT, PROPS */, _hoisted_4$9),
                  createTextVNode(") ")
                ]))
              : createCommentVNode("v-if", true),
            ($props.substep.Capability_Requirements.includes('Linux Capability'))
              ? (openBlock(), createBlock(_component_LinuxChip, {
                  key: 1,
                  tooltipText: "Substep was executed in a Linux environment"
                }))
              : createCommentVNode("v-if", true),
            ($props.substep.Capability_Requirements.includes('False Positive'))
              ? (openBlock(), createBlock(_component_v_chip, {
                  key: 2,
                  class: "mk-vue-select-chip ml-2"
                }, {
                  default: withCtx(() => [
                    createTextVNode("Noise")
                  ]),
                  _: 1 /* STABLE */
                }))
              : createCommentVNode("v-if", true)
          ]),
          createElementVNode("div", {
            class: normalizeClass({'mk-text--regular wrap-break-word': true, 'mk-text--grey60': $props.substep.Is_Setup})
          }, toDisplayString($props.substep.Criteria), 3 /* TEXT, CLASS */)
        ], 2 /* CLASS */))
      : (openBlock(), createElementBlock("div", {
          key: 1,
          class: normalizeClass($props.substepNameSpacing)
        }, [
          createElementVNode("span", {
            class: normalizeClass({'mk-text--grey60': $props.substep.Is_Setup, 'mk-text--h4': true, 'mk-text--medium': true})
          }, [
            createTextVNode(toDisplayString($props.substep.Substep) + " ", 1 /* TEXT */),
            ($props.substep.Technique.Technique_Id)
              ? (openBlock(), createElementBlock("span", _hoisted_5$9, [
                  ($props.substep.Subtechnique.Subtechnique_Name)
                    ? (openBlock(), createElementBlock("span", _hoisted_6$9, " - " + toDisplayString($props.substep.Subtechnique.Subtechnique_Name), 1 /* TEXT */))
                    : ($props.substep.Technique.Technique_Name)
                      ? (openBlock(), createElementBlock("span", _hoisted_7$9, " - " + toDisplayString($props.substep.Technique.Technique_Name), 1 /* TEXT */))
                      : createCommentVNode("v-if", true),
                  createTextVNode(" ("),
                  createElementVNode("a", {
                    class: "mk-text--hover",
                    href: `${_ctx.$mitreAttackExternalLink}techniques/${$props.substep.Subtechnique.Subtechnique_Id ? _ctx.formatSubtechniqueLink($props.substep) : $props.substep.Technique.Technique_Id}`,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    "data-id": "results.evaluationdetails.substepheader.techniquelink"
                  }, toDisplayString($props.substep.Subtechnique.Subtechnique_Id || $props.substep.Technique.Technique_Id), 9 /* TEXT, PROPS */, _hoisted_8$8),
                  createTextVNode(") ")
                ]))
              : createCommentVNode("v-if", true)
          ], 2 /* CLASS */),
          ($props.substep.Capability_Requirements.includes('Linux Capability'))
            ? (openBlock(), createBlock(_component_LinuxChip, {
                key: 0,
                tooltipText: "Substep executed in a Linux environment"
              }))
            : createCommentVNode("v-if", true),
          ($props.substep.Capability_Requirements.includes('False Positive'))
            ? (openBlock(), createBlock(_component_v_chip, {
                key: 1,
                class: "mk-vue-select-chip ml-2"
              }, {
                default: withCtx(() => [
                  createTextVNode("Noise")
                ]),
                _: 1 /* STABLE */
              }))
            : createCommentVNode("v-if", true),
          createElementVNode("div", {
            class: normalizeClass($props.criteriaSpacing)
          }, [
            createTextVNode(toDisplayString($props.selectedScenario.name) + " Step ", 1 /* TEXT */),
            createVNode(_component_v_tooltip, {
              text: $props.substep.Criteria,
              "content-class": "mk-tooltip--right"
            }, {
              activator: withCtx(({ props }) => [
                createElementVNode("span", normalizeProps(guardReactiveProps(props)), "(" + toDisplayString($props.substep.Substep) + ")", 17 /* TEXT, FULL_PROPS */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["text"])
          ], 2 /* CLASS */)
        ], 2 /* CLASS */)),
    (!$props.substep.Is_Setup)
      ? (openBlock(), createElementBlock("div", _hoisted_9$7, [
          createElementVNode("span", _hoisted_10$6, [
            createTextVNode(toDisplayString($props.substep.Tactic.Tactic_Name) + " (", 1 /* TEXT */),
            createElementVNode("a", {
              class: "mk-text--hover",
              href: `${_ctx.$mitreAttackExternalLink}tactics/${$props.substep.Tactic.Tactic_Id}`,
              target: "_blank",
              rel: "noopener noreferrer",
              "data-id": "results.evaluationdetails.substepheader.tacticlink"
            }, toDisplayString($props.substep.Tactic.Tactic_Id), 9 /* TEXT, PROPS */, _hoisted_11$6),
            createTextVNode(") ")
          ]),
          ($props.substep.Technique.Technique_Id)
            ? (openBlock(), createElementBlock("span", _hoisted_12$6, [
                createTextVNode(toDisplayString($props.substep.Technique.Technique_Name) + " (", 1 /* TEXT */),
                createElementVNode("a", {
                  class: "mk-text--hover",
                  href: `${_ctx.$mitreAttackExternalLink}techniques/${$props.substep.Technique.Technique_Id}`,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  "data-id": "results.evaluationdetails.substepheader.techniquelink"
                }, toDisplayString($props.substep.Technique.Technique_Id), 9 /* TEXT, PROPS */, _hoisted_13$5),
                createTextVNode(") ")
              ]))
            : createCommentVNode("v-if", true),
          ($props.substep.Subtechnique.Subtechnique_Name)
            ? (openBlock(), createElementBlock("span", _hoisted_14$5, [
                createTextVNode(toDisplayString($props.substep.Subtechnique.Subtechnique_Name.slice($props.substep.Subtechnique.Subtechnique_Name.indexOf(':') + 2)) + " (", 1 /* TEXT */),
                createElementVNode("a", {
                  class: "mk-text--hover",
                  href: `${_ctx.$mitreAttackExternalLink}techniques/${_ctx.formatSubtechniqueLink($props.substep)}/`,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  "data-id": "results.evaluationdetails.substepheader.subtechniquelink"
                }, toDisplayString($props.substep.Subtechnique.Subtechnique_Id), 9 /* TEXT, PROPS */, _hoisted_15$5),
                createTextVNode(") ")
              ]))
            : createCommentVNode("v-if", true)
        ]))
      : (openBlock(), createBlock(_component_v_chip, {
          key: 3,
          label: "",
          class: "mt-2"
        }, {
          default: withCtx(() => [
            createTextVNode("Setup Substep")
          ]),
          _: 1 /* STABLE */
        }))
  ]))
}
var SubstepHeader = /*#__PURE__*/_export_sfc(_sfc_main$a, [['render',_sfc_render$8],['__scopeId',"data-v-dff8f283"],['__file',"/home/runner/work/evals-website/evals-website/packages/enterprise-results/src/SubstepHeader.vue"]]);

var css_248z$7 = "";
styleInject(css_248z$7);

const _sfc_main$9 = {
    name: 'EvaluationDetailModal',
    data: () => ({
      screenshotDisplayed: undefined,
      showActionButtons: false,
      route: useRoute(),
    }),
    components: {
      SubstepHeader,
      ModalCarousel,
    },
    props: {
      vendorData: Object,
      selectedScenario: Object,
      substep: Object,
      getResultColor: Function,
      selectedEvaluation: Object,
      screenshotUrl: String,
      preview: Boolean
    },
    methods: {
      closeModal(){
        this.$emit("updateEvaluationDetailModalOpen", false);
      },
      updateScreenshotDisplayed(value){
        this.screenshotDisplayed = value;
      }
    },
    computed: {
      screenshots(){
        if(Array.isArray(this.vendorData.Results)){
          let detections = this.vendorData.Results.filter(detection => detection.Include);
          let screenshots = detections.map(detection => {
            detection.Screenshots.map(screenshot => {
              screenshot.Detection_Type = detection.Detection_Type;
              screenshot.Modifiers = detection.Modifiers;
              return screenshot;
            });
            return detection.Screenshots;
          });
          screenshots = screenshots.flat();
          return screenshots;
        }
        else {
          let screenshots = this.vendorData.Results.Screenshots.map(screenshot => {
            screenshot.Detection_Type = this.vendorData.Results.Protection_Type;
            screenshot.Modifiers = this.vendorData.Results.Modifiers;
            return screenshot;
          });
          return screenshots;
        }
      }
    },
};
const _hoisted_1$8 = { class: "mk-text--h5" };
const _hoisted_2$8 = { class: "mb-auto" };
const _hoisted_3$8 = ["href"];
const _hoisted_4$8 = ["href"];
const _hoisted_5$8 = { class: "mk-text--body" };
const _hoisted_6$8 = { class: "mk-text--grey60 mk-text--h5" };
const _hoisted_7$8 = { class: "mk-text--caption" };
const _hoisted_8$7 = { key: 0 };
const _hoisted_9$6 = { class: "mk-text--grey60 mk-text--h5" };

function _sfc_render$7(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ModalCarousel = resolveComponent("ModalCarousel");
  const _component_SubstepHeader = resolveComponent("SubstepHeader");
  const _component_v_col = resolveComponent("v-col");
  const _component_v_icon = resolveComponent("v-icon");
  const _component_v_row = resolveComponent("v-row");
  const _component_v_card_text = resolveComponent("v-card-text");
  const _component_v_card = resolveComponent("v-card");

  return (openBlock(), createBlock(_component_v_card, { color: "white" }, {
    default: withCtx(() => [
      (_ctx.$vuetify.display.mobile)
        ? (openBlock(), createBlock(_component_ModalCarousel, {
            key: 0,
            screenshots: $options.screenshots,
            screenshotUrl: $props.screenshotUrl,
            onUpdateScreenshotDisplayed: $options.updateScreenshotDisplayed,
            onCloseModal: $options.closeModal
          }, null, 8 /* PROPS */, ["screenshots", "screenshotUrl", "onUpdateScreenshotDisplayed", "onCloseModal"]))
        : (openBlock(), createBlock(_component_v_card_text, {
            key: 1,
            onMouseenter: _cache[1] || (_cache[1] = $event => (_ctx.showActionButtons = true)),
            onMouseleave: _cache[2] || (_cache[2] = $event => (_ctx.showActionButtons = false))
          }, {
            default: withCtx(() => [
              createElementVNode("div", null, [
                createVNode(_component_v_row, null, {
                  default: withCtx(() => [
                    createVNode(_component_v_col, { cols: "10" }, {
                      default: withCtx(() => [
                        createElementVNode("span", _hoisted_1$8, toDisplayString($props.vendorData.Vendor_Details.display_name), 1 /* TEXT */),
                        createVNode(_component_SubstepHeader, {
                          substep: $props.substep,
                          substepNameSpacing: "m-spacing--top-2",
                          criteriaSpacing: "m-spacing--top-2",
                          selectedScenario: $props.selectedScenario
                        }, null, 8 /* PROPS */, ["substep", "selectedScenario"])
                      ]),
                      _: 1 /* STABLE */
                    }),
                    createVNode(_component_v_col, {
                      cols: "2",
                      class: "text-right d-flex flex-column"
                    }, {
                      default: withCtx(() => [
                        createElementVNode("div", _hoisted_2$8, [
                          ($props.selectedEvaluation.domain !== 'MANAGED_SERVICES')
                            ? (openBlock(), createElementBlock("a", {
                                key: 0,
                                href: `/results/${_ctx.route.params.domain}/${$props.vendorData.Vendor_Name}/${$props.selectedEvaluation.name}_configuration`,
                                target: "_blank",
                                class: normalizeClass({'mk-link--disabled': $props.preview}),
                                rel: "noopener noreferrer",
                                "data-id": "results.evaluationdetails.evaluationdetailmodal.participantconfigurationlink"
                              }, [
                                createElementVNode("span", {
                                  class: normalizeClass({
                    'mk-text--grey60 icon--hover': _ctx.showActionButtons,
                    'c-text--white': !_ctx.showActionButtons,
                    'material-symbols-rounded icon--hover': true
                  })
                                }, "settings", 2 /* CLASS */)
                              ], 10 /* CLASS, PROPS */, _hoisted_3$8))
                            : createCommentVNode("v-if", true),
                          ($options.screenshots[_ctx.screenshotDisplayed])
                            ? (openBlock(), createElementBlock("a", {
                                key: 1,
                                href: `${$props.screenshotUrl}${$options.screenshots[_ctx.screenshotDisplayed].Name}`,
                                download: "",
                                "data-id": "results.evaluationdetails.evaluationdetailmodal.downloadscreenshotbutton"
                              }, [
                                createElementVNode("span", {
                                  class: normalizeClass({
                    'mk-text--grey60 icon--hover c-text--cursor-pointer': _ctx.showActionButtons,
                    'c-text--white': !_ctx.showActionButtons,
                    'material-symbols-rounded icon--hover': true
                  })
                                }, "download", 2 /* CLASS */)
                              ], 8 /* PROPS */, _hoisted_4$8))
                            : createCommentVNode("v-if", true),
                          createElementVNode("span", {
                            class: normalizeClass({
                  'mk-text--grey60 icon--hover c-text--cursor-pointer': _ctx.showActionButtons,
                  'c-text--white': !_ctx.showActionButtons,
                  'material-symbols-rounded icon--hover': true
                }),
                            "data-id": "results.evaluationdetails.evaluationdetailmodal.closemodalbutton",
                            onClick: _cache[0] || (_cache[0] = (...args) => ($options.closeModal && $options.closeModal(...args)))
                          }, "close ", 2 /* CLASS */)
                        ]),
                        createElementVNode("div", _hoisted_5$8, [
                          createTextVNode(toDisplayString($options.screenshots[_ctx.screenshotDisplayed] && $options.screenshots[_ctx.screenshotDisplayed].Detection_Type) + " ", 1 /* TEXT */),
                          createVNode(_component_v_icon, {
                            color: $options.screenshots[_ctx.screenshotDisplayed] && $props.getResultColor($options.screenshots[_ctx.screenshotDisplayed]),
                            class: "detection-level-box"
                          }, {
                            default: withCtx(() => [
                              createTextVNode(" mdi-square-rounded ")
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["color"])
                        ])
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                }),
                createVNode(_component_v_row, null, {
                  default: withCtx(() => [
                    createVNode(_component_v_col, { class: "col--no-spacing-bottom" }, {
                      default: withCtx(() => [
                        createVNode(_component_ModalCarousel, {
                          screenshots: $options.screenshots,
                          screenshotUrl: $props.screenshotUrl,
                          onUpdateScreenshotDisplayed: $options.updateScreenshotDisplayed
                        }, null, 8 /* PROPS */, ["screenshots", "screenshotUrl", "onUpdateScreenshotDisplayed"])
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                }),
                createVNode(_component_v_row, { class: "m-spacing--top-5 m-spacing--bottom-5" }, {
                  default: withCtx(() => [
                    ($options.screenshots[_ctx.screenshotDisplayed] && $options.screenshots[_ctx.screenshotDisplayed].Data_Sources.length)
                      ? (openBlock(), createBlock(_component_v_col, {
                          key: 0,
                          cols: "5",
                          class: "c-col--no-padding-bottom c-col--no-padding-top"
                        }, {
                          default: withCtx(() => [
                            createElementVNode("span", _hoisted_6$8, toDisplayString($options.screenshots[_ctx.screenshotDisplayed].Data_Sources.length > 1 ? "Data Sources" : "Data Source"), 1 /* TEXT */),
                            (openBlock(true), createElementBlock(Fragment, null, renderList($options.screenshots[_ctx.screenshotDisplayed].Data_Sources, (dataSource) => {
                              return (openBlock(), createElementBlock("div", {
                                class: "mk-text--body",
                                key: dataSource
                              }, toDisplayString(dataSource), 1 /* TEXT */))
                            }), 128 /* KEYED_FRAGMENT */))
                          ]),
                          _: 1 /* STABLE */
                        }))
                      : createCommentVNode("v-if", true),
                    createVNode(_component_v_col, {
                      cols: $options.screenshots[_ctx.screenshotDisplayed] && $options.screenshots[_ctx.screenshotDisplayed].Data_Sources.length ? 2 : 12,
                      class: "c-col--no-padding-bottom c-col--no-padding-top text-center"
                    }, {
                      default: withCtx(() => [
                        createElementVNode("span", _hoisted_7$8, "Screenshot " + toDisplayString(_ctx.screenshotDisplayed + 1) + " of " + toDisplayString($options.screenshots.length), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["cols"]),
                    createVNode(_component_v_col, {
                      cols: "5",
                      class: "c-col--no-padding-bottom c-col--no-padding-top text-right"
                    }, {
                      default: withCtx(() => [
                        ($options.screenshots[_ctx.screenshotDisplayed] && $options.screenshots[_ctx.screenshotDisplayed].Modifiers.length)
                          ? (openBlock(), createElementBlock("div", _hoisted_8$7, [
                              createElementVNode("span", _hoisted_9$6, toDisplayString($options.screenshots[_ctx.screenshotDisplayed].Modifiers.length > 1 ? "Modifier" : "Modifiers"), 1 /* TEXT */),
                              (openBlock(true), createElementBlock(Fragment, null, renderList($options.screenshots[_ctx.screenshotDisplayed].Modifiers, (modifier) => {
                                return (openBlock(), createElementBlock("div", {
                                  class: "mk-text--body",
                                  key: modifier
                                }, toDisplayString(modifier), 1 /* TEXT */))
                              }), 128 /* KEYED_FRAGMENT */))
                            ]))
                          : createCommentVNode("v-if", true)
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                })
              ])
            ]),
            _: 1 /* STABLE */
          }))
    ]),
    _: 1 /* STABLE */
  }))
}
var EvaluationDetailModal = /*#__PURE__*/_export_sfc(_sfc_main$9, [['render',_sfc_render$7],['__scopeId',"data-v-65b1c89e"],['__file',"/home/runner/work/evals-website/evals-website/packages/enterprise-results/src/EvaluationDetailModal.vue"]]);

var css_248z$6 = "";
styleInject(css_248z$6);

const _sfc_main$8 = {
  name: 'EvaluationDetails',
  props: {
    selectedVendors: Array,
    comparisonData: Array,
    evaluationSteps: Array,
    evalResultCategoriesNames: Array,
    adversaryChartColors: Array,
    selectedScenario: Object,
    selectedEvaluation: Object,
    checkIfStepProtected: Function,
    chartLegendScrollToTopOverlap: Boolean,
    getTooltipText: Function,
    screenshotUrl: String,
    preview: Boolean,
    showSetup: Boolean,
    isScrollToTopBtnDisplayed: Boolean
  },
  components: {
    EvaluationDetailModal,
    LinuxChip,
    SubstepHeader,
  },

  data: () => ({
    comparisonDataVendorsFiltered: [],
    showAllTechniquesDict: {},
    screenshotHeightLonger: '277px',
    screenshotHeightShorter: '185px',
    evaluationDetailModalOpen: false,
    modalVendorData: undefined,
    modalSubstep: undefined,
    hoverScreenshotDictionary: {},
    scrollToTopBtnStyle: "",
    isMobileLandscape: false,
  }),

  methods: {
    notAllResultsAreNa(substep) {
      return !substep.Vendor_Data.every(vendor => {
        const result = vendor.Results.length ? vendor.Results[0] : vendor.Results;
        return result.Protection_Type === 'Not applicable'
      })
    },
    openScreenshotInNewTab(screenshot) {
      window.open(`${this.$imageSrc}${screenshot.name}`, '_blank');
    },
    vendorStepHasMTTD(step, vendor) {
      const hasStepStartDate = this.getVendorStepData(step, vendor)?.Step_Start_Date;
      const hasStepAlertDate = this.getVendorStepData(step, vendor)?.Step_Alert_Date;
      return hasStepAlertDate && hasStepStartDate;
    },
    formatDate(stringDate) {
      const dateObj = new Date(stringDate);
      const utcMonth = dateObj.getUTCMonth();
      const utcYear = dateObj.getUTCFullYear();
      const utcDate = dateObj.getUTCDate();
      const utcHours = dateObj.getUTCHours();
      const utcMins = dateObj.getUTCMinutes();
      const monthNames = [
       'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
      ];
      return `${monthNames[utcMonth]} ${utcDate} ${utcYear}, ${utcHours}:${utcMins} UTC`;
    },
    getVendorStepData(step, vendor) {
      return this.comparisonDataVendorsFiltered.find(
              s => s.Step_Num === step.Step_Num
            ).Step_Vendor_Data.find(
              v => v.Vendor_Name === vendor.name
            )
    },
    getTimeToDetect(step, vendor) {
      const stepData = this.getVendorStepData(step, vendor);
      const stepStartTime = new Date(stepData.Step_Start_Date).getTime();
      const alertTime = new Date(stepData.Step_Alert_Date).getTime();
      return (alertTime - stepStartTime) / 60000 ;
    },
    getFilteredSubsteps(step){
      if (this.showSetup) {
        return step.Substeps.filter(substep => substep.checked);
      }
      return step.Substeps.filter(substep => substep.checked && !substep.Is_Setup);
    },
    scrollToTop(){
      if(!this.$vuetify.display.mobile) {
        const overviewColumn = document.getElementById("overviewCol");
        overviewColumn.scrollTo({ top: 0, behavior: 'smooth'});
      }
      else {
        window.scrollTo({ top: 0, behavior: 'smooth'});
      }

    },
    moreSubstepsInStep(stepNum){
      let substeps = this.comparisonDataVendorsFiltered.find(step => step.Step_Num === stepNum).Substeps;
      substeps = substeps.filter(substep => substep.Include);
      let substepsAllVendorsNa = substeps.filter(substep => {
        return substep.Vendor_Data.every(vendor => {
          const result = vendor.Results.length ? vendor.Results[0] : vendor.Results;
          return result.Protection_Type === 'Not applicable'
        });
      });
      return substepsAllVendorsNa.length > 0;
    },
    updateEvaluationDetailModalOpen(value){
      this.evaluationDetailModalOpen = value;
    },
    getResultColor(result) {
      let type = result.Detection_Type ? result.Detection_Type : result.Protection_Type;
      return this.adversaryChartColors[this.evalResultCategoriesNames.indexOf(type)];
    },
    getMostSpecificResultColor(substep, vendorData) {
      return substep.Capability_Requirements.includes('False Positive') ? getNoiseResultCategoryColor(vendorData.Results[0].Detection_Type) : this.getResultColor(this.getMostSpecificDetection(vendorData));
    },
    getMostSpecificDetection(vendorData) {
      if (this.selectedScenario.scenario_type === "PROTECTION") {
        return vendorData.Results.length ? vendorData.Results[0] : vendorData.Results;
      }
      let mostSpecificDetection = vendorData.Results.find((detection) => detection.Include);
      // if detection has a modifier and is filtered out, and there are no other detections, detection is None
      if (!mostSpecificDetection){
        mostSpecificDetection = {
          Detection_Type: "None",
          Include: true,
          Screenshots: [],
          Modifiers: [],
          Footnotes: [],
        };
        if (this.selectedEvaluation.domain === "MANAGED_SERVICES") {
          mostSpecificDetection.Detection_Type = "Not reported";
        }
      }
      return mostSpecificDetection;
    },

    getMostSpecificScreenshot(vendorData) {
      return this.getMostSpecificDetection(vendorData).Screenshots[0];
    },
    getMostSpecificScreenshotWebp(vendorData){
      return this.getMostSpecificScreenshot(vendorData).Name.replace('.png', '.webp');
    },
    openEvaluationModal(vendorData, substep){
      this.modalVendorData = vendorData;
      this.modalSubstep = substep;
      this.evaluationDetailModalOpen = true;
    },
    handleOrientationChange(){
      this.isMobileLandscape = this.$vuetify.display.mobile && window.screen.orientation.type === "landscape-primary";
    },
  },
  watch:  {
    comparisonData(){
      let hoverScreenshotDictionary = {};
      this.comparisonDataVendorsFiltered = this.comparisonData.map(step => {
        this.showAllTechniquesDict[step.Step_Num] = false;
        step.Substeps.map(substep => {
          substep.Vendor_Data = substep.Vendor_Data.filter(vendorData => this.selectedVendors.map(vendorObj => vendorObj.name).includes(vendorData.Vendor_Name));
           hoverScreenshotDictionary[substep.Substep] = {};
           substep.Vendor_Data.forEach(vendor => {
            hoverScreenshotDictionary[substep.Substep][vendor.Vendor_Name] = false;
          });
          return substep;
        });
        return step;
      });
      this.hoverScreenshotDictionary = hoverScreenshotDictionary;
    },
  },
  created () {
    this.handleOrientationChange();

    window.addEventListener(
      "orientationchange",
      this.handleOrientationChange
    );
  },
  unmounted () {
    window.removeEventListener('orientationchange', this.handleOrientationChange);
  },
};

const _hoisted_1$7 = {
  key: 0,
  class: "mb-5"
};
const _hoisted_2$7 = /*#__PURE__*/createElementVNode("div", { class: "m-spacing--top-9 mk-text--h1 text-left" }, "Evaluation Details", -1 /* HOISTED */);
const _hoisted_3$7 = ["innerHTML"];
const _hoisted_4$7 = { class: "m-spacing--top-9 mk-text--h2 text-left" };
const _hoisted_5$7 = ["id"];
const _hoisted_6$7 = {
  key: 0,
  class: "m-spacing--top-9"
};
const _hoisted_7$7 = { class: "text-left step-name-div" };
const _hoisted_8$6 = { class: "mk-text--h3 number-box text-center" };
const _hoisted_9$5 = { class: "mk-text--h3 text-left ml-2" };
const _hoisted_10$5 = { class: "m-spacing--top-4 text-left" };
const _hoisted_11$5 = ["innerHTML"];
const _hoisted_12$5 = { key: 0 };
const _hoisted_13$4 = { class: "mk-text--h5 text-left" };
const _hoisted_14$4 = { class: "d-flex" };
const _hoisted_15$4 = { class: "time-to-detect" };
const _hoisted_16$3 = /*#__PURE__*/createElementVNode("div", null, "START", -1 /* HOISTED */);
const _hoisted_17$3 = { class: "mk-text--regular" };
const _hoisted_18$2 = /*#__PURE__*/createElementVNode("hr", { class: "dotted-line" }, null, -1 /* HOISTED */);
const _hoisted_19$2 = /*#__PURE__*/createElementVNode("span", { class: "mx-5 material-symbols-rounded" }, " avg_pace ", -1 /* HOISTED */);
const _hoisted_20$2 = /*#__PURE__*/createElementVNode("hr", { class: "dotted-line" }, null, -1 /* HOISTED */);
const _hoisted_21$2 = /*#__PURE__*/createElementVNode("div", null, "DETECTION", -1 /* HOISTED */);
const _hoisted_22$2 = { class: "mk-text--regular" };
const _hoisted_23$2 = { class: "text-center" };
const _hoisted_24$2 = /*#__PURE__*/createElementVNode("div", { class: "mk-text--grey90 m-spacing--top-3" }, "No image collected", -1 /* HOISTED */);
const _hoisted_25$2 = {
  key: 0,
  class: "m-spacing--top-7"
};
const _hoisted_26$2 = { class: "m-spacing--top-7 mk-text--h5 mk-text--medium mk-text--grey90" };
const _hoisted_27$2 = { class: "m-spacing--left-3 mk-text--body mk-text--grey90 mk-text--medium" };
const _hoisted_28$1 = /*#__PURE__*/createElementVNode("p", null, "We used an alternate step to evaluate these TTPs.", -1 /* HOISTED */);
const _hoisted_29$1 = /*#__PURE__*/createElementVNode("span", null, [
  /*#__PURE__*/createTextVNode("Actionable detections include some or all of the following as applicable: activity, time, location, users, and context. "),
  /*#__PURE__*/createElementVNode("a", {
    href: "/managed-services/managed-services-2/",
    target: "_blank"
  }, "Learn More")
], -1 /* HOISTED */);
const _hoisted_30$1 = {
  key: 0,
  class: "text-left"
};
const _hoisted_31$1 = { class: "screenshot-div" };
const _hoisted_32$1 = {
  key: 0,
  class: "m-spacing--top-3"
};
const _hoisted_33$1 = { class: "mk-text--grey90 mk-text--body mk-text--medium" };
const _hoisted_34$2 = { key: 0 };
const _hoisted_35$1 = { class: "mk-text--grey90 mk-text--body mk-text--medium" };
const _hoisted_36$1 = { class: "text-center" };
const _hoisted_37$1 = { key: 0 };
const _hoisted_38$1 = /*#__PURE__*/createElementVNode("div", { class: "mk-text--grey90 m-spacing--top-3" }, "No image collected", -1 /* HOISTED */);
const _hoisted_39$1 = { key: 1 };
const _hoisted_40$1 = /*#__PURE__*/createElementVNode("div", { class: "mk-text--grey90 m-spacing--top-3" }, "Protected", -1 /* HOISTED */);
const _hoisted_41$1 = {
  key: 2,
  class: "m-spacing--top-3"
};
const _hoisted_42$1 = { class: "mk-text--grey90 mk-text--body mk-text--medium" };

function _sfc_render$6(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_btn = resolveComponent("v-btn");
  const _component_LinuxChip = resolveComponent("LinuxChip");
  const _component_v_col = resolveComponent("v-col");
  const _component_v_row = resolveComponent("v-row");
  const _component_v_carousel_item = resolveComponent("v-carousel-item");
  const _component_v_carousel = resolveComponent("v-carousel");
  const _component_v_icon = resolveComponent("v-icon");
  const _component_SubstepHeader = resolveComponent("SubstepHeader");
  const _component_v_tooltip = resolveComponent("v-tooltip");
  const _component_v_chip = resolveComponent("v-chip");
  const _component_v_img = resolveComponent("v-img");
  const _component_EvaluationDetailModal = resolveComponent("EvaluationDetailModal");
  const _component_v_dialog = resolveComponent("v-dialog");

  return ($props.selectedVendors && $props.selectedVendors.length)
    ? (openBlock(), createElementBlock("div", _hoisted_1$7, [
        createVNode(_component_v_row, null, {
          default: withCtx(() => [
            createCommentVNode(" empty space so evaluation details line up correctly with charts "),
            createVNode(Transition, null, {
              default: withCtx(() => [
                ($props.isScrollToTopBtnDisplayed)
                  ? (openBlock(), createBlock(_component_v_btn, {
                      key: 0,
                      color: "primary",
                      id: "scroll-to-top-btn",
                      icon: "mdi-arrow-up",
                      onClick: $options.scrollToTop,
                      class: normalizeClass({
            'fixed-btn': true,
            'scroll-to-top-button': !_ctx.$vuetify.display.mobile,
            'scroll-to-top-button--mobile': _ctx.$vuetify.display.mobile
          }),
                      "data-id": "results.evaluationdetails.scrolltotopbutton"
                    }, null, 8 /* PROPS */, ["onClick", "class"]))
                  : createCommentVNode("v-if", true)
              ]),
              _: 1 /* STABLE */
            }),
            createVNode(_component_v_col, { id: "evaluationDetailsCol" }, {
              default: withCtx(() => [
                createCommentVNode(" Evaluation details header "),
                _hoisted_2$7,
                createElementVNode("div", {
                  class: "m-spacing--top-5 text-left",
                  innerHTML: $props.selectedScenario.emulation_plan_description
                }, null, 8 /* PROPS */, _hoisted_3$7),
                createElementVNode("div", _hoisted_4$7, toDisplayString($props.selectedScenario.scenario_type === 'DETECTION' ? 'Steps' : 'Tests'), 1 /* TEXT */),
                createCommentVNode(" steps "),
                (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.comparisonDataVendorsFiltered, (step) => {
                  return (openBlock(), createElementBlock("div", {
                    key: step.Step_Num,
                    id: `${step.Step_Num}_details`
                  }, [
                    createCommentVNode(" do not render step if all substeps are filtered out "),
                    (
              !step.Substeps.every(substep => !substep.Include)
              && (!step.Substeps.every(substep => substep.Is_Setup) || $props.showSetup)
              && step.checked
            )
                      ? (openBlock(), createElementBlock("div", _hoisted_6$7, [
                          createElementVNode("div", _hoisted_7$7, [
                            createElementVNode("span", _hoisted_8$6, toDisplayString(step.Step_Num), 1 /* TEXT */),
                            createElementVNode("span", _hoisted_9$5, toDisplayString(step.Step_Name), 1 /* TEXT */),
                            (step.Substeps.some(substep => substep.Capability_Requirements.includes('Linux Capability')))
                              ? (openBlock(), createBlock(_component_LinuxChip, {
                                  key: 0,
                                  tooltipText: $props.getTooltipText(step)
                                }, null, 8 /* PROPS */, ["tooltipText"]))
                              : createCommentVNode("v-if", true)
                          ]),
                          createElementVNode("div", _hoisted_10$5, [
                            createElementVNode("span", {
                              innerHTML: step.Step_Description
                            }, null, 8 /* PROPS */, _hoisted_11$5)
                          ]),
                          ($props.selectedEvaluation.domain === 'MANAGED_SERVICES' && $props.selectedEvaluation.start_year >= 2024)
                            ? (openBlock(), createBlock(_component_v_row, {
                                key: 0,
                                class: "mt-4"
                              }, {
                                default: withCtx(() => [
                                  (openBlock(true), createElementBlock(Fragment, null, renderList($props.selectedVendors, (vendor) => {
                                    return (openBlock(), createBlock(_component_v_col, {
                                      key: vendor.id,
                                      cols: $props.selectedVendors.length === 1 ? 6 : 12 / $props.selectedVendors.length,
                                      id: "time-to-detect-col"
                                    }, {
                                      default: withCtx(() => [
                                        ($options.getVendorStepData(step, vendor) && $options.getVendorStepData(step, vendor).Step_Screenshots.length)
                                          ? (openBlock(), createElementBlock("div", _hoisted_12$5, [
                                              createElementVNode("div", _hoisted_13$4, toDisplayString(vendor.display_name), 1 /* TEXT */),
                                              createElementVNode("div", _hoisted_14$4, [
                                                createElementVNode("div", _hoisted_15$4, [
                                                  createVNode(_component_v_row, null, {
                                                    default: withCtx(() => [
                                                      createVNode(_component_v_col, { class: "text-left" }, {
                                                        default: withCtx(() => [
                                                          _hoisted_16$3,
                                                          createElementVNode("div", _hoisted_17$3, toDisplayString($options.vendorStepHasMTTD(step, vendor) ? $options.formatDate($options.getVendorStepData(step, vendor).Step_Start_Date) : 'N/A'), 1 /* TEXT */)
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                      }, 1024 /* DYNAMIC_SLOTS */),
                                                      createVNode(_component_v_col, null, {
                                                        default: withCtx(() => [
                                                          createVNode(_component_v_row, null, {
                                                            default: withCtx(() => [
                                                              createVNode(_component_v_col, { class: "dotted-line-col" }, {
                                                                default: withCtx(() => [
                                                                  _hoisted_18$2
                                                                ]),
                                                                _: 1 /* STABLE */
                                                              }),
                                                              createVNode(_component_v_col, null, {
                                                                default: withCtx(() => [
                                                                  _hoisted_19$2,
                                                                  createElementVNode("div", null, toDisplayString($options.vendorStepHasMTTD(step, vendor) ? `${$options.getTimeToDetect(step, vendor)} mins` : 'N/A'), 1 /* TEXT */)
                                                                ]),
                                                                _: 2 /* DYNAMIC */
                                                              }, 1024 /* DYNAMIC_SLOTS */),
                                                              createVNode(_component_v_col, { class: "dotted-line-col" }, {
                                                                default: withCtx(() => [
                                                                  _hoisted_20$2
                                                                ]),
                                                                _: 1 /* STABLE */
                                                              })
                                                            ]),
                                                            _: 2 /* DYNAMIC */
                                                          }, 1024 /* DYNAMIC_SLOTS */)
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                      }, 1024 /* DYNAMIC_SLOTS */),
                                                      createVNode(_component_v_col, { class: "text-right" }, {
                                                        default: withCtx(() => [
                                                          _hoisted_21$2,
                                                          createElementVNode("div", _hoisted_22$2, toDisplayString($options.vendorStepHasMTTD(step, vendor) ? $options.formatDate($options.getVendorStepData(step, vendor).Step_Alert_Date) : 'N/A'), 1 /* TEXT */)
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                      }, 1024 /* DYNAMIC_SLOTS */)
                                                    ]),
                                                    _: 2 /* DYNAMIC */
                                                  }, 1024 /* DYNAMIC_SLOTS */),
                                                  ($options.vendorStepHasMTTD(step, vendor))
                                                    ? (openBlock(), createBlock(_component_v_carousel, {
                                                        key: 0,
                                                        "hide-delimiters": "",
                                                        class: "time-to-detect-carousel",
                                                        "show-arrows": $options.getVendorStepData(step, vendor).Step_Screenshots.length > 1 ? 'hover' : false
                                                      }, {
                                                        default: withCtx(() => [
                                                          (openBlock(true), createElementBlock(Fragment, null, renderList($options.getVendorStepData(step, vendor).Step_Screenshots, (screenshot) => {
                                                            return (openBlock(), createBlock(_component_v_carousel_item, {
                                                              key: screenshot.name,
                                                              src: `${_ctx.$imageSrc}${screenshot.name}`,
                                                              eager: "",
                                                              onClick: $event => ($options.openScreenshotInNewTab(screenshot))
                                                            }, null, 8 /* PROPS */, ["src", "onClick"]))
                                                          }), 128 /* KEYED_FRAGMENT */))
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["show-arrows"]))
                                                    : (openBlock(), createElementBlock("div", {
                                                        key: 1,
                                                        class: normalizeClass({
                            'no-screenshot-placeholder--longer': $props.selectedVendors.length < 3,
                            'no-screenshot-placeholder--shorter': $props.selectedVendors.length === 3,
                            'd-flex justify-center align-center no-screenshot-placeholder-col': true
                          })
                                                      }, [
                                                        createElementVNode("div", _hoisted_23$2, [
                                                          createVNode(_component_v_icon, {
                                                            size: "50",
                                                            class: "mk-text--grey20 no-screenshot-icon"
                                                          }, {
                                                            default: withCtx(() => [
                                                              createTextVNode("mdi-image")
                                                            ]),
                                                            _: 1 /* STABLE */
                                                          }),
                                                          _hoisted_24$2
                                                        ])
                                                      ], 2 /* CLASS */))
                                                ])
                                              ])
                                            ]))
                                          : createCommentVNode("v-if", true)
                                      ]),
                                      _: 2 /* DYNAMIC */
                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["cols"]))
                                  }), 128 /* KEYED_FRAGMENT */))
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1024 /* DYNAMIC_SLOTS */))
                            : createCommentVNode("v-if", true),
                          createCommentVNode(" substeps "),
                          (openBlock(true), createElementBlock(Fragment, null, renderList($options.getFilteredSubsteps(step), (substep, idx) => {
                            return (openBlock(), createElementBlock("div", {
                              class: "text-left",
                              key: substep.Substep
                            }, [
                              createCommentVNode(" For protections, only show substeps until all vendors are protected, unless the user has clicked the 'Show all techniques' button "),
                              createCommentVNode(" Edge case:  if all substeps in a test or all substeps currently displayed in a test that are not filtered out are n/a, show the first substep "),
                              ((
                        $props.selectedScenario.scenario_type === 'DETECTION'
                        || $options.notAllResultsAreNa(substep)
                        || idx === 0
                        || step.Substeps.filter((substep, index) => index < idx && !substep.Include).length === idx
                        || _ctx.showAllTechniquesDict[step.Step_Num]
                      )
                      && substep.Include)
                                ? (openBlock(), createElementBlock("div", _hoisted_25$2, [
                                    createVNode(_component_SubstepHeader, {
                                      substep: substep,
                                      substepNameSpacing: "m-spacing--top-9",
                                      criteriaSpacing: "m-spacing--top-4",
                                      selectedScenario: $props.selectedScenario
                                    }, null, 8 /* PROPS */, ["substep", "selectedScenario"]),
                                    (!substep.Is_Setup)
                                      ? (openBlock(), createBlock(_component_v_row, { key: 0 }, {
                                          default: withCtx(() => [
                                            (openBlock(true), createElementBlock(Fragment, null, renderList(substep.Vendor_Data, (vendorData, index) => {
                                              return (openBlock(), createBlock(_component_v_col, {
                                                key: vendorData.name,
                                                cols: 12 / $props.selectedVendors.length
                                              }, {
                                                default: withCtx(() => [
                                                  (!(vendorData.Vendor_Details.name === 'checkpoint' && $props.selectedEvaluation.name === 'er6' && $props.selectedScenario.scenario_type === 'PROTECTION'))
                                                    ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                                                        createElementVNode("div", _hoisted_26$2, toDisplayString(vendorData.Vendor_Details.display_name), 1 /* TEXT */),
                                                        createVNode(_component_v_row, null, {
                                                          default: withCtx(() => [
                                                            createVNode(_component_v_col, {
                                                              cols: _ctx.$vuetify.display.mobile || $props.selectedVendors.length > 1 ? '6' : '3',
                                                              class: "d-flex align-center m-spacing--top-4 c-col--no-padding-top"
                                                            }, {
                                                              default: withCtx(() => [
                                                                ($options.getMostSpecificResultColor(substep, vendorData) !== '#FFFFFF')
                                                                  ? (openBlock(), createBlock(_component_v_icon, {
                                                                      key: 0,
                                                                      color: $options.getMostSpecificResultColor(substep, vendorData),
                                                                      class: "detection-specificity-box"
                                                                    }, {
                                                                      default: withCtx(() => [
                                                                        createTextVNode(" mdi-square-rounded ")
                                                                      ]),
                                                                      _: 2 /* DYNAMIC */
                                                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["color"]))
                                                                  : (openBlock(), createBlock(_component_v_icon, {
                                                                      key: 1,
                                                                      color: "#25333C",
                                                                      class: "detection-specificity-box"
                                                                    }, {
                                                                      default: withCtx(() => [
                                                                        createTextVNode(" mdi-square-rounded-outline ")
                                                                      ]),
                                                                      _: 1 /* STABLE */
                                                                    })),
                                                                createElementVNode("span", _hoisted_27$2, toDisplayString($props.selectedScenario.scenario_type === 'DETECTION' ?
                              $options.getMostSpecificDetection(vendorData).Detection_Type :
                              $options.getMostSpecificDetection(vendorData).Protection_Type), 1 /* TEXT */),
                                                                ($options.getMostSpecificDetection(vendorData).Execution_Status === 'ALTERNATE')
                                                                  ? (openBlock(), createBlock(_component_v_tooltip, {
                                                                      key: 2,
                                                                      "content-class": "mk-tooltip--top",
                                                                      location: "top"
                                                                    }, {
                                                                      activator: withCtx(({ props }) => [
                                                                        createElementVNode("span", mergeProps(props, { class: "material-symbols-rounded alt-route-icon ml-2" }), " alt_route", 16 /* FULL_PROPS */)
                                                                      ]),
                                                                      default: withCtx(() => [
                                                                        _hoisted_28$1,
                                                                        createTextVNode(),
                                                                        createElementVNode("p", null, toDisplayString($options.getMostSpecificDetection(vendorData).Alternate_Criteria), 1 /* TEXT */)
                                                                      ]),
                                                                      _: 2 /* DYNAMIC */
                                                                    }, 1024 /* DYNAMIC_SLOTS */))
                                                                  : createCommentVNode("v-if", true)
                                                              ]),
                                                              _: 2 /* DYNAMIC */
                                                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["cols"]),
                                                            createVNode(_component_v_col, {
                                                              cols: _ctx.$vuetify.display.mobile || $props.selectedVendors.length > 1 ? '6' : '3'
                                                            }, {
                                                              default: withCtx(() => [
                                                                createVNode(_component_v_tooltip, {
                                                                  "content-class": _ctx.$vuetify.display.mobile || ($props.selectedVendors.length > 1 && index == $props.selectedVendors.length - 1) ? 'mk-tooltip--allow-pointer-events-arrow-right' : 'mk-tooltip--allow-pointer-events',
                                                                  location: "top"
                                                                }, {
                                                                  activator: withCtx(({ props }) => [
                                                                    ($options.getMostSpecificDetection(vendorData).Actionable)
                                                                      ? (openBlock(), createBlock(_component_v_chip, mergeProps({ key: 0 }, props, {
                                                                          label: "",
                                                                          class: "float-right"
                                                                        }), {
                                                                          default: withCtx(() => [
                                                                            createTextVNode("Actionable")
                                                                          ]),
                                                                          _: 2 /* DYNAMIC */
                                                                        }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */))
                                                                      : createCommentVNode("v-if", true)
                                                                  ]),
                                                                  default: withCtx(() => [
                                                                    _hoisted_29$1
                                                                  ]),
                                                                  _: 2 /* DYNAMIC */
                                                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["content-class"])
                                                              ]),
                                                              _: 2 /* DYNAMIC */
                                                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["cols"])
                                                          ]),
                                                          _: 2 /* DYNAMIC */
                                                        }, 1024 /* DYNAMIC_SLOTS */),
                                                        createVNode(_component_v_col, {
                                                          class: "m-spacing--top-4 text-left col--no-padding",
                                                          cols: _ctx.$vuetify.display.mobile || $props.selectedVendors.length > 1 ? 12 : 6
                                                        }, {
                                                          default: withCtx(() => [
                                                            createCommentVNode(" detection screenshot "),
                                                            (
                          $options.getMostSpecificDetection(vendorData).Detection_Type !== 'None' &&
                          $options.getMostSpecificDetection(vendorData).Detection_Type !== 'Not applicable' &&
                          $options.getMostSpecificDetection(vendorData).Detection_Type !== 'Not reported' &&
                          $options.getMostSpecificDetection(vendorData).Protection_Type !== 'None' &&
                          $options.getMostSpecificDetection(vendorData).Protection_Type !== 'Not blocked' &&
                          $options.getMostSpecificDetection(vendorData).Protection_Type !== 'Not applicable' &&
                          $options.getMostSpecificDetection(vendorData).Protection_Type !== 'Not reported' &&
                          $options.getMostSpecificDetection(vendorData).Screenshots &&
                          $options.getMostSpecificDetection(vendorData).Screenshots.length
                        )
                                                              ? (openBlock(), createElementBlock("div", _hoisted_30$1, [
                                                                  createElementVNode("div", _hoisted_31$1, [
                                                                    (openBlock(), createBlock(_component_v_img, {
                                                                      onMouseenter: $event => (_ctx.hoverScreenshotDictionary[substep.Substep][vendorData.Vendor_Name] = true),
                                                                      onMouseleave: $event => (_ctx.hoverScreenshotDictionary[substep.Substep][vendorData.Vendor_Name] = false),
                                                                      key: $options.getMostSpecificScreenshotWebp(vendorData),
                                                                      src: `${$props.screenshotUrl}${$options.getMostSpecificScreenshotWebp(vendorData)}`,
                                                                      height: $props.selectedVendors.length < 3 ? _ctx.screenshotHeightLonger : _ctx.screenshotHeightShorter,
                                                                      class: "screenshot",
                                                                      onClick: $event => (_ctx.$vuetify.display.mobile ? $options.openEvaluationModal(vendorData, substep) : {})
                                                                    }, null, 8 /* PROPS */, ["onMouseenter", "onMouseleave", "src", "height", "onClick"])),
                                                                    (_ctx.hoverScreenshotDictionary[substep.Substep][vendorData.Vendor_Name] && !_ctx.$vuetify.display.mobile)
                                                                      ? (openBlock(), createBlock(_component_v_btn, {
                                                                          key: 0,
                                                                          onMouseenter: $event => (_ctx.hoverScreenshotDictionary[substep.Substep][vendorData.Vendor_Name] = true),
                                                                          class: "expand-modal-btn",
                                                                          icon: "mdi-unfold-more-horizontal",
                                                                          "data-id": "results.evaluationdetails.expandmodalbutton",
                                                                          onClick: $event => ($options.openEvaluationModal(vendorData, substep))
                                                                        }, null, 8 /* PROPS */, ["onMouseenter", "onClick"]))
                                                                      : createCommentVNode("v-if", true)
                                                                  ]),
                                                                  createVNode(_component_v_row, { class: "details-row" }, {
                                                                    default: withCtx(() => [
                                                                      createVNode(_component_v_col, {
                                                                        class: "details-cols",
                                                                        cols: $props.selectedVendors.length > 2 ? 12 : 6
                                                                      }, {
                                                                        default: withCtx(() => [
                                                                          ($props.selectedScenario.scenario_type === 'DETECTION' && $options.getMostSpecificScreenshot(vendorData).Data_Sources.length)
                                                                            ? (openBlock(), createElementBlock("div", _hoisted_32$1, [
                                                                                createElementVNode("div", _hoisted_33$1, toDisplayString($options.getMostSpecificScreenshot(vendorData).Data_Sources.length > 1 ? 'Data Sources' : 'Data Source'), 1 /* TEXT */),
                                                                                (openBlock(true), createElementBlock(Fragment, null, renderList($options.getMostSpecificScreenshot(vendorData).Data_Sources, (dataSource) => {
                                                                                  return (openBlock(), createElementBlock("div", {
                                                                                    key: dataSource,
                                                                                    class: "mk-text--body mk-text--regular mk-text--grey70"
                                                                                  }, toDisplayString(dataSource), 1 /* TEXT */))
                                                                                }), 128 /* KEYED_FRAGMENT */))
                                                                              ]))
                                                                            : createCommentVNode("v-if", true)
                                                                        ]),
                                                                        _: 2 /* DYNAMIC */
                                                                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["cols"]),
                                                                      createVNode(_component_v_col, {
                                                                        cols: $props.selectedVendors.length > 2 ? 12 : 6,
                                                                        class: normalizeClass($props.selectedVendors.length > 2 ? 'text-left pt-0' : 'text-right m-spacing--top-3 details-cols')
                                                                      }, {
                                                                        default: withCtx(() => [
                                                                          ($props.selectedScenario.scenario_type === 'DETECTION' && $options.getMostSpecificDetection(vendorData).Modifiers.length)
                                                                            ? (openBlock(), createElementBlock("div", _hoisted_34$2, [
                                                                                createElementVNode("div", _hoisted_35$1, toDisplayString($options.getMostSpecificDetection(vendorData).Modifiers.length > 1 ? 'Modifiers' : 'Modifier'), 1 /* TEXT */),
                                                                                (openBlock(true), createElementBlock(Fragment, null, renderList($options.getMostSpecificDetection(vendorData).Modifiers, (modifier) => {
                                                                                  return (openBlock(), createElementBlock("div", {
                                                                                    key: modifier,
                                                                                    class: "mk-text--body mk-text--regular mk-text--grey70"
                                                                                  }, toDisplayString(modifier), 1 /* TEXT */))
                                                                                }), 128 /* KEYED_FRAGMENT */))
                                                                              ]))
                                                                            : createCommentVNode("v-if", true)
                                                                        ]),
                                                                        _: 2 /* DYNAMIC */
                                                                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["cols", "class"])
                                                                    ]),
                                                                    _: 2 /* DYNAMIC */
                                                                  }, 1024 /* DYNAMIC_SLOTS */)
                                                                ]))
                                                              : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                                                                  createCommentVNode(" placeholder if there are no screenshots "),
                                                                  createElementVNode("div", {
                                                                    class: normalizeClass({
                            'no-screenshot-placeholder--longer': $props.selectedVendors.length < 3,
                            'no-screenshot-placeholder--shorter': $props.selectedVendors.length === 3,
                            'd-flex justify-center align-center no-screenshot-placeholder-col': true
                          })
                                                                  }, [
                                                                    createElementVNode("div", _hoisted_36$1, [
                                                                      ($props.selectedScenario.scenario_type === 'DETECTION' || (
                              $props.selectedScenario.scenario_type === 'PROTECTION' &&
                              ($options.getMostSpecificDetection(vendorData).Protection_Type === 'None' ||
                              $options.getMostSpecificDetection(vendorData).Protection_Type === 'Not blocked' ||
                              $options.getMostSpecificDetection(vendorData).Protection_Type === 'Not applicable' ||
                              $options.getMostSpecificDetection(vendorData).Protection_Type === 'Not reported' &&
                              !$props.checkIfStepProtected(step, vendorData.Vendor_Name, substep.Substep))
                            ))
                                                                        ? (openBlock(), createElementBlock("div", _hoisted_37$1, [
                                                                            createVNode(_component_v_icon, {
                                                                              size: "50",
                                                                              class: "mk-text--grey20 no-screenshot-icon"
                                                                            }, {
                                                                              default: withCtx(() => [
                                                                                createTextVNode("mdi-image")
                                                                              ]),
                                                                              _: 1 /* STABLE */
                                                                            }),
                                                                            _hoisted_38$1
                                                                          ]))
                                                                        : (openBlock(), createElementBlock("div", _hoisted_39$1, [
                                                                            createVNode(_component_v_icon, {
                                                                              size: "50",
                                                                              class: "mk-text--grey20 no-screenshot-icon"
                                                                            }, {
                                                                              default: withCtx(() => [
                                                                                createTextVNode("mdi-lock")
                                                                              ]),
                                                                              _: 1 /* STABLE */
                                                                            }),
                                                                            _hoisted_40$1
                                                                          ]))
                                                                    ])
                                                                  ], 2 /* CLASS */)
                                                                ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */)),
                                                            ($options.getMostSpecificDetection(vendorData).Footnotes?.length)
                                                              ? (openBlock(), createElementBlock("div", _hoisted_41$1, [
                                                                  createElementVNode("div", _hoisted_42$1, toDisplayString($options.getMostSpecificDetection(vendorData).Footnotes.length > 1 ? 'Footnotes' : 'Footnote'), 1 /* TEXT */),
                                                                  (openBlock(true), createElementBlock(Fragment, null, renderList($options.getMostSpecificDetection(vendorData).Footnotes, (footnote) => {
                                                                    return (openBlock(), createElementBlock("div", {
                                                                      key: footnote,
                                                                      class: "mk-text--body mk-text--regular mk-text--grey70"
                                                                    }, toDisplayString(footnote), 1 /* TEXT */))
                                                                  }), 128 /* KEYED_FRAGMENT */))
                                                                ]))
                                                              : createCommentVNode("v-if", true)
                                                          ]),
                                                          _: 2 /* DYNAMIC */
                                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["cols"])
                                                      ], 64 /* STABLE_FRAGMENT */))
                                                    : createCommentVNode("v-if", true)
                                                ]),
                                                _: 2 /* DYNAMIC */
                                              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["cols"]))
                                            }), 128 /* KEYED_FRAGMENT */))
                                          ]),
                                          _: 2 /* DYNAMIC */
                                        }, 1024 /* DYNAMIC_SLOTS */))
                                      : createCommentVNode("v-if", true)
                                  ]))
                                : createCommentVNode("v-if", true)
                            ]))
                          }), 128 /* KEYED_FRAGMENT */)),
                          (
                !_ctx.showAllTechniquesDict[step.Step_Num] &&
                $options.moreSubstepsInStep(step.Step_Num) &&
                $props.selectedScenario.scenario_type === 'PROTECTION'
              )
                            ? (openBlock(), createBlock(_component_v_btn, {
                                key: 1,
                                class: "mk-button--primary-ghost m-spacing--top-7",
                                onClick: $event => (_ctx.showAllTechniquesDict[step.Step_Num] = true),
                                "data-id": "results.evaluationdetails.showalltechniquesbutton"
                              }, {
                                default: withCtx(() => [
                                  createTextVNode(" Show all techniques ")
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]))
                            : (
                _ctx.showAllTechniquesDict &&
                $options.moreSubstepsInStep(step.Step_Num) &&
                $props.selectedScenario.scenario_type === 'PROTECTION'
              )
                              ? (openBlock(), createBlock(_component_v_btn, {
                                  key: 2,
                                  class: "mk-button--primary-ghost m-spacing--top-7",
                                  onClick: $event => (_ctx.showAllTechniquesDict[step.Step_Num] = false),
                                  "data-id": "results.evaluationdetails.showlesstechniquesbutton"
                                }, {
                                  default: withCtx(() => [
                                    createTextVNode(" Show less techniques ")
                                  ]),
                                  _: 2 /* DYNAMIC */
                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]))
                              : createCommentVNode("v-if", true)
                        ]))
                      : createCommentVNode("v-if", true)
                  ], 8 /* PROPS */, _hoisted_5$7))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }),
        createVNode(_component_v_dialog, {
          fullscreen: _ctx.isMobileLandscape,
          modelValue: _ctx.evaluationDetailModalOpen,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.evaluationDetailModalOpen) = $event)),
          width: "auto"
        }, {
          default: withCtx(() => [
            createVNode(_component_EvaluationDetailModal, {
              vendorData: _ctx.modalVendorData,
              selectedScenario: $props.selectedScenario,
              substep: _ctx.modalSubstep,
              getResultColor: $options.getResultColor,
              selectedEvaluation: $props.selectedEvaluation,
              preview: $props.preview,
              onUpdateEvaluationDetailModalOpen: $options.updateEvaluationDetailModalOpen,
              screenshotUrl: $props.screenshotUrl
            }, null, 8 /* PROPS */, ["vendorData", "selectedScenario", "substep", "getResultColor", "selectedEvaluation", "preview", "onUpdateEvaluationDetailModalOpen", "screenshotUrl"])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["fullscreen", "modelValue"])
      ]))
    : createCommentVNode("v-if", true)
}
var EvaluationDetails = /*#__PURE__*/_export_sfc(_sfc_main$8, [['render',_sfc_render$6],['__file',"/home/runner/work/evals-website/evals-website/packages/enterprise-results/src/EvaluationDetails.vue"]]);

var css_248z$5 = "";
styleInject(css_248z$5);

const _sfc_main$7 = {
    name: 'ChartLegend',
    data: () => ({
      legendExpanded: false,
      hoverOnCard: false,
      footerVisible: false,
    }),
    props: {
      evalResultCategories: Array,
      chartColors: Array,
    },
    watch: {
      legendExpanded(value){
        this.$emit("updateLegendExpanded", value);
      }
    },
    methods: {
      handleScroll(){
        if (document.getElementById('footer')){
          let footer = document.getElementById('footer').getBoundingClientRect();
          let top = window.innerHeight - footer.top;
          this.footerVisible = top > 0;
        }
      },
      closeChartLegend(){
        this.$emit("updateMobileDetectionKeyExpanded", false);
      }
    },
    created () {
      window.addEventListener('scroll', this.handleScroll);

    },
    unmounted () {
      window.removeEventListener('scroll', this.handleScroll);
    },
};

const _withScopeId$2 = n => (pushScopeId("data-v-3fb20227"),n=n(),popScopeId(),n);
const _hoisted_1$6 = { key: 0 };
const _hoisted_2$6 = /*#__PURE__*/ _withScopeId$2(() => /*#__PURE__*/createElementVNode("span", { class: "mk-text--grey60 mb-6" }, "Detection Key", -1 /* HOISTED */));
const _hoisted_3$6 = {
  key: 1,
  class: "icon--hover icon-container c-text--cursor-pointer"
};
const _hoisted_4$6 = ["width"];
const _hoisted_5$6 = ["width"];
const _hoisted_6$6 = /*#__PURE__*/ _withScopeId$2(() => /*#__PURE__*/createElementVNode("span", { class: "text-left legend-col" }, "More Specific", -1 /* HOISTED */));
const _hoisted_7$6 = /*#__PURE__*/ _withScopeId$2(() => /*#__PURE__*/createElementVNode("span", { class: "text-right legend-col" }, "Less Specific", -1 /* HOISTED */));
const _hoisted_8$5 = { class: "ml-2" };

function _sfc_render$5(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_col = resolveComponent("v-col");
  const _component_v_row = resolveComponent("v-row");
  const _component_v_card_text = resolveComponent("v-card-text");
  const _component_v_card = resolveComponent("v-card");

  return (openBlock(), createBlock(Transition, null, {
    default: withCtx(() => [
      (!_ctx.footerVisible)
        ? (openBlock(), createElementBlock("div", _hoisted_1$6, [
            createVNode(_component_v_col, null, {
              default: withCtx(() => [
                createVNode(_component_v_card, {
                  id: "chart-legend",
                  color: "white px-4 py-2",
                  onMouseenter: _cache[3] || (_cache[3] = $event => (_ctx.hoverOnCard = true)),
                  onMouseleave: _cache[4] || (_cache[4] = $event => (_ctx.hoverOnCard = false)),
                  elevation: "10"
                }, {
                  default: withCtx(() => [
                    createVNode(_component_v_card_text, { class: "text-left card__text" }, {
                      default: withCtx(() => [
                        createVNode(_component_v_row, null, {
                          default: withCtx(() => [
                            createVNode(_component_v_col, { class: "col--no-left-padding" }, {
                              default: withCtx(() => [
                                _hoisted_2$6
                              ]),
                              _: 1 /* STABLE */
                            }),
                            (!_ctx.legendExpanded)
                              ? (openBlock(), createElementBlock("span", {
                                  key: 0,
                                  onClick: _cache[0] || (_cache[0] = $event => (_ctx.legendExpanded = true)),
                                  class: normalizeClass({
                'icon--hover material-symbols-rounded icon-container': true,
                'mk-text--grey60 c-text--cursor-pointer': _ctx.hoverOnCard || _ctx.$vuetify.display.mobile,
                'c-text--white': !_ctx.hoverOnCard && !_ctx.$vuetify.display.mobile
              }),
                                  "data-id": "results.chartlegend.expandlegendbutton"
                                }, " expand_content ", 2 /* CLASS */))
                              : createCommentVNode("v-if", true),
                            (_ctx.legendExpanded)
                              ? (openBlock(), createElementBlock("div", _hoisted_3$6, [
                                  createElementVNode("span", {
                                    onClick: _cache[1] || (_cache[1] = $event => (_ctx.legendExpanded = false)),
                                    class: normalizeClass({
                  'material-symbols-rounded icon--rotate': true,
                  'mk-text--grey60': _ctx.hoverOnCard || _ctx.$vuetify.display.mobile,
                  'c-text--white': !_ctx.hoverOnCard && !_ctx.$vuetify.display.mobile
                }),
                                    "data-id": "results.chartlegend.collapselegendbutton"
                                  }, " unfold_less ", 2 /* CLASS */)
                                ]))
                              : createCommentVNode("v-if", true),
                            (_ctx.$vuetify.display.mobile)
                              ? (openBlock(), createElementBlock("span", {
                                  key: 2,
                                  onClick: _cache[2] || (_cache[2] = (...args) => ($options.closeChartLegend && $options.closeChartLegend(...args))),
                                  class: "icon--hover material-symbols-rounded mk-text--grey60 c-text--cursor-pointer",
                                  "data-id": "results.chartlegend.expandlegendbutton"
                                }, " close "))
                              : createCommentVNode("v-if", true)
                          ]),
                          _: 1 /* STABLE */
                        }),
                        createVNode(_component_v_row, null, {
                          default: withCtx(() => [
                            createCommentVNode(" Detection Color Bar "),
                            createElementVNode("div", null, [
                              (openBlock(true), createElementBlock(Fragment, null, renderList($props.chartColors, (color) => {
                                return (openBlock(), createElementBlock("svg", {
                                  key: color,
                                  width: 300 / $props.chartColors.length,
                                  height: "30",
                                  style: normalizeStyle(
                  color === '#FFFFFF' ?
                  'border-top:0.5px solid #25333C; border-bottom:0.5px solid #25333C' :
                  `border-top:0.5px solid ${color}; border-bottom:0.5px solid ${color}`
                )
                                }, [
                                  createElementVNode("rect", {
                                    style: normalizeStyle(`fill:${color}`),
                                    width: 300 / $props.chartColors.length,
                                    height: "30"
                                  }, null, 12 /* STYLE, PROPS */, _hoisted_5$6)
                                ], 12 /* STYLE, PROPS */, _hoisted_4$6))
                              }), 128 /* KEYED_FRAGMENT */))
                            ])
                          ]),
                          _: 1 /* STABLE */
                        }),
                        createVNode(_component_v_row, null, {
                          default: withCtx(() => [
                            _hoisted_6$6,
                            _hoisted_7$6
                          ]),
                          _: 1 /* STABLE */
                        }),
                        (_ctx.legendExpanded)
                          ? (openBlock(), createBlock(_component_v_row, {
                              key: 0,
                              class: "mt-10"
                            }, {
                              default: withCtx(() => [
                                (openBlock(true), createElementBlock(Fragment, null, renderList($props.evalResultCategories, (resultCategory, idx) => {
                                  return (openBlock(), createBlock(_component_v_col, {
                                    key: resultCategory.id,
                                    class: "mx-3 my-4",
                                    cols: _ctx.$vuetify.display.mobile ? 12 : ''
                                  }, {
                                    default: withCtx(() => [
                                      createVNode(_component_v_row, { class: "align-center pr-6" }, {
                                        default: withCtx(() => [
                                          (openBlock(), createElementBlock("svg", {
                                            width: "30",
                                            height: "30",
                                            style: normalizeStyle($props.chartColors[idx] === '#FFFFFF' ?
                  'border:1px solid #25333C;':
                  `border:1px solid ${$props.chartColors[idx]};`)
                                          }, [
                                            createElementVNode("rect", {
                                              width: "30",
                                              height: "30",
                                              style: normalizeStyle(`fill:${$props.chartColors[idx]}`)
                                            }, null, 4 /* STYLE */)
                                          ], 4 /* STYLE */)),
                                          createElementVNode("div", _hoisted_8$5, toDisplayString(resultCategory.name), 1 /* TEXT */)
                                        ]),
                                        _: 2 /* DYNAMIC */
                                      }, 1024 /* DYNAMIC_SLOTS */),
                                      createVNode(_component_v_row, { class: "pt-2 mk-text--grey60 pr-6" }, {
                                        default: withCtx(() => [
                                          createElementVNode("div", null, toDisplayString(resultCategory.description), 1 /* TEXT */)
                                        ]),
                                        _: 2 /* DYNAMIC */
                                      }, 1024 /* DYNAMIC_SLOTS */)
                                    ]),
                                    _: 2 /* DYNAMIC */
                                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["cols"]))
                                }), 128 /* KEYED_FRAGMENT */))
                              ]),
                              _: 1 /* STABLE */
                            }))
                          : createCommentVNode("v-if", true)
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            })
          ]))
        : createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }))
}
var ChartLegend = /*#__PURE__*/_export_sfc(_sfc_main$7, [['render',_sfc_render$5],['__scopeId',"data-v-3fb20227"],['__file',"/home/runner/work/evals-website/evals-website/packages/enterprise-results/src/ChartLegend.vue"]]);

var css_248z$4 = "";
styleInject(css_248z$4);

const _sfc_main$6 = {
    name: 'Filters',

    data: () => ({
      modifiers: [],
      modifierMenu: true,
      searchText: "",
      localFiltersTab: 'steps',
      localTactics: {},
      localFiltersUnchecked: {},
      showSetup: false
    }),

    props: {
      filtersTab: String,
      filtersUnchecked: Object,
      evaluationSteps: Array,
      selectedEvaluation: Object,
      generateScenarioDetectionChart: Function,
      generateScenarioActionableDetectionChart: Function,
      generateStepActionableDetectionChart: Function,
      generateStepDetectionChart: Function,
      generateTacticDetectionChart: Function,
      generateTacticActionableDetectionChart: Function,
      selectedVendors: Array,
      tactics: Object,
      allModifierTypes: Array,
      selectedScenario: Object
    },

    watch: {
      evaluationSteps(value){
        if(value) this.getTactics();
      },
      filtersTab(value){
        this.localFiltersTab = value;
      },
      localFiltersTab(newValue){
        this.modifiers = this.modifiers.map(modifier => {
          modifier.checked = true;
          return modifier;
        });
        this.modifierMenu = false;
        this.$emit("updateFiltersTab", newValue);
      },
      tactics(value){
        this.localTactics = value;
      },
      localTactics(value){
        this.$emit("updateTactics", value);
      },
      localFiltersUnchecked(value){
        this.$emit("updateFiltersUnchecked", value);
      },
    },

    computed: {
      filteredSteps() {
        return this.evaluationSteps.filter(step => {
          return step.checked === true
        });
      },
    },

    methods: {
      unnestedFilterCheckedUpdated(item) {
        if(item.checked){
          if(item.type === 'tactic'){
            this.localFiltersUnchecked.tacticsUnchecked = this.localFiltersUnchecked.tacticsUnchecked.filter(tacticUnchecked => tacticUnchecked !== item.id);
            this.localTactics[item.id].checked = true;
          }
          else if (item.type === 'technique'){
            this.localFiltersUnchecked.techniquesUnchecked = this.localFiltersUnchecked.techniquesUnchecked.filter(techniqueUnchecked => techniqueUnchecked !== item.id);
            this.localTactics[item.tactic].techniques[item.id].checked = true;
          }
          else {
            this.localFiltersUnchecked.subtechniquesUnchecked = this.localFiltersUnchecked.subtechniquesUnchecked.filter(subtechniqueUnchecked => subtechniqueUnchecked !== item.id);
            this.localTactics[item.tactic].techniques[item.technique].subtechniques[item.id].checked = true;
          }
        }
        else if(item.type === 'tactic'){
          this.localFiltersUnchecked.tacticsUnchecked.push(item.id);
          this.localTactics[item.id].checked = false;
        }
        else if (item.type === 'technique'){
          this.localFiltersUnchecked.techniquesUnchecked.push(item.id);
          this.localTactics[item.tactic].techniques[item.id].checked = false;
        }
        else {
          this.localFiltersUnchecked.subtechniquesUnchecked.push(item.id);
          this.localTactics[item.tactic].techniques[item.technique].subtechniques[item.id].checked = false;
        }

        this.selectedVendors.forEach(vendor => {
          this.generateScenarioDetectionChart(vendor.name);
          this.generateScenarioActionableDetectionChart(vendor.name);
          this.generateTacticDetectionChart(vendor.name);
          this.generateTacticActionableDetectionChart(vendor.name);
        });
      },

      techniqueCheckedUpdated(tacticId, tacticValue, techniqueId, techniqueValue){
        let techniquesChecked = Object.values(tacticValue.techniques).map(techniqueValue => {
          return techniqueValue.checked;
        });
        let someChecked = techniquesChecked.some(checked =>  checked);
        let allChecked = techniquesChecked.every(checked => checked);

        // if some techniques are checked, ensure that parent tactic is checked
        if(allChecked){
          tacticValue.checked = true;
          tacticValue.minusIcon = false;
          this.localFiltersUnchecked.tacticsUnchecked = this.localFiltersUnchecked.tacticsUnchecked.filter(tacticUnchecked => tacticUnchecked !== tacticId);
        }
        // if some but not all techniques are checked, should show minus icon instead of checked
        else if(someChecked){
          tacticValue.checked = true;
          tacticValue.minusIcon = true;
          this.localFiltersUnchecked.tacticsUnchecked = this.localFiltersUnchecked.tacticsUnchecked.filter(tacticUnchecked => tacticUnchecked !== tacticId);
        }
        // if al techniques are unchecked, ensure that parent tactic is unchecked
        else {
          let allUnchecked = techniquesChecked.every(checked => !checked);
          if(allUnchecked){
            tacticValue.checked = false;
            this.localFiltersUnchecked.tacticsUnchecked.push(tacticId);
          }
        }


        // if technique is checked, ensure that all children subtechniques are checked
        if(techniqueValue.checked){
            techniqueValue.minusIcon = false;
            Object.entries(techniqueValue.subtechniques).forEach(([subtechniqueId, subtechniqueValue]) => {
              subtechniqueValue.checked = true;
              this.localFiltersUnchecked.subtechniquesUnchecked = this.localFiltersUnchecked.subtechniquesUnchecked.filter(
                subtechniqueUnchecked => subtechniqueUnchecked !== subtechniqueId
              );
            });
            // take technique out of array of unchecked techniques
            this.localFiltersUnchecked.techniquesUnchecked = this.localFiltersUnchecked.techniquesUnchecked.filter(
              techniqueUnchecked => techniqueUnchecked !== techniqueId
            );
        }
        // if technique is unchecked, ensure that all children subtechniques are unchecked
        else {
            Object.entries(techniqueValue.subtechniques).forEach(([subtechniqueId, subtechniqueValue]) => {
              subtechniqueValue.checked = false;
              this.localFiltersUnchecked.subtechniquesUnchecked.push(subtechniqueId);
            });
            // add technique to array of unchecked techniques
            this.localFiltersUnchecked.techniquesUnchecked.push(techniqueId);
        }

        this.selectedVendors.forEach(vendor => {
            this.generateScenarioDetectionChart(vendor.name);
            this.generateScenarioActionableDetectionChart(vendor.name);
          if (this.filtersTab === 'steps') {
            this.generateStepDetectionChart(this.filteredSteps, vendor.name);
            this.generateStepActionableDetectionChart(this.filteredSteps, vendor.name);
          } else {
            this.generateTacticDetectionChart(vendor.name);
            this.generateTacticActionableDetectionChart(vendor.name);
          }

        });
      },

      modifierCheckedUpdated(modifier){
        if(modifier.checked){
          this.localFiltersUnchecked.modifiersUnchecked = this.localFiltersUnchecked.modifiersUnchecked.filter(modifierUnchecked => modifierUnchecked !== modifier.label);
        }
        else {
          this.localFiltersUnchecked.modifiersUnchecked.push(modifier.label);
        }

        this.selectedVendors.forEach(vendor => {
          this.generateScenarioDetectionChart(vendor.name);
          this.generateScenarioActionableDetectionChart(vendor.name);
          if (this.filtersTab === 'steps') {
            this.generateStepDetectionChart(this.filteredSteps, vendor.name);
            this.generateStepActionableDetectionChart(this.filteredSteps, vendor.name);
          } else {
            this.generateTacticDetectionChart(vendor.name);
            this.generateTacticActionableDetectionChart(vendor.name);
          }
        });
      },

      tacticCheckedUpdated(tacticId, tacticValue){
        // if tactic is checked, ensure that all children techniques and subtechniques are checked
        if(tacticValue.checked){
          tacticValue.minusIcon = false;
          Object.entries(tacticValue.techniques).forEach(([techniqueId, techniqueValue]) => {
            techniqueValue.checked = true;
            this.localFiltersUnchecked.techniquesUnchecked = this.localFiltersUnchecked.techniquesUnchecked.filter(
              techniqueUnchecked => techniqueUnchecked !== techniqueId
            );
            Object.entries(techniqueValue.subtechniques).forEach(([subtechniqueId, subtechniqueValue]) => {
              subtechniqueValue.checked = true;
              this.localFiltersUnchecked.subtechniquesUnchecked = this.localFiltersUnchecked.subtechniquesUnchecked.filter(
                subtechniqueUnchecked => subtechniqueUnchecked !== subtechniqueId
              );
            });
          });
          // remove tactic from array of unchecked tactics
          this.localFiltersUnchecked.tacticsUnchecked = this.localFiltersUnchecked.tacticsUnchecked.filter(tacticUnchecked => tacticUnchecked!==tacticId);
        }
        // if tactic is unchecked, ensure that all children techniques and subtechniques are unchecked
        else {
          Object.entries(tacticValue.techniques).forEach(([techniqueId, techniqueValue]) => {
            techniqueValue.checked = false;
            this.localFiltersUnchecked.techniquesUnchecked.push(techniqueId);
            Object.entries(techniqueValue.subtechniques).forEach(([subtechniqueId, subtechniqueValue]) => {
              subtechniqueValue.checked = false;
              this.localFiltersUnchecked.subtechniquesUnchecked.push(subtechniqueId);
            });
          });
          // add tactic to array of unchecked tactics
          this.localFiltersUnchecked.tacticsUnchecked.push(tacticId);
        }
        this.selectedVendors.forEach(vendor => {
          this.generateScenarioDetectionChart(vendor.name);
          this.generateScenarioActionableDetectionChart(vendor.name);
          if (this.filtersTab === 'steps') {
            this.generateStepDetectionChart(this.filteredSteps, vendor.name);
            this.generateStepActionableDetectionChart(this.filteredSteps, vendor.name);
          } else {
            this.generateTacticDetectionChart(vendor.name);
            this.$nextTick(() => {
              this.generateTacticActionableDetectionChart(vendor.name);
            });
          }
        });
      },

      subtechniqueCheckedUpdated(tacticId, tacticValue, techniqueId, techniqueValue, subtechniqueId, subtechniqueValue){

        let subtechniquesChecked = Object.values(techniqueValue.subtechniques).map(subtechniqueValue => {
          return subtechniqueValue.checked;
        });
        let techniquesChecked = Object.values(tacticValue.techniques).map(techniqueValue => {
          return techniqueValue.checked;
        });
        let someChecked = subtechniquesChecked.some(checked =>  checked);
        let allChecked = subtechniquesChecked.every(checked => checked);

        // if all subtechniques are checked, ensure that parent technique is checked
        if(allChecked){
          techniqueValue.checked = true;
          techniqueValue.minusIcon = false;
          tacticValue.checked = true;
          let allTechniquesChecked = Object.values(tacticValue.techniques).every(techniqueValue => techniqueValue.checked);
          tacticValue.minusIcon = !allTechniquesChecked;
          this.localFiltersUnchecked.techniquesUnchecked = this.localFiltersUnchecked.techniquesUnchecked.filter(techniqueUnchecked => techniqueUnchecked !== techniqueId);
          this.localFiltersUnchecked.tacticsUnchecked = this.localFiltersUnchecked.tacticsUnchecked.filter(tacticUnchecked => tacticUnchecked !== tacticId);
        }
        // if some but not all checked, parent technique icon should be minus instead of check
        else if(someChecked){
          techniqueValue.checked = true;
          techniqueValue.minusIcon = true;
          if (techniquesChecked.every(checked => checked)) tacticValue.minusIcon = true;
        }
        // if al subtechniques are unchecked, ensure that parent technique is unchecked
        else {
          let allUnchecked = subtechniquesChecked.every(checked => !checked);
          techniqueValue.minusIcon = false;
          if(allUnchecked){
            this.localFiltersUnchecked.techniquesUnchecked.push(techniqueId);
            techniqueValue.checked = false;
            let allTechniquesUnchecked = Object.values(tacticValue.techniques).every(techniqueValue => !techniqueValue.checked);
            if (allTechniquesUnchecked){
              tacticValue.checked = false;
              this.localFiltersUnchecked.tacticsUnchecked.push(tacticId);
            }
            else {
              tacticValue.minusIcon = true;
            }
          }
        }

        // if subtechnique is checked, remove from array of unchecked subtechniques
        if(subtechniqueValue.checked){
            this.localFiltersUnchecked.subtechniquesUnchecked = this.localFiltersUnchecked.subtechniquesUnchecked.filter(
              subtechniqueUnchecked => subtechniqueUnchecked !== subtechniqueId
            );
        }
        // if subtechnique is not checked, add to array of unchecked subtechniques
        else {
          this.localFiltersUnchecked.subtechniquesUnchecked.push(subtechniqueId);
        }
        this.selectedVendors.forEach(vendor => {
          this.generateScenarioDetectionChart(vendor.name);
          this.generateScenarioActionableDetectionChart(vendor.name);
          if (this.filtersTab === 'steps') {
            this.generateStepDetectionChart(this.filteredSteps, vendor.name);
            this.generateStepActionableDetectionChart(this.filteredSteps, vendor.name);
          } else {
            this.generateTacticDetectionChart(vendor.name);
            this.generateTacticActionableDetectionChart(vendor.name);
          }
        });
      },

      getTactics(){
        let tacticsDictionary = {};
        this.evaluationSteps.forEach(step => {
          step.Substeps.forEach(substep => {
            let tactic = substep.Tactic;
            let technique = substep.Technique;
            let subtechnique = substep.Subtechnique;
            if(!tacticsDictionary[tactic.Tactic_Id]){
              tacticsDictionary[tactic.Tactic_Id] = {
                name: tactic.Tactic_Name,
                checked: true,
                open: false,
                hover: false,
                minusIcon: false,
                display: true,
                'techniques': {}
              };
            }
            if(!tacticsDictionary[tactic.Tactic_Id]['techniques'][technique.Technique_Id]){
              tacticsDictionary[tactic.Tactic_Id]['techniques'][technique.Technique_Id] = {
                name: technique.Technique_Name,
                checked: true,
                open: false,
                hover: false,
                minusIcon: false,
                display: true,
                'subtechniques': {},
              };

            }
            if(subtechnique.Subtechnique_Id
              && !tacticsDictionary[tactic.Tactic_Id]['techniques'][technique.Technique_Id]['subtechniques'][subtechnique.Subtechnique_Id]){
                tacticsDictionary[tactic.Tactic_Id]['techniques'][technique.Technique_Id]['subtechniques'][subtechnique.Subtechnique_Id] = {
                  name: subtechnique.Subtechnique_Name.slice(subtechnique.Subtechnique_Name.indexOf(':') + 2),
                  checked: true,
                  display: true,
              };
            }
          });
        });
        this.localTactics = this.sortTactics(tacticsDictionary);
      },

      sortIdsByName(object){
        return Object.keys(object).sort((a,b) => {
          return object[a].name > object[b].name ? 1 : -1;
        })
      },

      sortTactics(tactics){
        let sortedTacticIds = this.sortIdsByName(tactics);
        let sortedTactics = {};
        sortedTacticIds.forEach(tacticId => {
          let sortedTechniqueIds = this.sortIdsByName(tactics[tacticId].techniques);
          sortedTactics[tacticId] = {
            checked: tactics[tacticId].checked,
            hover: tactics[tacticId].hover,
            minusIcon: tactics[tacticId].minusIcon,
            open: tactics[tacticId].open,
            name: tactics[tacticId].name,
            display: tactics[tacticId].display,
            techniques: {}
          };
          sortedTechniqueIds.forEach(techniqueId => {
            let sortedSubtechniqueIds = this.sortIdsByName(tactics[tacticId].techniques[techniqueId].subtechniques);
            sortedTactics[tacticId].techniques[techniqueId] = {
              checked: tactics[tacticId].techniques[techniqueId].checked,
              hover: tactics[tacticId].techniques[techniqueId].hover,
              minusIcon: tactics[tacticId].techniques[techniqueId].minusIcon,
              open: tactics[tacticId].techniques[techniqueId].open,
              name: tactics[tacticId].techniques[techniqueId].name,
              display: tactics[tacticId].techniques[techniqueId].display,
              subtechniques: {}
            };
            sortedSubtechniqueIds.forEach(subtechniqueId => {
              sortedTactics[tacticId].techniques[techniqueId].subtechniques[subtechniqueId] = tactics[tacticId].techniques[techniqueId].subtechniques[subtechniqueId];
            });
          });
        });
        return sortedTactics;
      },

      getEvaluationModifiers(){
        let modifiers = [];
        this.allModifierTypes.forEach(modifier => {
          let modifierCategory = getModifierTypeCategory(modifier.name);
          if(this.selectedEvaluation.operational_flow[0].adversary === modifier.adversary &&
            this.selectedScenario.scenario_type === modifier.result_type &&
            !modifiers.find(m => m.label === modifierCategory) &&
            (modifierCategory !== 'User Consent' || this.selectedEvaluation.name !== 'turla')){
            modifiers.push({label: modifierCategory, value: modifier.id, checked: true});
          }});
        this.modifiers = modifiers;
      },

      filterTacticsView(){
        let searchText = this.searchText.toLowerCase();
        Object.entries(this.tactics).forEach(([tacticId, tacticValue]) => {
          this.filterTactics(searchText, tacticId, tacticValue);
          Object.entries(tacticValue.techniques).forEach(([techniqueId, techniqueValue]) => {
            this.filterTactics(searchText, techniqueId, techniqueValue, tacticId, tacticValue, );
            Object.entries(techniqueValue.subtechniques).forEach(([subtechniqueId, subtechniqueValue]) => {
              this.filterTactics(searchText, subtechniqueId, subtechniqueValue, techniqueId, techniqueValue, tacticId, tacticValue);
            });
          });
        });
      },
      filterTactics(searchText, id, value, parentId, parentValue, grandparentId, grandparentValue){
        if(searchText === '') {
          value.display = true;
          value.open = false;
        }
        else if (id.toLowerCase().includes(searchText) || value.name.toLowerCase().includes(searchText)){
          value.display = true;
          if(parentValue){
            parentValue.display = true;
            parentValue.open = true;
          }
          if (grandparentValue) {
            grandparentValue.display = true;
            grandparentValue.open = true;
          }
        }
        else if ((parentId?.toLowerCase().includes(searchText) || parentValue?.name.toLowerCase().includes(searchText))
                  || grandparentId?.toLowerCase().includes(searchText) || grandparentValue?.name.toLowerCase().includes(searchText)){
          let someTechniquesIncludeSearch;
          if (parentValue && !grandparentValue) {
            someTechniquesIncludeSearch = Object.entries(parentValue.techniques).some(([techniqueId, techniqueValue]) => {
              return techniqueValue.name.toLowerCase().includes(searchText) || techniqueId.toLowerCase().includes(searchText)
            });
          }
          value.display = true;
          parentValue.open = someTechniquesIncludeSearch;
        }
        else {
          value.display = false;
        }
      },
    },

    mounted(){
      if (this.evaluationSteps.length) this.getTactics();
      this.localFiltersUnchecked = this.filtersUnchecked;
      this.getEvaluationModifiers();
    },
};

const _withScopeId$1 = n => (pushScopeId("data-v-e3ca2479"),n=n(),popScopeId(),n);
const _hoisted_1$5 = /*#__PURE__*/ _withScopeId$1(() => /*#__PURE__*/createElementVNode("span", { class: "mk-text--black" }, " Show setup steps ", -1 /* HOISTED */));
const _hoisted_2$5 = { key: 1 };
const _hoisted_3$5 = ["onMouseenter", "onMouseleave"];
const _hoisted_4$5 = ["onClick"];
const _hoisted_5$5 = {
  key: 0,
  class: "mk-text--grey60 mk-text--caption"
};
const _hoisted_6$5 = {
  key: 2,
  class: "mt-4"
};
const _hoisted_7$5 = ["onMouseenter", "onMouseleave"];
const _hoisted_8$4 = ["href"];
const _hoisted_9$4 = ["onClick"];
const _hoisted_10$4 = { key: 0 };
const _hoisted_11$4 = ["onMouseenter", "onMouseleave"];
const _hoisted_12$4 = ["href"];
const _hoisted_13$3 = ["onClick"];
const _hoisted_14$3 = { key: 0 };
const _hoisted_15$3 = ["href"];
const _hoisted_16$2 = /*#__PURE__*/ _withScopeId$1(() => /*#__PURE__*/createElementVNode("span", null, "Modifiers", -1 /* HOISTED */));
const _hoisted_17$2 = {
  key: 4,
  class: "m-spacing--left-5 m-spacing--top-3"
};

function _sfc_render$4(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_tab = resolveComponent("v-tab");
  const _component_v_tabs = resolveComponent("v-tabs");
  const _component_v_icon = resolveComponent("v-icon");
  const _component_v_tooltip = resolveComponent("v-tooltip");
  const _component_v_switch = resolveComponent("v-switch");
  const _component_v_checkbox = resolveComponent("v-checkbox");
  const _component_v_text_field = resolveComponent("v-text-field");

  return (openBlock(), createElementBlock("div", null, [
    createVNode(_component_v_tabs, {
      modelValue: _ctx.localFiltersTab,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.localFiltersTab) = $event)),
      "bg-color": "white",
      class: normalizeClass({'mk-tabs': true, 'mb-4': true, 'border-radius-top-4': _ctx.$vuetify.display.mobile}),
      color: "primary"
    }, {
      default: withCtx(() => [
        createVNode(_component_v_tab, {
          value: "steps",
          "data-id": "results.filters.stepstab"
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString($props.selectedScenario.scenario_type === 'DETECTION' ? 'Steps' : 'Tests'), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }),
        ($props.selectedScenario && $props.selectedScenario.scenario_type !== 'PROTECTION')
          ? (openBlock(), createBlock(_component_v_tab, {
              key: 0,
              "data-id": "results.filters.tacticstab",
              value: "tactics"
            }, {
              default: withCtx(() => [
                createTextVNode(" Tactics ")
              ]),
              _: 1 /* STABLE */
            }))
          : createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue", "class"]),
    ($props.evaluationSteps.some(step => step.Substeps.some(substep => substep.Is_Setup)))
      ? (openBlock(), createBlock(_component_v_switch, {
          key: 0,
          "hide-details": "",
          color: "primary",
          class: "setup-switch",
          modelValue: _ctx.showSetup,
          "onUpdate:modelValue": [
            _cache[1] || (_cache[1] = $event => ((_ctx.showSetup) = $event)),
            _cache[2] || (_cache[2] = $event => (_ctx.$emit('updateShowSetup', _ctx.showSetup)))
          ]
        }, {
          label: withCtx(() => [
            _hoisted_1$5,
            createVNode(_component_v_tooltip, {
              "content-class": "mk-tooltip--top",
              location: "top"
            }, {
              activator: withCtx(({ props }) => [
                createVNode(_component_v_icon, mergeProps({
                  class: "ml-2",
                  size: "x-small"
                }, props), {
                  default: withCtx(() => [
                    createTextVNode("mdi-information-outline")
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */)
              ]),
              default: withCtx(() => [
                createTextVNode(" Setup steps are necessary to evaluate detections and provide scenario continuity. When ON, the setup steps are shown in the detailed results. ")
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue"]))
      : createCommentVNode("v-if", true),
    (_ctx.localFiltersTab === 'steps')
      ? (openBlock(), createElementBlock("div", _hoisted_2$5, [
          (openBlock(true), createElementBlock(Fragment, null, renderList($props.evaluationSteps.filter(step => !step.Substeps.every(substep => substep.Is_Setup) || _ctx.showSetup), (step) => {
            return (openBlock(), createElementBlock("div", {
              key: step.Step_Num || step.Test_Num
            }, [
              createElementVNode("div", {
                onMouseenter: $event => (step.hover = true),
                onMouseleave: $event => (step.hover = false)
              }, [
                createVNode(_component_v_checkbox, {
                  "data-id": "results.filters.stepcheckbox",
                  "hide-details": "",
                  modelValue: step.checked,
                  "onUpdate:modelValue": [$event => ((step.checked) = $event), $event => (_ctx.$emit('updateStepChecked', step))],
                  label: step.Step_Num ? step.Step_Num + ' - ' + step.Step_Name  : step.Test_Num  + ' - ' + step.Test_Name,
                  "true-icon": step.minusIcon ? 'mdi-minus-box' : '$checkboxOn',
                  class: normalizeClass({
              'mk-checkbox m-spacing--left-5 filter-checkbox': true,
              'checkbox-disabled': $props.evaluationSteps.filter(step => step.checked && (!step.Substeps.every(substep => substep.Is_Setup) || _ctx.showSetup)).length <= 1 && step.checked
            }),
                  color: "primary"
                }, {
                  append: withCtx(() => [
                    (step.Substeps.length)
                      ? (openBlock(), createElementBlock("div", {
                          key: 0,
                          class: "c-text--cursor-pointer",
                          onClick: $event => (step.open = !step.open)
                        }, [
                          (step.open && step.hover)
                            ? (openBlock(), createBlock(_component_v_icon, {
                                key: 0,
                                class: "pr-3 mk-text--grey60 filter-expand-icon",
                                "data-id": "results.filters.tacticcollapse"
                              }, {
                                default: withCtx(() => [
                                  createTextVNode("mdi-chevron-up")
                                ]),
                                _: 1 /* STABLE */
                              }))
                            : (step.hover)
                              ? (openBlock(), createBlock(_component_v_icon, {
                                  key: 1,
                                  class: "pr-3 mk-text--grey60 filter-expand-icon",
                                  "data-id": "results.filters.tacticexpand"
                                }, {
                                  default: withCtx(() => [
                                    createTextVNode("mdi-chevron-down")
                                  ]),
                                  _: 1 /* STABLE */
                                }))
                              : createCommentVNode("v-if", true)
                        ], 8 /* PROPS */, _hoisted_4$5))
                      : createCommentVNode("v-if", true)
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "onUpdate:modelValue", "label", "true-icon", "class"])
              ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_3$5),
              (openBlock(true), createElementBlock(Fragment, null, renderList(step.Substeps, (substep) => {
                return (openBlock(), createElementBlock("div", {
                  key: substep.Substep_Id
                }, [
                  (step.open && (!substep.Is_Setup || _ctx.showSetup))
                    ? (openBlock(), createBlock(_component_v_checkbox, {
                        key: 0,
                        "data-id": "results.filters.substepcheckbox",
                        "hide-details": "",
                        modelValue: substep.checked,
                        "onUpdate:modelValue": [$event => ((substep.checked) = $event), $event => (_ctx.$emit('updateSubstepChecked', substep, step))],
                        class: normalizeClass({
              'mk-checkbox filter-checkbox m-spacing--left-8': true,
            })
                      }, {
                        label: withCtx(() => [
                          createElementVNode("span", null, [
                            createTextVNode(toDisplayString(substep.Technique.Technique_Id ? `${substep.Substep} - ${substep.Technique.Technique_Name}` : substep.Substep) + " ", 1 /* TEXT */),
                            (substep.Is_Setup)
                              ? (openBlock(), createElementBlock("span", _hoisted_5$5, " Setup Step "))
                              : createCommentVNode("v-if", true)
                          ])
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "onUpdate:modelValue"]))
                    : createCommentVNode("v-if", true)
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : (openBlock(), createElementBlock("div", _hoisted_6$5, [
          createCommentVNode(" tactic filters "),
          createVNode(_component_v_text_field, {
            class: "mk-text-field m-spacing--left-4 m-spacing--bottom-4",
            variant: "outlined",
            placeholder: "Search tactics, techniques, and subtechniques",
            modelValue: _ctx.searchText,
            "onUpdate:modelValue": [
              _cache[3] || (_cache[3] = $event => ((_ctx.searchText) = $event)),
              $options.filterTacticsView
            ],
            "hide-details": ""
          }, {
            "prepend-inner": withCtx(() => [
              createVNode(_component_v_icon, null, {
                default: withCtx(() => [
                  createTextVNode("mdi-magnify")
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"]),
          (openBlock(true), createElementBlock(Fragment, null, renderList(Object.entries(_ctx.localTactics), ([tacticId, tacticValue]) => {
            return (openBlock(), createElementBlock("div", { key: tacticId }, [
              createElementVNode("div", {
                onMouseenter: $event => (tacticValue.hover = true),
                onMouseleave: $event => (tacticValue.hover = false)
              }, [
                (tacticValue.display)
                  ? (openBlock(), createBlock(_component_v_checkbox, {
                      key: 0,
                      modelValue: tacticValue.checked,
                      "onUpdate:modelValue": [$event => ((tacticValue.checked) = $event), $event => ($options.tacticCheckedUpdated(tacticId, tacticValue))],
                      "data-id": "results.filters.tacticcheckbox",
                      "hide-details": "",
                      class: normalizeClass({
              'mk-checkbox m-spacing--left-5 filter-checkbox': true,
              'checkbox-disabled': tacticValue.checked && Object.values(_ctx.localTactics).filter(tactic => tactic.checked).length === 1
            }),
                      "true-icon": tacticValue.minusIcon ? 'mdi-minus-box' : '$checkboxOn',
                      color: "primary"
                    }, {
                      label: withCtx(() => [
                        createElementVNode("span", null, [
                          createTextVNode(toDisplayString(tacticValue.name) + " (", 1 /* TEXT */),
                          createElementVNode("a", {
                            href: `${_ctx.$mitreAttackExternalLink}tactics/${tacticId}`,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            "data-id": "results.filters.tacticlink"
                          }, toDisplayString(tacticId), 9 /* TEXT, PROPS */, _hoisted_8$4),
                          createTextVNode(") ")
                        ])
                      ]),
                      append: withCtx(() => [
                        (Object.keys(tacticValue.techniques).length)
                          ? (openBlock(), createElementBlock("div", {
                              key: 0,
                              class: "c-text--cursor-pointer",
                              onClick: $event => (tacticValue.open = !tacticValue.open)
                            }, [
                              (tacticValue.open && tacticValue.hover)
                                ? (openBlock(), createBlock(_component_v_icon, {
                                    key: 0,
                                    class: "pr-3 mk-text--grey60 filter-expand-icon",
                                    "data-id": "results.filters.tacticcollapse"
                                  }, {
                                    default: withCtx(() => [
                                      createTextVNode("mdi-chevron-up")
                                    ]),
                                    _: 1 /* STABLE */
                                  }))
                                : (tacticValue.hover)
                                  ? (openBlock(), createBlock(_component_v_icon, {
                                      key: 1,
                                      class: "pr-3 mk-text--grey60 filter-expand-icon",
                                      "data-id": "results.filters.tacticexpand"
                                    }, {
                                      default: withCtx(() => [
                                        createTextVNode("mdi-chevron-down")
                                      ]),
                                      _: 1 /* STABLE */
                                    }))
                                  : createCommentVNode("v-if", true)
                            ], 8 /* PROPS */, _hoisted_9$4))
                          : createCommentVNode("v-if", true)
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "onUpdate:modelValue", "class", "true-icon"]))
                  : createCommentVNode("v-if", true)
              ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_7$5),
              (tacticValue.open)
                ? (openBlock(), createElementBlock("div", _hoisted_10$4, [
                    createCommentVNode(" technique filters "),
                    (openBlock(true), createElementBlock(Fragment, null, renderList(Object.entries(tacticValue.techniques), ([techniqueId, techniqueValue]) => {
                      return (openBlock(), createElementBlock("div", { key: techniqueId }, [
                        createElementVNode("div", {
                          onMouseenter: $event => (techniqueValue.hover = true),
                          onMouseleave: $event => (techniqueValue.hover = false)
                        }, [
                          (techniqueValue.display)
                            ? (openBlock(), createBlock(_component_v_checkbox, {
                                key: 0,
                                "data-id": "results.filters.techniquecheckbox",
                                "hide-details": "",
                                class: normalizeClass({
                  'mk-checkbox filter-checkbox m-spacing--left-8': true,
                  'checkbox-disabled': techniqueValue.checked
                    && Object.values(this.localTactics).filter(tactic => tactic.checked).length === 1
                    && Object.values(tacticValue.techniques).filter(technique => technique.checked).length === 1
                }),
                                modelValue: techniqueValue.checked,
                                "onUpdate:modelValue": [$event => ((techniqueValue.checked) = $event), $event => ($options.techniqueCheckedUpdated(tacticId, tacticValue, techniqueId, techniqueValue))],
                                "true-icon": techniqueValue.minusIcon ? 'mdi-minus-box' : '$checkboxOn',
                                color: "primary"
                              }, {
                                label: withCtx(() => [
                                  createElementVNode("span", null, [
                                    createTextVNode(toDisplayString(techniqueValue.name) + " (", 1 /* TEXT */),
                                    createElementVNode("a", {
                                      href: `${_ctx.$mitreAttackExternalLink}techniques/${techniqueId}`,
                                      target: "_blank",
                                      rel: "noopener noreferrer",
                                      "data-id": "results.filters.techniquelink"
                                    }, toDisplayString(techniqueId), 9 /* TEXT, PROPS */, _hoisted_12$4),
                                    createTextVNode(") ")
                                  ])
                                ]),
                                append: withCtx(() => [
                                  (Object.keys(techniqueValue.subtechniques).length)
                                    ? (openBlock(), createElementBlock("div", {
                                        key: 0,
                                        class: "c-text--cursor-pointer",
                                        onClick: $event => (techniqueValue.open = !techniqueValue.open)
                                      }, [
                                        (techniqueValue.open && techniqueValue.hover)
                                          ? (openBlock(), createBlock(_component_v_icon, {
                                              key: 0,
                                              class: "pr-3 mk-text--grey60",
                                              "data-id": "results.filters.techniquecollapse"
                                            }, {
                                              default: withCtx(() => [
                                                createTextVNode("mdi-chevron-up")
                                              ]),
                                              _: 1 /* STABLE */
                                            }))
                                          : (techniqueValue.hover)
                                            ? (openBlock(), createBlock(_component_v_icon, {
                                                key: 1,
                                                class: "pr-3 mk-text--grey60",
                                                "data-id": "results.filters.techniquecollapse"
                                              }, {
                                                default: withCtx(() => [
                                                  createTextVNode("mdi-chevron-down")
                                                ]),
                                                _: 1 /* STABLE */
                                              }))
                                            : createCommentVNode("v-if", true)
                                      ], 8 /* PROPS */, _hoisted_13$3))
                                    : createCommentVNode("v-if", true)
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["class", "modelValue", "onUpdate:modelValue", "true-icon"]))
                            : createCommentVNode("v-if", true)
                        ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_11$4),
                        createCommentVNode(" subtechnique filters "),
                        (techniqueValue.open)
                          ? (openBlock(), createElementBlock("div", _hoisted_14$3, [
                              (openBlock(true), createElementBlock(Fragment, null, renderList(Object.entries(techniqueValue.subtechniques), ([subtechniqueId, subtechniqueValue]) => {
                                return (openBlock(), createElementBlock("div", { key: subtechniqueId }, [
                                  (subtechniqueValue.display)
                                    ? (openBlock(), createBlock(_component_v_checkbox, {
                                        key: 0,
                                        "data-id": "results.filters.subtechniquecheckbox",
                                        "hide-details": "",
                                        class: normalizeClass({
                    'mk-checkbox filter-checkbox subtechnique-checkbox': true,
                    'checkbox-disabled': subtechniqueValue.checked &&
                                         Object.values(tacticValue.techniques).filter(technique => technique.checked).length === 1 &&
                                         Object.values(techniqueValue.subtechniques).filter(subtechnique => subtechnique.checked).length === 1}),
                                        modelValue: subtechniqueValue.checked,
                                        "onUpdate:modelValue": [$event => ((subtechniqueValue.checked) = $event), $event => ($options.subtechniqueCheckedUpdated(tacticId, tacticValue, techniqueId, techniqueValue, subtechniqueId, subtechniqueValue))],
                                        label: subtechniqueValue.name + ' (' + subtechniqueId + ')'
                                      }, {
                                        label: withCtx(() => [
                                          createElementVNode("span", null, [
                                            createTextVNode(toDisplayString(subtechniqueValue.name) + " (", 1 /* TEXT */),
                                            createElementVNode("a", {
                                              href: `${_ctx.$mitreAttackExternalLink}techniques/${subtechniqueId.replace('.', '/')}/`,
                                              target: "_blank",
                                              "data-id": "results.filters.subtechniquelink",
                                              rel: "noopener noreferrer"
                                            }, toDisplayString(subtechniqueId), 9 /* TEXT, PROPS */, _hoisted_15$3),
                                            createTextVNode(") ")
                                          ])
                                        ]),
                                        _: 2 /* DYNAMIC */
                                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["class", "modelValue", "onUpdate:modelValue", "label"]))
                                    : createCommentVNode("v-if", true)
                                ]))
                              }), 128 /* KEYED_FRAGMENT */))
                            ]))
                          : createCommentVNode("v-if", true)
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]))
                : createCommentVNode("v-if", true)
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ])),
    createCommentVNode(" modifier filters "),
    (_ctx.modifiers.length > 0)
      ? (openBlock(), createElementBlock("div", {
          key: 3,
          class: "c-text--cursor-pointer m-spacing--top-5",
          onClick: _cache[4] || (_cache[4] = $event => (_ctx.modifierMenu = !_ctx.modifierMenu))
        }, [
          (_ctx.modifierMenu)
            ? (openBlock(), createBlock(_component_v_icon, {
                key: 0,
                class: "pr-3",
                color: "primary",
                "data-id": "results.filters.modifierscollapse"
              }, {
                default: withCtx(() => [
                  createTextVNode("mdi-chevron-up")
                ]),
                _: 1 /* STABLE */
              }))
            : (openBlock(), createBlock(_component_v_icon, {
                key: 1,
                class: "pr-3",
                color: "primary",
                "data-id": "results.filters.modifiersexpand"
              }, {
                default: withCtx(() => [
                  createTextVNode("mdi-chevron-down")
                ]),
                _: 1 /* STABLE */
              })),
          _hoisted_16$2
        ]))
      : createCommentVNode("v-if", true),
    (_ctx.modifierMenu)
      ? (openBlock(), createElementBlock("div", _hoisted_17$2, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.modifiers, (modifier) => {
            return (openBlock(), createBlock(_component_v_checkbox, {
              class: "mk-checkbox filter-checkbox",
              "data-id": "results.filters.modifiercheckbox",
              "hide-details": "",
              key: modifier.label,
              label: modifier.label,
              modelValue: modifier.checked,
              "onUpdate:modelValue": [$event => ((modifier.checked) = $event), $event => ($options.modifierCheckedUpdated(modifier))]
            }, null, 8 /* PROPS */, ["label", "modelValue", "onUpdate:modelValue"]))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : createCommentVNode("v-if", true)
  ]))
}
var Filters = /*#__PURE__*/_export_sfc(_sfc_main$6, [['render',_sfc_render$4],['__scopeId',"data-v-e3ca2479"],['__file',"/home/runner/work/evals-website/evals-website/packages/enterprise-results/src/Filters.vue"]]);

var css_248z$3 = "";
styleInject(css_248z$3);

const _sfc_main$5 = {
  name: "VendorSummaryModal",
  props: {
    vendor: Object,
    selectedEvaluation: Object,
    breachScreenshots: Array,
    selectedScenario: Object,
    screenshotUrl: String,
    preview: Boolean,
  },
  components: {
    ModalCarousel,
  },
  data: () => ({
    showActionButtons: false,
    route: useRoute(),
    screenshotDisplayed: undefined,
  }),
  methods: {
    closeModal() {
      this.$emit("updateVendorSummaryModal", false);
    },
    updateScreenshotDisplayed(value) {
      this.screenshotDisplayed = value;
    },
  },
};
const _hoisted_1$4 = { class: "mk-text--h5" };
const _hoisted_2$4 = { class: "mk-text--h4" };
const _hoisted_3$4 = { class: "mk-text--body" };
const _hoisted_4$4 = { class: "mb-auto" };
const _hoisted_5$4 = ["href"];
const _hoisted_6$4 = ["href"];
const _hoisted_7$4 = { class: "mk-text--caption" };

function _sfc_render$3(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_col = resolveComponent("v-col");
  const _component_v_row = resolveComponent("v-row");
  const _component_ModalCarousel = resolveComponent("ModalCarousel");
  const _component_v_card_text = resolveComponent("v-card-text");
  const _component_v_card = resolveComponent("v-card");

  return (openBlock(), createBlock(_component_v_card, { color: "white" }, {
    default: withCtx(() => [
      createVNode(_component_v_card_text, {
        onMouseenter: _cache[1] || (_cache[1] = $event => (_ctx.showActionButtons = true)),
        onMouseleave: _cache[2] || (_cache[2] = $event => (_ctx.showActionButtons = false))
      }, {
        default: withCtx(() => [
          createElementVNode("div", null, [
            createVNode(_component_v_row, null, {
              default: withCtx(() => [
                createVNode(_component_v_col, { cols: "10" }, {
                  default: withCtx(() => [
                    createElementVNode("div", _hoisted_1$4, toDisplayString($props.vendor.display_name), 1 /* TEXT */),
                    createElementVNode("div", _hoisted_2$4, toDisplayString($props.selectedEvaluation.display_name) + " " + toDisplayString($props.selectedScenario.name), 1 /* TEXT */),
                    createElementVNode("div", _hoisted_3$4, toDisplayString($props.vendor.display_name) + "'s provided response summary ", 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }),
                createVNode(_component_v_col, {
                  cols: "2",
                  class: "text-right d-flex flex-column"
                }, {
                  default: withCtx(() => [
                    createElementVNode("div", _hoisted_4$4, [
                      createElementVNode("a", {
                        "data-id": "results.vendorsummarymodal.participantconfigurationlink",
                        href: `/results/${_ctx.route.params.domain}/${$props.vendor.name}/${$props.selectedEvaluation.name}_configuration`,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        class: normalizeClass({ 'mk-link--disabled': $props.preview })
                      }, [
                        createElementVNode("span", {
                          class: normalizeClass({
                    'mk-text--grey60 icon--hover': _ctx.showActionButtons,
                    'c-text--white': !_ctx.showActionButtons,
                    'material-symbols-rounded icon--hover': true,
                  })
                        }, "settings", 2 /* CLASS */)
                      ], 10 /* CLASS, PROPS */, _hoisted_5$4),
                      ($props.breachScreenshots[_ctx.screenshotDisplayed])
                        ? (openBlock(), createElementBlock("a", {
                            key: 0,
                            href: `${$props.screenshotUrl}${$props.breachScreenshots[_ctx.screenshotDisplayed]}`,
                            download: "",
                            "data-id": "results.vendorsummarymodal.downloadscreenshotbutton"
                          }, [
                            createElementVNode("span", {
                              class: normalizeClass({
                    'mk-text--grey60 icon--hover c-text--cursor-pointer':
                      _ctx.showActionButtons,
                    'c-text--white': !_ctx.showActionButtons,
                    'material-symbols-rounded icon--hover': true,
                  })
                            }, "download", 2 /* CLASS */)
                          ], 8 /* PROPS */, _hoisted_6$4))
                        : createCommentVNode("v-if", true),
                      createElementVNode("span", {
                        class: normalizeClass({
                  'mk-text--grey60 icon--hover c-text--cursor-pointer':
                    _ctx.showActionButtons,
                  'c-text--white': !_ctx.showActionButtons,
                  'material-symbols-rounded icon--hover': true,
                }),
                        "data-id": "results.vendorsummarymodal.closemodalbutton",
                        onClick: _cache[0] || (_cache[0] = (...args) => ($options.closeModal && $options.closeModal(...args)))
                      }, "close ", 2 /* CLASS */)
                    ])
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }),
            createVNode(_component_v_row, null, {
              default: withCtx(() => [
                createVNode(_component_v_col, { class: "col--no-spacing-bottom" }, {
                  default: withCtx(() => [
                    createVNode(_component_ModalCarousel, {
                      screenshots: $props.breachScreenshots,
                      screenshotUrl: $props.screenshotUrl,
                      preview: $props.preview,
                      onUpdateScreenshotDisplayed: $options.updateScreenshotDisplayed
                    }, null, 8 /* PROPS */, ["screenshots", "screenshotUrl", "preview", "onUpdateScreenshotDisplayed"])
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }),
            createVNode(_component_v_row, null, {
              default: withCtx(() => [
                createVNode(_component_v_col, { class: "text-center c-col--no-padding-top m-spacing--bottom-4" }, {
                  default: withCtx(() => [
                    createElementVNode("span", _hoisted_7$4, "Screenshot " + toDisplayString(_ctx.screenshotDisplayed + 1) + " of " + toDisplayString($props.breachScreenshots.length), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            })
          ])
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }))
}
var VendorSummaryModal = /*#__PURE__*/_export_sfc(_sfc_main$5, [['render',_sfc_render$3],['__scopeId',"data-v-4c364b21"],['__file',"/home/runner/work/evals-website/evals-website/packages/enterprise-results/src/VendorSummaryModal.vue"]]);

var css_248z$2 = "";
styleInject(css_248z$2);

const _sfc_main$4 = {
    name: 'VendorLogoAndHoverButtons',
    components: {
      VendorSummaryModal
    },

    data: () => ({
      route: useRoute(),
      vendorsHover: {},
      vendorSummaryModal: false,
      vendorDisclaimer: true
    }),

    props: {
      removeVendor: Function,
      selectedEvaluation: Object,
      vendor: Object,
      vendorsHoverDict: Object,
      breachScreenshots: Array,
      selectedScenario: Object,
      vendorLogoUrl: String,
      screenshotUrl: String,
      preview: Boolean,
      archiveUrl: String,
      isEnriched: Boolean,
      enrichedCriteria: Object,
      scenarioMetricPreview: Boolean,
    },

    watch: {
      vendorDisclaimer(value){
        this.$emit("updateVendorDisclaimerExpanded", value);
      }
    },

    methods: {
      updateVendorSummaryModal(value) {
        this.vendorSummaryModal = value;
      },

      getJSONData(vendor) {
        this.$api
          .get(`export/?participant=${vendor}&adversary=${this.selectedEvaluation.name}`)
          .then((response) => {
            if (!response.data.length) {
              alert(
              `There was a problem with the ${this.selectedEvaluation.display_name} download. ` +
                'If this problem persists, please contact us at evals@mitre-engenuity.org.',
              );
            } else exportJSON(response.data[0], `${vendor}_${this.selectedEvaluation.name}_results.json`);
         });
      },

      getEnrichedChecklistText(question) {
        return getEnrichedCriteriaText(question)
      }
    },

    mounted(){
      this.vendorsHover = this.vendorsHoverDict;
    }
  };

const _withScopeId = n => (pushScopeId("data-v-cb7fdb2f"),n=n(),popScopeId(),n);
const _hoisted_1$3 = ["href"];
const _hoisted_2$3 = { class: "d-flex justify-center align-center" };
const _hoisted_3$3 = { class: "text-h5" };
const _hoisted_4$3 = {
  key: 0,
  class: "text-right ml-2"
};
const _hoisted_5$3 = { class: "text-left" };
const _hoisted_6$3 = { class: "d-flex align-center m-spacing--bottom-5" };
const _hoisted_7$3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/createElementVNode("span", { style: {"height":"16px"} }, "Enriched", -1 /* HOISTED */));
const _hoisted_8$3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/createElementVNode("span", null, "Report(s) included contextual analysis (e.g. highlighting relationships between steps, providing heat maps of observed behaviors, etc.)", -1 /* HOISTED */));
const _hoisted_9$3 = {
  key: 0,
  class: "mk-text--grey50"
};
const _hoisted_10$3 = { key: 2 };
const _hoisted_11$3 = { class: "m-spacing--top-2" };
const _hoisted_12$3 = ["href"];
const _hoisted_13$2 = { class: "text-h5" };
const _hoisted_14$2 = ["href"];
const _hoisted_15$2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/createElementVNode("a", {
  href: "https://console.amp.cisco.com/help/en/Content/Secure_Endpoint_User_Guide/Release_Notes/202408.html",
  target: "_blank",
  rel: "noopener"
}, "Cisco Secure Endpoint 8.4.1.30307 Release Notes.", -1 /* HOISTED */));

function _sfc_render$2(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_row = resolveComponent("v-row");
  const _component_v_img = resolveComponent("v-img");
  const _component_v_icon = resolveComponent("v-icon");
  const _component_v_col = resolveComponent("v-col");
  const _component_v_chip = resolveComponent("v-chip");
  const _component_v_tooltip = resolveComponent("v-tooltip");
  const _component_v_divider = resolveComponent("v-divider");
  const _component_v_alert = resolveComponent("v-alert");
  const _component_v_slide_x_reverse_transition = resolveComponent("v-slide-x-reverse-transition");
  const _component_VendorSummaryModal = resolveComponent("VendorSummaryModal");
  const _component_v_dialog = resolveComponent("v-dialog");

  return (_ctx.vendorsHover[$props.vendor.name])
    ? (openBlock(), createElementBlock("div", {
        key: 0,
        onMouseenter: _cache[6] || (_cache[6] = $event => (_ctx.vendorsHover[$props.vendor.name].hovered = true)),
        onMouseleave: _cache[7] || (_cache[7] = $event => (_ctx.vendorsHover[$props.vendor.name].hovered = false))
      }, [
        createVNode(_component_v_row, { class: "justify-end hover-btn-row" }, {
          default: withCtx(() => [
            ($props.selectedScenario.scenario_type === 'DETECTION' && $props.breachScreenshots.length)
              ? (openBlock(), createElementBlock("span", {
                  key: 0,
                  onClick: _cache[0] || (_cache[0] = $event => (_ctx.vendorSummaryModal = true)),
                  "data-id": "results.vendorlogoandhoverbuttons.vendorsummarymodalbutton",
                  class: normalizeClass({
          'mk-text--grey60 c-text--cursor-pointer': _ctx.vendorsHover[$props.vendor.name].hovered,
          'c-text--white': !_ctx.vendorsHover[$props.vendor.name].hovered,
          'material-symbols-rounded icon--hover': true
        })
                }, "summarize", 2 /* CLASS */))
              : createCommentVNode("v-if", true),
            createElementVNode("a", {
              href: `/results/${_ctx.route.params.domain}/${$props.vendor.name}/${$props.selectedEvaluation.name}_configuration`,
              target: "_blank",
              "data-id": "results.vendorlogoandhoverbuttons.participantconfigurationlink",
              rel: "noopener noreferrer",
              class: normalizeClass({'mk-link--disabled': $props.preview})
            }, [
              ($props.selectedEvaluation.name !== 'oilrig')
                ? (openBlock(), createElementBlock("span", {
                    key: 0,
                    class: normalizeClass({
            'mk-text--grey60 icon--hover': _ctx.vendorsHover[$props.vendor.name].hovered,
            'c-text--white': !_ctx.vendorsHover[$props.vendor.name].hovered,
            'material-symbols-rounded icon--hover': true
          })
                  }, "settings", 2 /* CLASS */))
                : createCommentVNode("v-if", true)
            ], 10 /* CLASS, PROPS */, _hoisted_1$3),
            createElementVNode("span", {
              class: normalizeClass({
          'mk-text--grey60 icon--hover c-text--cursor-pointer': _ctx.vendorsHover[$props.vendor.name].hovered,
          'c-text--white': !_ctx.vendorsHover[$props.vendor.name].hovered,
          'material-symbols-rounded icon--hover': true,
        }),
              onClick: _cache[1] || (_cache[1] = $event => (!$props.preview && $options.getJSONData($props.vendor.name))),
              "data-id": "results.vendorlogoandhoverbuttons.downloadjsonbutton"
            }, "download", 2 /* CLASS */),
            createElementVNode("span", {
              class: normalizeClass({
          'mk-text--grey60 icon--hover c-text--cursor-pointer': _ctx.vendorsHover[$props.vendor.name].hovered,
          'c-text--white': !_ctx.vendorsHover[$props.vendor.name].hovered,
          'material-symbols-rounded icon--hover': true
        }),
              "data-id": "results.vendorlogoandhoverbuttons.removevendorbutton",
              onClick: _cache[2] || (_cache[2] = $event => ($props.removeVendor($props.vendor)))
            }, "close", 2 /* CLASS */)
          ]),
          _: 1 /* STABLE */
        }),
        createVNode(_component_v_row, null, {
          default: withCtx(() => [
            createVNode(_component_v_img, {
              src: this.scenarioMetricPreview ? this.vendorLogoUrl + $props.vendor.logo.name : this.vendorLogoUrl + $props.vendor.logo_image,
              height: "10vh",
              class: "vendor-logo"
            }, null, 8 /* PROPS */, ["src"])
          ]),
          _: 1 /* STABLE */
        }),
        createVNode(_component_v_row, {
          class: "mt-4",
          id: "vendor-name"
        }, {
          default: withCtx(() => [
            (!_ctx.vendorDisclaimer ||
          (($props.vendor.name !== 'sophos' || $props.selectedEvaluation.name !== 'oilrig') &&
           ($props.vendor.name !== 'microsoft' || $props.selectedEvaluation.name !== 'turla') &&
           ($props.vendor.name !== 'cisco' || $props.selectedEvaluation.name !== 'er6') &&
           ($props.vendor.name !== 'checkpoint' || $props.selectedEvaluation.name !== 'er6' || $props.selectedScenario.scenario_type !== 'PROTECTION')))
              ? (openBlock(), createBlock(_component_v_col, {
                  key: 0,
                  class: "text-center",
                  cols: "12"
                }, {
                  default: withCtx(() => [
                    createElementVNode("div", _hoisted_2$3, [
                      createElementVNode("p", _hoisted_3$3, toDisplayString($props.vendor.display_name), 1 /* TEXT */),
                      ((
              ($props.vendor.name === 'sophos' && $props.selectedEvaluation.name === 'oilrig') ||
              ($props.vendor.name === 'microsoft' && $props.selectedEvaluation.name === 'turla') ||
              ($props.vendor.name === 'cisco' && $props.selectedEvaluation.name === 'er6') ||
              ($props.vendor.name === 'checkpoint' && $props.selectedEvaluation.name === 'er6' && $props.selectedScenario.scenario_type === 'PROTECTION')) &&
              !_ctx.vendorDisclaimer)
                        ? (openBlock(), createElementBlock("div", _hoisted_4$3, [
                            createVNode(_component_v_icon, {
                              onClick: _cache[3] || (_cache[3] = $event => (_ctx.vendorDisclaimer = true)),
                              class: "c-text--cursor-pointer mk-text--blue-info",
                              "data-id": "results.vendorlogoandhoverbuttons.microsoftdisclaimer.informationbutton"
                            }, {
                              default: withCtx(() => [
                                createTextVNode(" mdi-information-outline ")
                              ]),
                              _: 1 /* STABLE */
                            })
                          ]))
                        : createCommentVNode("v-if", true)
                    ]),
                    ($props.archiveUrl)
                      ? (openBlock(), createBlock(_component_v_row, {
                          key: 0,
                          class: "mt-4",
                          dense: ""
                        }, {
                          default: withCtx(() => [
                            createVNode(_component_v_col, { cols: "3" }, {
                              default: withCtx(() => [
                                createVNode(_component_v_img, {
                                  src: `${_ctx.$imageSrc}${$props.vendor.name}_${$props.selectedEvaluation.name}_report.png`,
                                  "max-height": "120",
                                  contain: "",
                                  class: "vendor-report"
                                }, null, 8 /* PROPS */, ["src"])
                              ]),
                              _: 1 /* STABLE */
                            }),
                            createVNode(_component_v_col, { cols: "8" }, {
                              default: withCtx(() => [
                                createElementVNode("div", _hoisted_5$3, [
                                  createElementVNode("div", _hoisted_6$3, [
                                    createElementVNode("p", null, toDisplayString($props.vendor.display_name) + " Report", 1 /* TEXT */),
                                    ($props.isEnriched)
                                      ? (openBlock(), createBlock(_component_v_tooltip, {
                                          key: 0,
                                          "content-class": "mk-tooltip--allow-pointer-events",
                                          location: "top"
                                        }, {
                                          activator: withCtx(({ props }) => [
                                            createVNode(_component_v_chip, mergeProps({
                                              class: "m-spacing--left-4",
                                              label: "",
                                              size: "small",
                                              "prepend-icon": "mdi-star-outline"
                                            }, props), {
                                              default: withCtx(() => [
                                                _hoisted_7$3
                                              ]),
                                              _: 2 /* DYNAMIC */
                                            }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */)
                                          ]),
                                          default: withCtx(() => [
                                            _hoisted_8$3
                                          ]),
                                          _: 1 /* STABLE */
                                        }))
                                      : createCommentVNode("v-if", true)
                                  ]),
                                  (openBlock(true), createElementBlock(Fragment, null, renderList($props.enrichedCriteria, (question, index) => {
                                    return (openBlock(), createElementBlock(Fragment, { key: question }, [
                                      ($options.getEnrichedChecklistText(question.Question) && question.Answer === false)
                                        ? (openBlock(), createElementBlock("span", _hoisted_9$3, "No "))
                                        : createCommentVNode("v-if", true),
                                      ($options.getEnrichedChecklistText(question.Question))
                                        ? (openBlock(), createElementBlock("span", {
                                            key: 1,
                                            class: normalizeClass(question.Answer === true ? 'mk-text--grey90' : 'mk-text--grey50')
                                          }, toDisplayString($options.getEnrichedChecklistText(question.Question)), 3 /* TEXT, CLASS */))
                                        : createCommentVNode("v-if", true),
                                      ($options.getEnrichedChecklistText(question.Question) && index > 0 && index < $props.enrichedCriteria.length-1)
                                        ? (openBlock(), createElementBlock("span", _hoisted_10$3, " • "))
                                        : createCommentVNode("v-if", true)
                                    ], 64 /* STABLE_FRAGMENT */))
                                  }), 128 /* KEYED_FRAGMENT */)),
                                  createElementVNode("div", _hoisted_11$3, [
                                    createElementVNode("a", {
                                      class: "text-caption",
                                      href: $props.preview ? `${$props.vendorLogoUrl}${$props.archiveUrl}` : `${_ctx.$imageSrc}${$props.archiveUrl}`,
                                      target: "_blank",
                                      "data-id": "results.vendorlogoandhoverbuttons.zipfilelink",
                                      rel: "noopener noreferrer"
                                    }, " Download ", 8 /* PROPS */, _hoisted_12$3)
                                  ])
                                ])
                              ]),
                              _: 1 /* STABLE */
                            })
                          ]),
                          _: 1 /* STABLE */
                        }))
                      : createCommentVNode("v-if", true),
                    createVNode(_component_v_divider, { class: "mt-4" })
                  ]),
                  _: 1 /* STABLE */
                }))
              : (openBlock(), createBlock(_component_v_col, {
                  key: 1,
                  id: "vendor-disclaimer"
                }, {
                  default: withCtx(() => [
                    createElementVNode("p", _hoisted_13$2, toDisplayString($props.vendor.display_name), 1 /* TEXT */),
                    createVNode(_component_v_col, null, {
                      default: withCtx(() => [
                        createVNode(_component_v_slide_x_reverse_transition, null, {
                          default: withCtx(() => [
                            createVNode(_component_v_alert, {
                              modelValue: _ctx.vendorDisclaimer,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.vendorDisclaimer) = $event)),
                              closable: "",
                              "close-label": "Close Alert",
                              class: "mk-toast-notification--info text-left",
                              icon: "mdi-information-outline",
                              border: "start"
                            }, {
                              default: withCtx(() => [
                                ($props.vendor.name === 'microsoft')
                                  ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                                      createTextVNode(" Notable specifics for this evaluation are described in the "),
                                      createElementVNode("a", {
                                        href: `/results/${_ctx.route.params.domain}/${$props.vendor.name}/${$props.selectedEvaluation.name}_configuration`,
                                        "data-id": "results.vendorlogoandhoverbuttons.microsoftdisclaimer.participantconfigurationlink",
                                        target: "_blank",
                                        rel: "noopener noreferrer"
                                      }, "configuration settings ", 8 /* PROPS */, _hoisted_14$2)
                                    ], 64 /* STABLE_FRAGMENT */))
                                  : ($props.vendor.name === 'sophos')
                                    ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                                        createTextVNode(" Footnotes have been added to 1.A.4, 1.A.5, 1.A.6, and 1.A.7. ")
                                      ], 64 /* STABLE_FRAGMENT */))
                                    : ($props.vendor.name === 'checkpoint')
                                      ? (openBlock(), createElementBlock(Fragment, { key: 2 }, [
                                          createTextVNode(" The evaluation environment did not accurately reflect the participant’s solution. As a result, we were unable to obtain results for this scenario. ")
                                        ], 64 /* STABLE_FRAGMENT */))
                                      : ($props.vendor.name === 'cisco')
                                        ? (openBlock(), createElementBlock(Fragment, { key: 3 }, [
                                            createTextVNode(" The version of Cisco Secure Endpoint used during testing was superseded by version 8.4.1.30307 which resolved issues causing Windows system crashes and crashes in the Cisco Secure Endpoint Behavioral Protection component: "),
                                            _hoisted_15$2
                                          ], 64 /* STABLE_FRAGMENT */))
                                        : createCommentVNode("v-if", true)
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["modelValue"])
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    }),
                    createVNode(_component_v_divider, { class: "mt-4" })
                  ]),
                  _: 1 /* STABLE */
                }))
          ]),
          _: 1 /* STABLE */
        }),
        createVNode(_component_v_dialog, {
          modelValue: _ctx.vendorSummaryModal,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.vendorSummaryModal) = $event)),
          width: "auto"
        }, {
          default: withCtx(() => [
            createVNode(_component_VendorSummaryModal, {
              vendor: $props.vendor,
              selectedEvaluation: $props.selectedEvaluation,
              breachScreenshots: $props.breachScreenshots,
              selectedScenario: $props.selectedScenario,
              screenshotUrl: $props.screenshotUrl,
              preview: $props.preview,
              onUpdateVendorSummaryModal: $options.updateVendorSummaryModal
            }, null, 8 /* PROPS */, ["vendor", "selectedEvaluation", "breachScreenshots", "selectedScenario", "screenshotUrl", "preview", "onUpdateVendorSummaryModal"])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue"])
      ], 32 /* HYDRATE_EVENTS */))
    : createCommentVNode("v-if", true)
}
var VendorLogoAndHoverButtons = /*#__PURE__*/_export_sfc(_sfc_main$4, [['render',_sfc_render$2],['__scopeId',"data-v-cb7fdb2f"],['__file',"/home/runner/work/evals-website/evals-website/packages/enterprise-results/src/VendorLogoAndHoverButtons.vue"]]);

const _hoisted_1$2 = ["id"];
const _hoisted_2$2 = { class: "d-flex mt-3 justify-space-between" };
const _hoisted_3$2 = /*#__PURE__*/createElementVNode("p", null, "Noise Steps", -1 /* HOISTED */);
const _hoisted_4$2 = {
  key: 0,
  class: "d-flex flex-column noise-legend"
};
const _hoisted_5$2 = { class: "d-flex" };
const _hoisted_6$2 = /*#__PURE__*/createElementVNode("p", null, "Reported", -1 /* HOISTED */);
const _hoisted_7$2 = { class: "d-flex" };
const _hoisted_8$2 = /*#__PURE__*/createElementVNode("p", null, "Not Reported", -1 /* HOISTED */);
const _hoisted_9$2 = { class: "d-flex" };
const _hoisted_10$2 = /*#__PURE__*/createElementVNode("p", null, "Not Applicable (N/A)", -1 /* HOISTED */);
const _hoisted_11$2 = ["id"];
const _hoisted_12$2 = {
  key: 1,
  class: "d-flex"
};


const _sfc_main$3 = {
  __name: 'NoiseChart',
  props: {
  noiseData: Object,
  amountSelectedVendors: Number,
  vendorName: String,
  includeLegend: Boolean
},
  setup(__props) {

const props = __props;


// Have to convert noise data to an array of strings for d3
const d3NoiseData = computed(() => {
  if (!props.noiseData) return [];
  const falsePositiveArr = Array.from({ length: props.noiseData['falsePositive'] }, () => 'falsePositive');
  const trueNegativeArr = Array.from({ length: props.noiseData['trueNegative'] }, () => 'trueNegative');
  const naArr = Array.from({ length: props.noiseData['N/A'] }, () => 'n/a');
  return [...falsePositiveArr, ...trueNegativeArr, ...naArr];
});

watch(() => d3NoiseData.value, (newValue) => {
  if (!newValue) return;
  loadNoiseChart(d3NoiseData.value);
}, { immediate: true });

onMounted(() => {
  loadNoiseChart(d3NoiseData.value);
});

function loadNoiseChart(d3NoiseData) {
  const chartId = `#noiseChart_${props.vendorName}`;
  const padding = 24;
  let width = 0;
  if (document.getElementById("preview-container")) {
    width = document.getElementById("preview-container").clientWidth - 100;
  } else if (document.getElementById("overviewCol")){
    width =
      document.getElementById("overviewCol").clientWidth /
        props.amountSelectedVendors -
        padding;
  }
  if (width <= 0) return;
  select(chartId).selectAll("*").remove();
  const height = 45;
  const gap = 2.1;
  const strokeWidth = 1;
  const barWidth = (width - gap * (d3NoiseData.length - 1)) / d3NoiseData.length;
  const svg = select(chartId)
  .attr("width", width + (strokeWidth * 2))
  .attr("height", height);

  svg.selectAll(".bar")
    .data(d3NoiseData)
    .enter()
    .append("g")
    .style("fill", (d) => d === 'falsePositive' ? getNoiseResultCategoryColor("Reported") : d === 'trueNegative' ? getNoiseResultCategoryColor("Not Reported") : getNoiseResultCategoryColor("N/A"))
    .style("stroke", getNoiseResultCategoryColor("Reported"))
    .style("stroke-width", strokeWidth)
    .append("rect")
    .attr("x", (d, i) => (i == 0 ? 0 : i * (barWidth + gap))) // Adjust x to include the gap
    .attr("y", 10)
    .attr("width", barWidth) // Use calculated barWidth
    .attr("height", 30);
}


return (_ctx, _cache) => {
  const _component_v_icon = resolveComponent("v-icon");

  return (openBlock(), createElementBlock("div", {
    class: "position-relative",
    id: `noise_chart_container_${__props.vendorName}`
  }, [
    createElementVNode("div", _hoisted_2$2, [
      _hoisted_3$2,
      createElementVNode("p", null, toDisplayString(d3NoiseData.value.length) + " total noise steps", 1 /* TEXT */)
    ]),
    (__props.includeLegend)
      ? (openBlock(), createElementBlock("div", _hoisted_4$2, [
          createElementVNode("div", _hoisted_5$2, [
            createVNode(_component_v_icon, {
              color: unref(getNoiseResultCategoryColor)('Reported'),
              class: "detection-specificity-box",
              size: "small"
            }, {
              default: withCtx(() => [
                createTextVNode(" mdi-square-rounded ")
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["color"]),
            _hoisted_6$2
          ]),
          createElementVNode("div", _hoisted_7$2, [
            createVNode(_component_v_icon, {
              color: unref(getNoiseResultCategoryColor)('Reported'),
              class: "detection-specificity-box",
              size: "small"
            }, {
              default: withCtx(() => [
                createTextVNode(" mdi-square-rounded-outline ")
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["color"]),
            _hoisted_8$2
          ]),
          createElementVNode("div", _hoisted_9$2, [
            createVNode(_component_v_icon, {
              color: unref(getNoiseResultCategoryColor)('N/A'),
              class: "detection-specificity-box",
              size: "small"
            }, {
              default: withCtx(() => [
                createTextVNode(" mdi-square-rounded ")
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["color"]),
            _hoisted_10$2
          ])
        ]))
      : createCommentVNode("v-if", true),
    (openBlock(), createElementBlock("svg", {
      id: `noiseChart_${__props.vendorName}`
    }, null, 8 /* PROPS */, _hoisted_11$2)),
    (__props.noiseData)
      ? (openBlock(), createElementBlock("div", _hoisted_12$2, [
          createElementVNode("p", null, toDisplayString(__props.noiseData['falsePositive']) + " reported false positives ", 1 /* TEXT */)
        ]))
      : createCommentVNode("v-if", true)
  ], 8 /* PROPS */, _hoisted_1$2))
}
}

};
var NoiseChart = /*#__PURE__*/_export_sfc(_sfc_main$3, [['__file',"/home/runner/work/evals-website/evals-website/packages/enterprise-results/src/NoiseChart.vue"]]);

const _sfc_main$2 = {
  name: "ScenarioSummary",
  components: {
    NoiseChart
  },
  props: {
    index: Number,
    tactics: Object,
    stepsRendered: Boolean,
    filtersUnchecked: Object,
    actionableMetricPresent: Boolean,
    chartHeight: Number,
    vendor: Object,
    vendorMTTDDict: Object,
    averageScenarioMTTD: Number,
    scenarioMetricPreview: Boolean,
    preview: Boolean,
    getTotalSubsteps: Function,
    getActionableTotalFromVendor: Function,
    getTotalPossibleActionableForVendor: Function,
    scenarioName: String,
    amountSelectedVendors: Number,
    selectedScenario: Object,
    noiseMetricPresent: Boolean,
    noiseData: Object,
    selectedEvaluation: Object
  },
  computed: {
  alertLegendLabels() {
    if (this.selectedEvaluation && this.selectedEvaluation.domain === 'ENTERPRISE') {
      return ["Initial Run", "Configuration Change"];
    }
    return ["Console", "Email"];
  },
  alertLegendColors() {
    if (this.selectedEvaluation && this.selectedEvaluation.domain === 'ENTERPRISE') {
      return ["#25333C", "#9EA4A8"];
    }
    return ["#25333C", "#9EA4A8"];
  },
  showAlerts() {
    return (this.selectedEvaluation.start_year >= 2024 && this.selectedEvaluation.domain === 'ENTERPRISE') || (this.selectedEvaluation.start_year >= 2023 && this.selectedEvaluation.domain === 'MANAGED_SERVICES')
  }
}
};

const _hoisted_1$1 = {
  key: 0,
  class: "d-flex justify-space-between text-left m-spacing--bottom-3"
};
const _hoisted_2$1 = { key: 0 };
const _hoisted_3$1 = /*#__PURE__*/createElementVNode("span", { class: "mk-text--grey60" }, "Results", -1 /* HOISTED */);
const _hoisted_4$1 = ["id"];
const _hoisted_5$1 = ["id"];
const _hoisted_6$1 = {
  key: 3,
  class: "d-flex justify-space-between"
};
const _hoisted_7$1 = { class: "text-left" };
const _hoisted_8$1 = /*#__PURE__*/createElementVNode("span", { class: "mk-text--grey60" }, "Actionable Detections ", -1 /* HOISTED */);
const _hoisted_9$1 = /*#__PURE__*/createElementVNode("span", null, [
  /*#__PURE__*/createTextVNode("Actionable detections include some or all of the following details: activity, time, location, users, and context. "),
  /*#__PURE__*/createElementVNode("a", {
    href: "/managed-services/menupass-blackcat/",
    target: "_blank"
  }, "Learn More")
], -1 /* HOISTED */);
const _hoisted_10$1 = { key: 0 };
const _hoisted_11$1 = { class: "mk-text--body" };
const _hoisted_12$1 = /*#__PURE__*/createElementVNode("span", { class: "mk-text--grey60 m-spacing--left-2" }, "MTTD ", -1 /* HOISTED */);
const _hoisted_13$1 = /*#__PURE__*/createElementVNode("br", null, null, -1 /* HOISTED */);
const _hoisted_14$1 = /*#__PURE__*/createElementVNode("br", null, null, -1 /* HOISTED */);
const _hoisted_15$1 = { key: 0 };
const _hoisted_16$1 = { class: "m-spacing--top-5" };
const _hoisted_17$1 = /*#__PURE__*/createElementVNode("span", { class: "mk-text--h3" }, "Alerts", -1 /* HOISTED */);
const _hoisted_18$1 = [
  _hoisted_17$1
];
const _hoisted_19$1 = {
  key: 0,
  class: "text-left m-spacing--top-5 alert-chart-container px-3 py-3"
};
const _hoisted_20$1 = { class: "mk-text--h5" };
const _hoisted_21$1 = { class: "mk-text--grey60" };
const _hoisted_22$1 = { class: "mk-text--grey60" };
const _hoisted_23$1 = ["id"];
const _hoisted_24$1 = {
  key: 4,
  class: "m-spacing--top-5"
};
const _hoisted_25$1 = /*#__PURE__*/createElementVNode("span", { class: "mk-text--h3" }, "Noise", -1 /* HOISTED */);
const _hoisted_26$1 = [
  _hoisted_25$1
];
const _hoisted_27$1 = /*#__PURE__*/createStaticVNode("<p>Benign activity (outside the emulation plan) was executed during the evaluation while malicious/suspicious activity was executed by the Red Team.</p><p>Noise steps received the following results:</p><p class=\"m-spacing--left-5\"><strong>Reported:</strong> When a participant incorrectly alerts on or blocks benign activity as malicious or suspicious (via a detection or automated protection), resulting in a false positive report </p><p class=\"m-spacing--left-5\"><strong>Not Reported:</strong> When a participant correctly determines benign activity as non-malicious activity, resulting in a true negative prediction</p><p class=\"m-spacing--left-5\"><strong>Not Applicable:</strong> Evaluation for the noise step was not completed. Reasons may include, but are not limited to, technical issues during execution prevented successful completion, or the platform not supported by the participant</p><p>Alerts must have met the General detection criteria, at a minimum, to be considered for this metric. </p><p>*No training data or learning period was provided. </p>", 7);
const _hoisted_34$1 = [
  _hoisted_27$1
];

function _sfc_render$1(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_col = resolveComponent("v-col");
  const _component_v_row = resolveComponent("v-row");
  const _component_v_icon = resolveComponent("v-icon");
  const _component_v_tooltip = resolveComponent("v-tooltip");
  const _component_NoiseChart = resolveComponent("NoiseChart");

  return (openBlock(), createElementBlock("div", null, [
    createVNode(_component_v_row, null, {
      default: withCtx(() => [
        createVNode(_component_v_col, null, {
          default: withCtx(() => [
            createElementVNode("div", {
              class: normalizeClass({'text-left mk-text--h1 my-7': true, 'invisible': $props.index != 0})
            }, toDisplayString($props.scenarioName) + " Summary", 3 /* TEXT, CLASS */)
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }),
    (
      $props.scenarioMetricPreview || ($props.stepsRendered &&
        $props.filtersUnchecked.tacticsUnchecked.length < Object.keys($props.tactics).length &&
        $props.selectedScenario.scenario_type === 'DETECTION'))
      ? (openBlock(), createElementBlock("div", _hoisted_1$1, [
          createElementVNode("span", null, toDisplayString($props.selectedScenario.name), 1 /* TEXT */),
          (!$props.scenarioMetricPreview)
            ? (openBlock(), createElementBlock("span", _hoisted_2$1, [
                createTextVNode(toDisplayString($props.getTotalSubsteps()) + " ", 1 /* TEXT */),
                _hoisted_3$1
              ]))
            : createCommentVNode("v-if", true)
        ]))
      : createCommentVNode("v-if", true),
    ($props.selectedScenario.scenario_type === 'DETECTION')
      ? (openBlock(), createElementBlock("div", {
          key: 1,
          class: "text-left",
          style: normalizeStyle(this.actionableMetricPresent && `height: ${$props.chartHeight}px;`),
          id: `scenarioDetectionChart_${$props.vendor.name}`,
          ref: 'scenarioDetectionChart' + $props.vendor.name
        }, null, 12 /* STYLE, PROPS */, _hoisted_4$1))
      : createCommentVNode("v-if", true),
    ($props.selectedScenario.scenario_type === 'DETECTION' && $props.actionableMetricPresent)
      ? (openBlock(), createElementBlock("div", {
          key: 2,
          class: "text-left",
          id: `scenarioActionableDetectionChart_${$props.vendor.name}`,
          ref: 'scenarioActionableDetectionChart' + $props.vendor.name
        }, null, 8 /* PROPS */, _hoisted_5$1))
      : createCommentVNode("v-if", true),
    ($props.actionableMetricPresent)
      ? (openBlock(), createElementBlock("div", _hoisted_6$1, [
          createElementVNode("div", null, [
            createElementVNode("span", _hoisted_7$1, [
              createTextVNode(toDisplayString($props.getActionableTotalFromVendor($props.vendor.name)) + " ", 1 /* TEXT */),
              _hoisted_8$1
            ]),
            (!$props.scenarioMetricPreview)
              ? (openBlock(), createBlock(_component_v_tooltip, {
                  key: 0,
                  "content-class": "mk-tooltip--allow-pointer-events",
                  location: "top"
                }, {
                  activator: withCtx(({ props }) => [
                    createVNode(_component_v_icon, mergeProps({ color: "grey" }, props, { size: "15px" }), {
                      default: withCtx(() => [
                        createTextVNode(" mdi-information-outline ")
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */)
                  ]),
                  default: withCtx(() => [
                    _hoisted_9$1
                  ]),
                  _: 1 /* STABLE */
                }))
              : createCommentVNode("v-if", true)
          ]),
          ($props.vendorMTTDDict[$props.vendor.name])
            ? (openBlock(), createElementBlock("div", _hoisted_10$1, [
                createElementVNode("span", _hoisted_11$1, [
                  createTextVNode(toDisplayString(Math.round($props.vendorMTTDDict[$props.vendor.name])) + " min ", 1 /* TEXT */),
                  _hoisted_12$1
                ]),
                createVNode(_component_v_tooltip, {
                  "content-class": "mk-tooltip--allow-pointer-events-arrow-right",
                  location: "top"
                }, {
                  activator: withCtx(({ props }) => [
                    createVNode(_component_v_icon, mergeProps({ color: "grey" }, props, { size: "16px" }), {
                      default: withCtx(() => [
                        createTextVNode(" mdi-help-circle-outline ")
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */)
                  ]),
                  default: withCtx(() => [
                    createElementVNode("span", null, [
                      createTextVNode("Mean Time to Detect (MTTD) is the average time between when an attack is run and when the managed service provider triggers an alert on this attack. The timestamp on the first email relevant to the step in question was used."),
                      _hoisted_13$1,
                      createTextVNode(),
                      _hoisted_14$1,
                      (!$props.scenarioMetricPreview && !$props.preview)
                        ? (openBlock(), createElementBlock("span", _hoisted_15$1, "Scenario avg for all participants: " + toDisplayString($props.averageScenarioMTTD) + " min", 1 /* TEXT */))
                        : createCommentVNode("v-if", true)
                    ])
                  ]),
                  _: 1 /* STABLE */
                })
              ]))
            : createCommentVNode("v-if", true)
        ]))
      : createCommentVNode("v-if", true),
    createElementVNode("div", _hoisted_16$1, [
      createElementVNode("div", {
        class: normalizeClass({'text-left': true, 'invisible': $props.index != 0})
      }, [..._hoisted_18$1], 2 /* CLASS */),
      createElementVNode("div", {
        class: normalizeClass({'text-left': true, 'invisible': $props.index != 0})
      }, [
        createElementVNode("span", null, "Alerts are sent from the participant to MITRE during the emulation. They are delivered by console" + toDisplayString(this.selectedEvaluation.domain !== "ENTERPRISE" ? " or email" : "") + "; and classified as critical, high, medium, low, or other.", 1 /* TEXT */)
      ], 2 /* CLASS */),
      ($options.showAlerts)
        ? (openBlock(), createElementBlock("div", _hoisted_19$1, [
            createElementVNode("div", {
              class: normalizeClass({'d-flex justify-space-between': _ctx.$vuetify.display.lgAndUp || $props.amountSelectedVendors < 3})
            }, [
              createElementVNode("span", _hoisted_20$1, toDisplayString($props.vendor.display_name) + " Alerts", 1 /* TEXT */),
              createElementVNode("div", null, [
                createVNode(_component_v_icon, {
                  color: $options.alertLegendColors[0],
                  class: "detection-specificity-box",
                  size: "small"
                }, {
                  default: withCtx(() => [
                    createTextVNode(" mdi-square-rounded ")
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["color"]),
                createElementVNode("span", _hoisted_21$1, toDisplayString($options.alertLegendLabels[0]), 1 /* TEXT */),
                createVNode(_component_v_icon, {
                  color: $options.alertLegendColors[1],
                  class: "detection-specificity-box m-spacing--left-5",
                  size: "small"
                }, {
                  default: withCtx(() => [
                    createTextVNode(" mdi-square-rounded ")
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["color"]),
                createElementVNode("span", _hoisted_22$1, toDisplayString($options.alertLegendLabels[1]), 1 /* TEXT */)
              ])
            ], 2 /* CLASS */),
            createElementVNode("div", {
              id: `alertChart_${$props.vendor.name}`,
              ref: `alertChart_${$props.vendor.name}`
            }, null, 8 /* PROPS */, _hoisted_23$1)
          ]))
        : createCommentVNode("v-if", true)
    ]),
    ($props.noiseMetricPresent)
      ? (openBlock(), createElementBlock("div", _hoisted_24$1, [
          createElementVNode("div", {
            class: normalizeClass({'text-left': true, 'invisible': $props.index != 0})
          }, [..._hoisted_26$1], 2 /* CLASS */),
          createElementVNode("div", {
            class: normalizeClass({'text-left': true, 'invisible': $props.index != 0})
          }, [..._hoisted_34$1], 2 /* CLASS */),
          createVNode(_component_NoiseChart, {
            noiseData: $props.noiseData,
            amountSelectedVendors: $props.amountSelectedVendors,
            vendorName: $props.vendor.name,
            includeLegend: $props.index === $props.amountSelectedVendors - 1
          }, null, 8 /* PROPS */, ["noiseData", "amountSelectedVendors", "vendorName", "includeLegend"])
        ]))
      : createCommentVNode("v-if", true)
  ]))
}
var ScenarioSummary = /*#__PURE__*/_export_sfc(_sfc_main$2, [['render',_sfc_render$1],['__file',"/home/runner/work/evals-website/evals-website/packages/enterprise-results/src/ScenarioSummary.vue"]]);

const _sfc_main$1 = {
  name: "IndividualParticipantResults",
  props: {
    allModifierTypes: Array,
    allResultCategories: Array,
    preview: Boolean,
    startingEvaluation: Object,
    startingScenario: Object,
    startingVendors: Object,
    domain: String,
    evaluations: Array,
    vendorLogoUrl: String,
    screenshotUrl: String,
    vendorSummaryScreenshotUrl: String,
    setup: Boolean,
    arcadeStepsData: Object,
  },
  components: {
    EvaluationDetails,
    VueMultiselect,
    ChartLegend,
    Filters,
    VendorLogoAndHoverButtons,
    LinuxChip,
    ScenarioSummary
  },
  computed: {
    operationalFlowForSelectedScenario() {
      if(this.selectedScenario && this.selectedEvaluation) {
        return this.selectedEvaluation.operational_flow.filter(substep => substep.scenario_type === this.selectedScenario.scenario_type);
      }
      return undefined;
    },
    filteredSteps() {
      return this.comparisonData.filter((step) => {
        return step.checked === true && (!this.isSetupStep(step) || this.showSetup);
      });
    },
    filteredSubsteps() {
      return this.filteredSteps.reduce((acc, step) => {
        return acc.concat(step.Substeps.filter((substep) => substep.checked === true && substep.Include));
      }, []);
    },
    chartWidth() {
      const overviewCol = document.getElementById("overviewCol");
      if(overviewCol){
        return (
          document.getElementById("overviewCol")?.clientWidth /
          this.selectedVendors.length
        );
      }
      return undefined;
    },
    stepsRendered() {
      return this.filteredSteps.length > 0;
    },
    maxSubstepsInTest() {
      let maxSubstepsInTest = 0;
      this.evaluationSteps.forEach((step) => {
        let substepLength = step.Substeps.length;
        if (substepLength > maxSubstepsInTest)
          maxSubstepsInTest = substepLength;
      });
      return maxSubstepsInTest;
    },
    substepTotalPerStep() {
      let substepTotalPerStep = {};
      this.filteredSubsteps.forEach((substep) => {
        if (substep.Is_Setup || substep.Capability_Requirements.includes("False Positive")) return;
        if (substepTotalPerStep[substep.Step]) {
          substepTotalPerStep[substep.Step]++;
        } else {
          substepTotalPerStep[substep.Step] = 1;
        }
      });
      return substepTotalPerStep;
    },
    substepTotalPerTactic() {
      let substepTotalPerTactic = {};
      Object.keys(this.tactics).forEach((tactic) => {
        let substepTotal = 0;
        this.comparisonData.forEach((step) => {
          substepTotal += step.Substeps.filter(
            (substep) => substep.Tactic.Tactic_Id === tactic && !substep.Is_Setup && substep.Include && !substep.Capability_Requirements.includes("False Positive")
          ).length;
        });
        substepTotalPerTactic[tactic] = substepTotal;
      });
      return substepTotalPerTactic;
    },
    actionableMetricPresent() {
      return parseInt(this.selectedEvaluation.start_year) >= 2023 && this.selectedEvaluation.domain === 'MANAGED_SERVICES';
    },
    noiseMetricPresent() {
      // Noise metric is present for all evaluations starting in 2024 for enterprise evaluations and 2025 for all other evaluations
      return (parseInt(this.selectedEvaluation.start_year) >= 2024 && this.selectedEvaluation.domain === 'ENTERPRISE') || parseInt(this.selectedEvaluation.start_year) >= 2025;
    },
    chartHeight() {
      return this.actionableMetricPresent ? 32 : 40;
    },
    vendorNameToNoiseData() {
      // Data structure is the following:
      //   {
      //     'vendorName': {
      //       'falsePositive': numOfFalsePositives: Number,
      //       'trueNegative': numOfTrueNegatives: Number,
      //       'N/A': numOfN/A: Number,
      //     }
      //   }
      const vendorNameToNoiseData = {};
      this.comparisonData.filter((step) => step.checked).forEach((step) => {
        step.Substeps.filter((s) => s.Capability_Requirements.includes('False Positive') && s.checked && s.Include).forEach((substep) => {
          substep.Vendor_Data.forEach((vendor) => {
            const mostSpecificResult = vendor.Results.find((result) => result.Most_Specific) ?? vendor.Results[0];
            if (!mostSpecificResult) return;
            const typeOfDetection = this.selectedScenario.scenario_type === 'PROTECTION' ? mostSpecificResult.Protection_Type : mostSpecificResult.Detection_Type;
            const noiseCategory = typeOfDetection === 'Not reported'
              ? 'trueNegative'
              : typeOfDetection === 'Not applicable'
                ? 'N/A'
                : 'falsePositive';
            if (!vendorNameToNoiseData[vendor.Vendor_Name]) {
              vendorNameToNoiseData[vendor.Vendor_Name] = {
                'trueNegative': 0,
                'falsePositive': 0,
                'N/A': 0
              };
            }
            vendorNameToNoiseData[vendor.Vendor_Name][noiseCategory] += 1;
          });
        });
      });
      return vendorNameToNoiseData;
    },
  },
  data: () => ({
    isEvaluationDetailsVisible: false,
    toggle: 'individualParticipant',
    modifiers: [],
    selectedEvaluation: undefined,
    scenarioOptions: [],
    selectedScenario: undefined,
    vendorOptions: [],
    selectedVendors: [],
    evaluationSelectMenuOpen: false,
    scenarioSelectMenuOpen: false,
    expandOverviewCard: false,
    evaluationSteps: [],
    route: useRoute(),
    router: useRouter(),
    selected: null,
    scenarioDetectionsData: {},
    evalResultCategories: [],
    evalResultCategoriesNames: [],
    chartsData: {},
    chartColors: [
      "#403386",
      "#89007D",
      "#D62150",
      "#FB7139",
      "#F7AC43",
      "#CED1D3",
    ],
    apt29ChartColors: [
      "#403386",
      "#89007D",
      "#D62150",
      "#E94F37",
      "#FB7139",
      "#F7AC43",
      "#CED1D3",
    ],
    apt3ChartColors: [
      "#403386",
      "#89007D",
      "#D62150",
      "#E94F37",
      "#FB7139",
      "#F7AC43",
    ],
    managedServicesChartColors: ["#403386", "#F7AC43", "#CED1D3"],
    protectionChartColors: ["#403386", "#F7AC43", "#CED1D3"],
    protectionChartColorMap: {
      Protected: "#403386",
      None: "#F7AC43",
      "Not blocked": "#F7AC43",
      "Not applicable": "#CED1D3",
      Reported: "#25333C",
      "Not reported": "#FFFFFF",
    },
    chartColorsWithoutTelemetryAndWithNoise: [
      "#403386",
      "#89007D",
      "#D62150",
      "#F7AC43",
      "#CED1D3",
    ],
    adversaryChartColors: [],
    vendorsHoverDict: {},
    searchText: "",
    modifiersUnchecked: [],
    filteredTactics: [],
    filteredTechniques: [],
    filteredSubtechniques: [],
    comparisonData: [],
    filtersTab: "steps",
    tactics: {},
    filtersUnchecked: {
      tacticsUnchecked: [],
      techniquesUnchecked: [],
      subtechniquesUnchecked: [],
      modifiersUnchecked: [],
    },
    tacticsNotShown: [],
    showOverlay: false,
    breachScreenshots: {},
    chartLegendScrollToTopOverlap: false,
    summaryChartMarginTop: 0,
    currentYear: new Date().getFullYear(),
    selectedVendorsLimit: 3,
    chartsOrDetailsVisible: false,
    mobileDetectionKeyExpanded: false,
    archiveUrls: {},
    vendorEnrichedDict: {},
    vendorEnrichedCriteriaDict: {},
    vendorMTTDDict: {},
    vendorAlertCountDict: {},
    alertChartScale: 500,
    averageScenarioMTTD: 0,
    showSetup: false
  }),
  watch: {
    filteredSteps(newValue, oldValue) {
      // watch filteredSteps to ensure that charts are re-rendered for steps that were re-checked
      let newSteps = [];

      newSteps = newValue.filter((step) => {
        return !oldValue.find((oldStep) => oldStep.Step_Num === step.Step_Num);
      });

      if (newSteps.length === 1) {
        this.selectedVendors.forEach((vendor) => {
          this.generateScenarioDetectionChart(vendor.name);
          this.generateScenarioActionableDetectionChart(vendor.name);
          this.$nextTick(() => {
            this.generateStepDetectionChart(newSteps, vendor.name);
            this.generateStepActionableDetectionChart(newSteps, vendor.name);
          });
        });
      } else if (newValue.length === oldValue.length - 1) {
        this.selectedVendors.forEach((vendor) => {
          this.generateScenarioDetectionChart(vendor.name);
          this.generateScenarioActionableDetectionChart(vendor.name);
        });
      }
    },
    "selectedVendors.length"(newValue, oldValue) {
      if (this.selectedEvaluation && this.selectedScenario) {
        let vendors = this.selectedVendors.map((vendor) => vendor.name);
        this.router.replace({
          query: {
            vendor: vendors,
            evaluation: this.selectedEvaluation.name,
            scenario: this.selectedScenario.number,
            view: "individualParticipant"
          },
        });
        this.calculateAlertChartScale();
      } else if (this.selectedEvaluation) {
        this.router.replace({
          query: {
            evaluation: this.selectedEvaluation.name,
            view: "individualParticipant"
          },
        });
      }
      if (oldValue > 0 && newValue === 0) {
        this.clearTacticAndModifierFilters();
        this.clearStepFilters();
        this.filtersTab = "steps";
      }
      this.calculateSpacingAboveSummaryCharts();
    },
    filtersTab(newValue, oldValue) {
      if (oldValue === "tactics" && newValue === "steps") {
        this.clearTacticAndModifierFilters();
        this.selectedVendors.forEach((vendor) => {
          this.generateStepDetectionChart(this.filteredSteps, vendor.name);
          this.$nextTick(() => {
            this.generateStepActionableDetectionChart(this.filteredSteps, vendor.name);
          });
        });
      } else if (oldValue === "steps" && newValue === "tactics") {
        this.clearStepFilters();
        this.selectedVendors.forEach((vendor) => {
          this.generateTacticDetectionChart(vendor.name);
          this.$nextTick(() => {
            this.generateTacticActionableDetectionChart(vendor.name);
          });
        });
      }
    },
    selectedEvaluation(newValue, oldValue) {
      if (newValue && (oldValue || !this.route.query.scenario)) {
        if (!this.route.query.scenario && this.scenarioOptions.length > 1) {
          this.router.replace({ query: { evaluation: newValue.name, view: "individualParticipant" } });
          this.selectedScenario = undefined;
        }
        else if(this.scenarioOptions.length === 1) {
          this.selectedScenario = this.scenarioOptions[0];
        }
        else {
          this.selectedScenario = this.scenarioOptions.find(s => s.number.toString() === this.route.query.scenario);
        }
        this.selectedVendors = [];
      } else {
        this.router.replace({ query: {view: "individualParticipant"} });
      }
      this.$nextTick(() => {
        if(newValue && (!this.selectedScenario || !Object.keys(this.selectedScenario).length)){
          this.$refs.scenarioSelect.activate();
        }
      });
    },
    selectedScenario(newValue, oldValue) {
      if(newValue && (oldValue || !this.route.query.vendor)) {
        this.selectedVendors = [];
        this.vendorOptions.forEach(vendor => vendor.checked = false);
        this.router.replace({
          query: {
            evaluation: this.selectedEvaluation.name,
            scenario: newValue.number,
            view: "individualParticipant"
          },
        });
      }
      else if(!newValue) {
        this.selectedVendors = [];
        this.vendorOptions.forEach(vendor => vendor.checked = false);
        this.router.replace({
          query: { evaluation: this.selectedEvaluation.name, view: "individualParticipant" },
        });
      }
      this.$nextTick(() => {
        if(newValue && !this.selectedVendors.length){
          this.$refs.vendorMultiselect.activate();
        }
      });
    },
    startingEvaluation(){
      this.selectedEvaluation = this.startingEvaluation;
      this.selectEvaluation();
    }
  },
  methods: {
    isSetupStep(step) {
      return step.Substeps.every(substep => substep.Is_Setup);
    },
    isOnlySetupSubstepsIncluded(step) {
      if (this.isSetupStep(step)) return false;
      return step.Substeps.every(substep => substep.Is_Setup || !substep.Include);
    },
    getContentClass(step) {
      let testChart = document.getElementById(`testChart_${step.Step_Num}`);
      return testChart?.getBoundingClientRect().bottom > window.innerHeight - 50
        ? "mk-tooltip--top"
        : "mk-tooltip--bottom";
    },
    getLocation(step) {
      let testChart = document.getElementById(`testChart_${step.Step_Num}`);
      return testChart?.getBoundingClientRect().bottom > window.innerHeight - 50
        ? "top"
        : "bottom";
    },

    updateStepChecked(step){
      if (step.checked) {
        step.minusIcon = false;
        step.Substeps.forEach(substep => {
          substep.checked = true;
        });
      } else {
        step.Substeps.forEach(substep => {
          substep.checked = false;
        });
      }
    },

    updateSubstepChecked(substep, step){
      if (substep.checked) {
        step.checked = true;
        const allSubstepsChecked = step.Substeps.every(substep => substep.checked);
        if (allSubstepsChecked) {
          step.minusIcon = false;
        } else {
          step.minusIcon = true;
        }
      } else {
        let noSubstepsChecked = false;
        if (!this.showSetup) {
          noSubstepsChecked = step.Substeps.every(substep => !substep.checked || substep.Is_Setup);
        } else {
          noSubstepsChecked = step.Substeps.every(substep => !substep.checked);
        }
        if (noSubstepsChecked) {
          step.checked = false;
        } else {
          step.minusIcon = true;
        }
      }
      // Rerender charts with new substeps
      if (!substep.Is_Setup) {
        this.selectedVendors.forEach((vendor) => {
          this.generateScenarioDetectionChart(vendor.name);
          this.generateScenarioActionableDetectionChart(vendor.name);
          this.$nextTick(() => {
            this.generateStepDetectionChart(this.filteredSteps, vendor.name);
            this.generateStepActionableDetectionChart(this.filteredSteps, vendor.name);
          });
        });
      }
    },

    updateFiltersTab(value) {
      this.filtersTab = value;
    },

    updateTactics(value) {
      this.tactics = value;
    },

    updateFiltersUnchecked(value) {
      this.filtersUnchecked = value;
    },

    updateLegendExpanded() {
      this.$nextTick(() => {
        this.checkIfLegendOverlap();
      });
    },

    updateMobileDetectionKeyExpanded(value) {
      this.mobileDetectionKeyExpanded = value;
    },

    updateVendorDisclaimerExpanded(value) {
      if (value) {
        this.calculateSpacingAboveSummaryCharts();
      } else {
        this.summaryChartMarginTop = 0;
      }
    },

    checkIfLegendOverlap() {
      let chartLegend = document
        .getElementById("chart-legend")
        ?.getBoundingClientRect();
      let scrollToTopBtn = document
        .getElementById("scroll-to-top-btn")
        ?.getBoundingClientRect();
      if (
        chartLegend &&
        scrollToTopBtn &&
        chartLegend.left < scrollToTopBtn.right
      ) {
        this.chartLegendScrollToTopOverlap = true;
      } else {
        this.chartLegendScrollToTopOverlap = false;
      }
    },

    getTooltipText(step) {
      let linuxSubsteps = step.Substeps.filter((substep) =>
        substep.Capability_Requirements.includes("Linux Capability")
      );
      let linuxSubstepsAmountText =
        linuxSubsteps.length === step.Substeps.length
          ? "All"
          : `${linuxSubsteps.length}/${step.Substeps.length}`;
      return `${linuxSubstepsAmountText} substeps were executed in a Linux environment`;
    },

    checkIfStepProtected(step, vendorName, substep) {
      let substepIndex = step.Substeps.findIndex((s) => s.Substep === substep);
      let vendorStepData = step.Substeps.map((substep) => {
        return substep.Vendor_Data.find(
          (vendorData) => vendorData.Vendor_Name === vendorName
        );
      });
      return vendorStepData.filter(
        (substep, idx) => {
          const results = substep.Results;
          const protectionType = results.length ? results[0] : substep.Results;
          return protectionType === 'Protected' && idx < substepIndex
        }
      )?.length;
    },

    getProtectionType(vendor, substep) {
      if (
        substep.Vendor_Data.find(
          (substepVendor) => substepVendor.Vendor_Name === vendor.name
        ).Results.Protection_Type === "Not applicable"
      ) {
        let stepNum = substep.Step;
        let thisStep = this.comparisonData.find(
          (step) => step.Step_Num === stepNum
        );
        let stepIsProtected = this.checkIfStepProtected(
          thisStep,
          vendor.name,
          substep.Substep
        );
        if (stepIsProtected) {
          return `${
            substep.Vendor_Data.find(
              (substepVendor) => substepVendor.Vendor_Name === vendor.name
            ).Results.Protection_Type
          } (Protected)`;
        }
      }
      return substep.Vendor_Data.find(
        (substepVendor) => substepVendor.Vendor_Name === vendor.name
      ).Results.Protection_Type;
    },

    clearStepFilters() {
      this.evaluationSteps = this.evaluationSteps.map((step) => {
        step.checked = true;
        step.minusIcon = false;
        step.Substeps.forEach((substep) => {
          substep.checked = true;
        });
        return step;
      });
    },

    clearTacticAndModifierFilters() {
      Object.keys(this.filtersUnchecked).forEach((filter) => {
        this.filtersUnchecked[filter] = [];
      });
    },

    getProtectionChartColor(vendor, substep) {
      if (
        substep.Vendor_Data.find(
          (vendorData) => vendorData.Vendor_Name === vendor
        )
      ) {
        let results = substep.Vendor_Data.find(
          (vendorData) => vendorData.Vendor_Name === vendor
        )?.Results;
        const protectionType = results.length ? results[0].Protection_Type : results.Protection_Type;
        return this.protectionChartColorMap[protectionType];
      }
    },

    scrollToStep(stepNum) {
      let scrollToElement = document.getElementById(`${stepNum}_details`);
      scrollToElement.scrollIntoView({ behavior: "smooth"});
    },

    getYear(evaluation) {
      return evaluation.date_published
        ? evaluation.date_published.slice(0, 4)
        : this.currentYear;
    },

    selectEvaluation() {
      if(this.scenarioOptions.length > 1){
        this.selectedScenario = undefined;
      }
      this.selectedVendors = [];
      this.vendorOptions = [];
      this.scenarioOptions = this.selectedEvaluation?.scenarios.sort(
        (a, b) => a.number - b.number
      );
      if (this.scenarioOptions.length == 1) {
        this.selectedScenario = this.scenarioOptions[0];
      }
      if (this.setup) {
        if (this.scenarioOptions.length != 1) {
          this.selectedScenario = this.startingScenario;
        }
        if (
          this.startingScenario == undefined ||
          this.startingVendors === undefined
        ) {
          this.$emit("updateSetup", false);
        }
      }

      if (this.selectedScenario) {
        this.selectScenario();
      }
    },

    selectScenario() {
      this.selectedVendors = [];
      this.evaluationSteps = [];
      this.comparisonData = [];
      this.modifiers = [];

      this.vendorOptions = this.selectedEvaluation.participants?.filter(
        (participant) =>
          participant.active_flag === true
      );

      const isDPRKScenario = this.selectedScenario && this.selectedScenario.name === 'DPRK';
      if (this.selectedScenario?.scenario_type === "PROTECTION") {
        if (!this.preview) {
          this.vendorOptions = this.vendorOptions.filter(
            (participant) =>
              participant.participant_capabilities.includes("Protection Capability") ||
              participant.participant.name === 'checkpoint' && this.selectedEvaluation.name === 'er6'
          );
        }
      }

      if (isDPRKScenario) {
        this.vendorOptions = this.vendorOptions.filter(vendor => {
          return vendor.participant_capabilities.includes('macOS Capability');
        });
      }

      this.vendorOptions = this.vendorOptions.map((vendor) => {
        this.vendorsHoverDict[vendor.participant.name] = {
          hovered: false,
          steps: {},
        };
        vendor.participant.checked = false;
        return vendor.participant;
      });

      if (this.selectedScenario?.scenario_type === "PROTECTION") {
        this.adversaryChartColors = this.protectionChartColors;
      } else if (this.selectedEvaluation.name === "apt29") {
        this.adversaryChartColors = this.apt29ChartColors;
      } else if (this.selectedEvaluation.name === "apt3") {
        this.adversaryChartColors = this.apt3ChartColors;
      } else if (this.domain === "MANAGED_SERVICES") {
        this.adversaryChartColors = this.managedServicesChartColors;
      } else if(this.domain === "ENTERPRISE" && this.selectedEvaluation.start_year >= 2024) {
        this.adversaryChartColors = this.chartColorsWithoutTelemetryAndWithNoise;
      }else {
        this.adversaryChartColors = this.chartColors;
      }

      this.getEvalResultCategories();

      // if not in preview mode, only set vendor if this is setting the scenario for the first time - at setup
      if (this.startingVendors.length) {
        if ((this.setup && this.$route.query.vendor) || this.preview) {
          this.selectVendor(this.startingVendors);
        }
      } else {
        this.$emit("updateSetup", false);
      }
    },

    getEvalResultCategories() {
      let evalResultCategories = [];
      evalResultCategories = this.allResultCategories.filter(
        (resultCategory) =>
          resultCategory.result_type === this.selectedScenario.scenario_type &&
          resultCategory.adversary ===
            this.selectedEvaluation.operational_flow[0].adversary
      );
      if (this.selectedEvaluation.domain === "ENTERPRISE") {
        evalResultCategories = evalResultCategories.filter(
          (resultCategory) => resultCategory.name !== "Reported" && resultCategory.name !== "Not reported" && resultCategory.name !== "Not Reported"
        );
      }

      this.evalResultCategories = evalResultCategories.reverse();
      this.evalResultCategoriesNames = evalResultCategories.map(
        (resultCategory) => resultCategory.name
      );
      this.evalResultCategories = this.evalResultCategories.map(
        (resultCategory) => {
          if (resultCategory.name === "N/A") {
            resultCategory.name = "Not applicable";
          } else if (resultCategory.name === "Blocked") {
            resultCategory.name = "Protected";
          }
          return resultCategory;
        }
      );
      this.evalResultCategoriesNames = this.evalResultCategories.map(
        (resultCategory) => resultCategory.name
      );
    },

    removeVendor(removedItem) {
      removedItem.checked = false;
      this.selectedVendors = this.selectedVendors.filter(
        (vendor) => vendor.name !== removedItem.name
      );
      this.renderCharts();
    },

    selectVendorFromCheck(option) {
      // makes sure the dropdown stays open when clicking adversary not on checkbox
      this.$refs.vendorMultiselect.activate();
      if (
        this.selectedVendors.length < this.selectedVendorsLimit &&
        option.checked
      ) {
        this.selectVendor([option]);
      } else if (!option.checked) {
        this.removeVendor(option);
      }
    },

    configureData(response, vendorName) {
      // all vendors will have the same steps, tactics, and modifiers so only organize data once
      if (!this.evaluationSteps.length) {
        this.getEvaluationSteps(response);
      }
      this.getComparisonData(response, vendorName);
      this.renderCharts();
    },

    selectVendor(vendors) {
      this.showOverlay = true;
      vendors.filter((v) => {
        // Check if vendor has the capability required for the scenario
        // This should be replace with a more robust way of checking if
        // the scenario is compatible with the vendor in the future
        if (this.selectedScenario?.scenario_type === "PROTECTION" && v.name === 'checkpoint') {
          return true;
        } else if (this.selectedScenario?.scenario_type === "PROTECTION") {
          return this.selectedEvaluation?.participants.find(
            (participant) => participant.participant.name === v.name
          ).participant_capabilities.includes("Protection Capability");
        } else if (this.selectedScenario?.name === "DPRK") {
          return this.selectedEvaluation?.participants.find(
            (participant) => participant.participant.name === v.name
          ).participant_capabilities.includes("macOS Capability");
        }
        return true;
      }).forEach((vendor) => {
        vendor.checked = true;
        this.selectedVendors.push(vendor);
      });
      this.$emit("updateSetup", false);
      if (this.comparisonData.length) {
        vendors = vendors.filter(
          (vendor) =>
            !this.comparisonData[0].Substeps[0].Vendor_Data.find(
              (v) => v.Vendor_Name === vendor.name
            )
        );
      }
      if (vendors.length && !this.preview) {
        Promise.all(
          vendors.map((vendor) =>
            this.$api.get(
              `results/?participant=${vendor.name}&adversary=${this.selectedEvaluation.name}`
            )
          )
        ).then((responses) => {
          responses.forEach((response, idx) => {
            let vendorName = vendors[idx].name;
            this.configureData(response.data, vendorName);
            this.showOverlay = false;
          });
        });
      } else if (this.preview) {
        let steps = this.arcadeStepsData[`${this.selectedScenario.scenario_type.toLowerCase()}Steps`].filter(step => step.Scenario === this.selectedScenario.id);
        this.configureData(steps, vendors[0].name);
        this.showOverlay = false;
      } else {
        this.renderCharts();
        this.showOverlay = false;
      }
    },

    renderCharts() {
      this.$nextTick(() => {
        this.selectedVendors.forEach((vendor) => {
          this.generateScenarioDetectionChart(vendor.name);
          this.generateScenarioActionableDetectionChart(vendor.name);
          this.loadAlertCharts(vendor.name);
          if (this.filtersTab === "steps") {
            this.generateStepDetectionChart(this.filteredSteps, vendor.name);
            this.generateStepActionableDetectionChart(this.filteredSteps, vendor.name);
          } else {
            this.generateTacticDetectionChart(vendor.name);
            this.generateTacticActionableDetectionChart(vendor.name);
          }
        });
        this.calculateSpacingAboveSummaryCharts();
      });
    },

    calculateSpacingAboveSummaryCharts() {
      this.$nextTick(() => {
        if (
          document.getElementById("vendor-disclaimer") &&
          document.getElementById("vendor-name")
        ) {
          let vendorDisclaimerHeight = document
            .getElementById("vendor-disclaimer")
            .getBoundingClientRect().height;
          let vendorNameHeight = document
            .getElementById("vendor-name")
            .getBoundingClientRect().height;
          this.summaryChartMarginTop =
            vendorDisclaimerHeight - vendorNameHeight;
        } else {
          this.summaryChartMarginTop = 0;
        }
      });
    },

    calculateAlertChartScale() {
      let maxAlertCount = 0;
      let alertCountPerSeverity = {};
      if (Object.keys(this.vendorAlertCountDict).length === 0){
        return;
      }
      for(const vendor in this.vendorAlertCountDict){
        if (!this.selectedVendors.some(s => s.name === vendor)){
          continue;
        }
        this.vendorAlertCountDict[vendor].forEach((alert) => {
          alertCountPerSeverity[alert.severity] = alertCountPerSeverity[alert.severity] ? alertCountPerSeverity[alert.severity] + alert.count : alert.count;
        });
        maxAlertCount = Math.max(...Object.values(alertCountPerSeverity), maxAlertCount);
        alertCountPerSeverity = {};
      }
      if (maxAlertCount <= 10) {
        this.alertChartScale = 10;
      } else if (maxAlertCount <= 100) {
        this.alertChartScale = 100;
      } else if (maxAlertCount <= 400) {
        this.alertChartScale = 500;
      } else if (maxAlertCount <= 700) {
        this.alertChartScale = 800;
      } else if (maxAlertCount <= 900) {
        this.alertChartScale = 1000;
      } else {
        this.alertChartScale = (maxAlertCount + (maxAlertCount * 0.1));
      }
    },

    getComparisonData(resultData, vendor) {
      if (!this.selectedScenario) return;
      let vendorStepsData = [];
      let stepNum = "";
      let scenarioValue = `Scenario_${this.selectedScenario.number}`;
      if (!this.preview) {
        if (this.selectedScenario.scenario_type === "DETECTION") {
          this.breachScreenshots[vendor] = resultData[0].adversaries[0].Eval_Range_Screenshots;
          this.vendorEnrichedDict[vendor] = resultData[0].adversaries[0].Detections_By_Step[scenarioValue].Enriched;
          this.vendorEnrichedCriteriaDict[vendor] = resultData[0].adversaries[0].Detections_By_Step[scenarioValue].Enriched_Criteria.sort((a, b) => a.Order_Num - b.Order_Num);
          this.vendorMTTDDict[vendor] = Math.round(resultData[0].adversaries[0].Detections_By_Step[scenarioValue].MTTD);
          this.averageScenarioMTTD = Math.round(resultData[0].adversaries[0].Detections_By_Step[scenarioValue].Avg_MTTD);
          this.vendorAlertCountDict[vendor] = resultData[0].adversaries[0].Detections_By_Step[scenarioValue].Alert_Counts;
          this.calculateAlertChartScale();
          vendorStepsData = resultData[0].adversaries[0].Detections_By_Step[scenarioValue].Steps;
          stepNum = "Step_Num";
          if (resultData[0].adversaries[0].Archive_File) {
            this.archiveUrls[vendor] = resultData[0].adversaries[0].Archive_File;
          }
        } else if (this.selectedScenario.scenario_type === "PROTECTION") {
          if(resultData[0].adversaries[0].Protections.Protection_Tests.length){
            vendorStepsData = resultData[0].adversaries[0].Protections.Protection_Tests;
            stepNum = "Test_Num";
          }
          else {
            this.vendorAlertCountDict[vendor] = resultData[0].adversaries[0].Detections_By_Step[scenarioValue].Alert_Counts;
            this.calculateAlertChartScale();
            vendorStepsData = resultData[0].adversaries[0].Detections_By_Step[scenarioValue].Steps;
            stepNum = "Step_Num";
          }
        }
      } else {
        this.vendorMTTDDict[vendor] = this.startingEvaluation.mttd_by_scenario[this.selectedScenario.id];
        this.vendorEnrichedDict[vendor] = this.startingEvaluation.enriched_by_scenario[this.selectedScenario.id];
        vendorStepsData = resultData;
        if(this.selectedScenario.scenario_type === "DETECTION") {
          this.vendorAlertCountDict[vendor] = this.startingEvaluation.alert_counts_by_scenario[this.selectedScenario.id];
          this.calculateAlertChartScale();
          this.breachScreenshots[vendor] = this.startingEvaluation.evaluation_screenshots;
          stepNum = "Step_Num";
        }
        else if (this.selectedScenario.scenario_type === "PROTECTION") {
          stepNum = "Test_Num";
        }
      }
      this.comparisonData = this.evaluationSteps.map((step) => {
        let vendorStepData = vendorStepsData.find(s => s.Step_Num === step.Step_Num);
        if(vendorStepData) {
          step.Step_Vendor_Data.push({
            Vendor_Name: vendor,
            Step_Start_Date: vendorStepData.Step_Start_Date,
            Step_Alert_Date: vendorStepData.Step_Alert_Date,
            Step_Screenshots: vendorStepData.Step_Screenshots
          });
        }
        step.Substeps = step.Substeps.filter(s => !s.is_setup);
        step.Substeps = step.Substeps.map((substep) => {
        if (substep.Vendor_Data.find((vendorData) => vendorData.name === vendor)) {
          return substep;
        }
        let results = vendorStepsData
          .find((dataStep) => dataStep[stepNum] === step.Step_Num)
          ?.Substeps.find(
            (dataSubstep) => dataSubstep.Substep === substep.Substep
          );

          if(results){
            let updatedResults = this.configureDetections(results.Detections || results.Protections || results, results.Noise_Category);
            substep.Vendor_Data.push({
              Vendor_Name: vendor,
              Vendor_Details: this.selectedVendors.find(
                (vendorObj) => vendorObj.name === vendor
              ),
              Results: updatedResults,
            });
          }
          substep.Include = true;
          substep.Step = step.Step_Num;
          return substep;
        });
        return step;
      });
    },

    configureDetections(results, noiseCategory) {
      if (this.selectedScenario.scenario_type === "DETECTION") {
        results = results.map((d) => {
          if (d.Detection_Type === "N/A") {
            d.Detection_Type = "Not applicable";
          }
          return d;
        });
        results = this.sortDetections(results, noiseCategory);
        results = results.map((result, idx) => {
          result.Specificity = idx;
          result.Most_Specific = idx === 0;
          result.Include = true;
          return result;
        });
      } else if (this.selectedScenario.scenario_type === "PROTECTION") {
        if(results.length) {
          results = results.map((d) => {
            d.Protection_Type = this.switchProtectionTypeNames(d.Protection_Type);
            return d;
          });
        }
        else if(Object.keys(results).length){
          results.Protection_Type = this.switchProtectionTypeNames(results.Protection_Type);
        }

      }
      return results;
    },

    switchProtectionTypeNames(protectionType) {
      switch (protectionType) {
        case "Blocked":
          return "Protected";
        case "N/A":
          return "Not applicable";
      }
      return protectionType;
    },

    sortDetections(detections, noiseCategory) {
      let evalResultCategories = this.evalResultCategoriesNames;
      // sort detections by most specific detection type/result category
      return detections.sort(function (a, b) {
        let specificity_of_a = evalResultCategories.indexOf(a.Detection_Type);
        let specificity_of_b = evalResultCategories.indexOf(b.Detection_Type);
        let modifier_amount_of_a = a.Modifiers.length;
        let modifier_amount_of_b = b.Modifiers.length;
        if(!noiseCategory){
          if (specificity_of_a < specificity_of_b) return -1;
          if (specificity_of_a > specificity_of_b) return 1;
        }
        // if substep has two detections of same detection type, the one without modifiers is more specific
        // however, for a noise substep, the one with modifiers is displayed
        if (modifier_amount_of_a < modifier_amount_of_b) return noiseCategory ? 1 : -1;
        else if (modifier_amount_of_a > modifier_amount_of_b) return noiseCategory ? -1 : 1;
        // if there are two detections, each with one modifier, and one modifier is delayed and the other is a configuration change,
        // delayed is more specific
        else if (modifier_amount_of_a === 1 && modifier_amount_of_b === 1) {
          if (
            getModifierTypeCategory(a.Modifiers[0]) === "Delayed" &&
            getModifierTypeCategory(b.Modifiers[0]) === "Configuration Change"
          ) {
            return -1;
          } else if (
            getModifierTypeCategory(b.Modifiers[0]) === "Delayed" &&
            getModifierTypeCategory(a.Modifiers[0]) === "Configuration Change"
          ) {
            return 1;
          }
        }
        return 0;
      });
    },

    filterComparisonData(vendor) {
      this.comparisonData = this.comparisonData.map((step) => {
        step.Substeps = step.Substeps.map((substep) => {
          let stepChecked =
            this.filteredSteps.find((s) => s.Step_Num === step.Step_Num) !==
            undefined;
          let tacticChecked = !this.filtersUnchecked.tacticsUnchecked.includes(
            substep.Tactic.Tactic_Id
          );
          let techniqueChecked =
            !this.filtersUnchecked.techniquesUnchecked.includes(
              substep.Technique.Technique_Id
            );
          let subtechniqueChecked =
            !this.filtersUnchecked.subtechniquesUnchecked.includes(
              substep.Subtechnique.Subtechnique_Id
            );
          let vendorData = substep.Vendor_Data.find(
            (vendorData) => vendorData.Vendor_Name === vendor
          );
          if (
            !stepChecked ||
            !tacticChecked ||
            !techniqueChecked ||
            !subtechniqueChecked ||
            !substep.checked
          ) {
            substep.Include = false;
          } else {
            substep.Include = true;
          }
          // set "Include" to true on the detection that is most specific but not filtered out
          if (this.selectedScenario.scenario_type === "DETECTION" && vendorData?.Results) {
            this.getMostSpecificDetectionShown(vendorData);
          }
          return substep;
        });
        return step;
      });
    },

    getMostSpecificDetectionShown(vendorData) {
      let detections = vendorData?.Results;
      let mostSpecificDetectionShown;
      detections.forEach((detection) => {
        let modifiers = detection.Modifiers.map((modifier) =>
          getModifierTypeCategory(modifier)
        );
        // check if the most specific detection has at least one modifier checked (if not modifiers, should always be true)
        let hasCheckedModifier =
          !modifiers.length ||
          modifiers.some(
            (modifier) =>
              !this.filtersUnchecked.modifiersUnchecked.includes(modifier)
          );
        if (hasCheckedModifier && !mostSpecificDetectionShown) {
          mostSpecificDetectionShown = detection;
          detection.Include = true;
          detection.Most_Specific = true;
        } else if (hasCheckedModifier) {
          detection.Include = true;
          detection.Most_Specific = false;
        } else {
          detection.Include = false;
          detection.Most_Specific = false;
        }
      });
    },

    generateScenarioDetectionChart(vendor) {
      this.filterComparisonData(vendor);
      let detectionCount = this.createDetectionCountDict();
      this.comparisonData.forEach((step) => {
        if (step.checked) {
          step.Substeps.forEach((substep) => {
            let vendorData = substep.Vendor_Data.find(
              (vendorData) => vendorData.Vendor_Name === vendor
            );
            if (substep.Include && !substep.Is_Setup && !substep.Capability_Requirements.includes("False Positive")) {
              let substepDetectionType = this.getSubstepDetectionType(vendorData);
              detectionCount = this.calculateDetectionCount(
                detectionCount,
                substepDetectionType
              );
            }
          });
        }
      });
      let targetId = `#scenarioDetectionChart_${vendor}`;
      const numAllDetections = Object.values(detectionCount).reduce(
        (a, b) => a + b,
        0
      );
      numAllDetections
        ? this.loadChart(detectionCount, targetId, numAllDetections)
        : select(targetId).select("svg").remove();
    },

    generateScenarioActionableDetectionChart(vendor) {
      if (!this.actionableMetricPresent) return;
      this.filterComparisonData(vendor);
      let targetId = `#scenarioActionableDetectionChart_${vendor}`;

      this.loadActionableChart(this.getActionableTotalFromVendor(vendor), targetId, this.getTotalPossibleActionableForVendor(vendor), this.getTotalSubsteps(vendor));
    },

    generateStepActionableDetectionChart(steps, vendor) {
      if (!this.actionableMetricPresent) return;
      this.filterComparisonData(vendor);
      steps.forEach((step) => {
        if (this.isSetupStep(step)) return;
        if (this.isOnlySetupSubstepsIncluded(step)) {
          this.loadActionableChart({}, `#stepActionableDetectionChart_${step.Step_Num}_${vendor}`, 0, 0, true);
          return;
        }
        let targetId = `#stepActionableDetectionChart_${step.Step_Num}_${vendor}`;
        if (steps.find((s) => s.Step_Num === step.Step_Num)) {
          this.loadActionableChart(this.getActionablePerStepFromVendor(vendor)[step.Step_Num], targetId, this.getTotalPossibleActionableForStep(step, vendor), this.substepTotalPerStep[step.Step_Num]);
        }
      });
    },

    generateStepDetectionChart(steps, vendor) {
      this.filterComparisonData(vendor);

      // load chart for each step
      // only count detections that do not include tactics, techniques, or subtechniques that are filtered
      this.comparisonData.forEach((step) => {
        if (this.isSetupStep(step)) return;
        if (this.isOnlySetupSubstepsIncluded(step)){
          this.loadChart({}, `#stepDetectionChart_${step.Step_Num}_${vendor}`, 0, true);
          return;
        }
        let stepDetections = [];
        if (steps.find((s) => s.Step_Num === step.Step_Num)) {
          let detectionCount = this.createDetectionCountDict();
          step.Substeps.forEach((substep) => {
            let vendorData = substep.Vendor_Data.find(
              (vendorData) => vendorData.Vendor_Name === vendor
            );
            let substepDetectionType = this.getSubstepDetectionType(vendorData);
            stepDetections.push(substepDetectionType);
            if (substep.Include && !substep.Is_Setup && !substep.Capability_Requirements.includes("False Positive")) {
              detectionCount = this.calculateDetectionCount(
                detectionCount,
                substepDetectionType
              );
            }
          });
          let targetId = `#stepDetectionChart_${step.Step_Num}_${vendor}`;
          const numAllDetections = Object.values(detectionCount).reduce(
            (a, b) => a + b,
            0
          );
          if (
            !numAllDetections &&
            stepDetections.every((detection) => detection === "Not applicable")
          ) {
            this.handleNoProtectionDetections(
              targetId,
              stepDetections,
              detectionCount
            );
          } else {
            this.$nextTick(() =>
              this.loadChart(detectionCount, targetId, numAllDetections)
            );
          }
        }
      });
    },

    generateTacticDetectionChart(vendor) {
      this.filterComparisonData(vendor);
      Object.entries(this.tactics).forEach(([tacticId]) => {
        if (!this.filtersUnchecked.tacticsUnchecked.includes(tacticId)) {
          let tacticDetectionTypes = [];
          let detectionCount = this.createDetectionCountDict();
          this.comparisonData.forEach((step) => {
            step.Substeps.forEach((substep) => {
              if (substep.Tactic.Tactic_Id === tacticId && substep.Include && !substep.Is_Setup && !substep.Capability_Requirements.includes("False Positive")) {
                let vendorData = substep.Vendor_Data.find(
                  (vendorData) => vendorData.Vendor_Name === vendor
                );
                let substepDetectionType = this.getSubstepDetectionType(vendorData);
                tacticDetectionTypes.push(substepDetectionType);
                detectionCount = this.calculateDetectionCount(
                  detectionCount,
                  substepDetectionType
                );
              }
            });
          });
          let targetId = `#tacticDetectionChart_${tacticId}_${vendor}`;
          const numAllDetections = Object.values(detectionCount).reduce(
            (a, b) => a + b,
            0
          );
          if (!numAllDetections) {
            this.handleNoTacticDetections(
              targetId,
              tacticId,
              tacticDetectionTypes,
              detectionCount
            );
          } else {
            this.tacticsNotShown = this.tacticsNotShown.filter(
              (tactic) => tactic !== tacticId
            );
            this.$nextTick(() =>
              this.loadChart(detectionCount, targetId, numAllDetections)
            );
          }
        }
      });
    },

    generateTacticActionableDetectionChart(vendor) {
      if (!this.actionableMetricPresent) return;
      this.filterComparisonData(vendor);
      Object.entries(this.tactics).forEach(([tacticId]) => {
        if (this.filtersUnchecked.tacticsUnchecked.includes(tacticId)) {
          return;
        }
        this.loadActionableChart(this.getActionablePerTacticFromVendor(vendor)[tacticId], `#tacticActionableDetectionChart_${tacticId}_${vendor}`, this.getTotalPossibleActionableForTactic(tacticId, vendor), this.substepTotalPerTactic[tacticId]);
      });
    },

    getSubstepDetectionType(vendorData) {
      let detections = vendorData?.Results;
      if (this.selectedScenario.scenario_type === "DETECTION" && detections) {
        let mostSpecificDetectionShown = detections.find(
          (detection) => detection.Most_Specific
        );
        if (mostSpecificDetectionShown) {
          return mostSpecificDetectionShown.Detection_Type;
        } else if (this.selectedEvaluation.domain === "MANAGED_SERVICES") {
          return "Not reported";
        } else {
          return "None";
        }
      } else if(this.selectedScenario.scenario_type === "PROTECTION" && detections) {
        return detections.Protection_Type;
      }
    },

    calculateDetectionCount(detectionCount, substepDetectionType) {
      if (
        this.selectedScenario.scenario_type === "DETECTION" ||
        substepDetectionType !== "Not applicable"
      ) {
        detectionCount[substepDetectionType]++;
      }
      return detectionCount;
    },

    createDetectionCountDict() {
      let detectionCount = {};
      this.evalResultCategoriesNames.forEach((resultCategory) => {
        detectionCount[resultCategory] = 0;
      });
      return detectionCount;
    },

    handleNoTacticDetections(
      targetId,
      tacticId,
      tacticDetectionTypes,
      detectionCount
    ) {
      if (this.selectedScenario.scenario_type !== "PROTECTION" || !tacticDetectionTypes.length) {
        select(targetId).select("svg").remove();
        this.tacticsNotShown.push(tacticId);
      } else {
        this.tacticsNotShown = this.tacticsNotShown.filter(
          (tactic) => tactic !== tacticId
        );
        this.handleNoProtectionDetections(
          targetId,
          tacticDetectionTypes,
          detectionCount
        );
      }
    },

    handleNoProtectionDetections(targetId, detectionTypes, detectionCount) {
      select(targetId).select("svg").remove();
      detectionCount["Not applicable"] = detectionTypes.length;
      const numAllDetections = detectionTypes.length;
      this.$nextTick(() =>
        this.loadChart(detectionCount, targetId, numAllDetections)
      );
    },

    getEvaluationSteps(data) {
      if (!this.selectedScenario) return;
      let scenarioValue = `Scenario_${this.selectedScenario.number}`;
      let stepsData;
      if (!this.preview) {
        stepsData =
          this.selectedScenario.scenario_type === "PROTECTION" && data[0].adversaries[0].Protections.Protection_Tests.length > 0
            ? data[0].adversaries[0].Protections.Protection_Tests
            : data[0].adversaries[0].Detections_By_Step[scenarioValue].Steps;
      } else {
        stepsData = data;
      }
      let evaluationSteps = [];
      let opFlow = this.operationalFlowForSelectedScenario.length ? this.operationalFlowForSelectedScenario : this.selectedEvaluation.operational_flow;
      opFlow.forEach((substep) => {
        let stepData = stepsData.find(step => step.Substeps.some(s => s.Substep === substep.name));
        if(stepData) {
          let substepData = this.getSubstepData(stepData, substep);
          if(substepData) {
            let step = this.selectedScenario.scenario_type === "PROTECTION" && data[0].adversaries[0].Protections.Protection_Tests.length
              ? evaluationSteps.find(s => s.Step_Num === stepData?.Test_Num)
              : evaluationSteps.find(s => s.Step_Num === substep.step_num);
            if (step){
              step.Substeps.push(substepData);
            }
            else if(substep.is_setup){
              evaluationSteps.push({
                checked: true,
                Step_Num: substep.step_num,
                Step_Name: substep.step_name,
                Step_Description: substep.step_description,
                Step_Vendor_Data: [],
                Substeps: [substepData],
                minusIcon: false,
                hover: false
              });
            }
            else {
              evaluationSteps.push({
                checked: true,
                Step_Num: stepData.Step_Num || stepData.Test_Num,
                Step_Name: stepData.Step_Name || stepData.Test_Name,
                Step_Description: stepData.Description || stepData.Test_Description,
                Step_Vendor_Data: [],
                Substeps: [substepData],
                minusIcon: false,
                hover: false
              });
            }
          }
        }
      });
      this.evaluationSteps = evaluationSteps;
    },

    getSubstepData(stepData, substep) {
        if(substep.is_setup){
          return {
            Subtechnique: {
              Subtechnique_Id: substep.subtechnique_tid,
              Subtechnique_Name: substep.subtechnique_name
            },
            Technique: {
              Technique_Id: substep.technique_tid,
              Technique_Name: substep.technique_name
            },
            Tactic: {
              Tactic_Id: substep.tactic_tid,
              Tactic_Name: substep.tactic_name
            },
            Substep: substep.name,
            Capability_Requirements: substep.capability_categories,
            Vendor_Data: [],
            Is_Setup: true,
            Criteria: substep.criteria,
            checked: true
          }

        }
        else {
          let stepsDataSubstep = stepData ? stepData.Substeps.find(s => s.Substep === substep.name) : undefined;
          if(stepsDataSubstep){
            return {
              Criteria: stepsDataSubstep.Criteria,
              Substep: stepsDataSubstep.Substep,
              Procedure: stepsDataSubstep.Procedure,
              Tactic: stepsDataSubstep.Tactic,
              Technique: stepsDataSubstep.Technique,
              Subtechnique: stepsDataSubstep.Subtechnique,
              Capability_Requirements: stepsDataSubstep.Capability_Requirements,
              Vendor_Data: [],
              Is_Setup: false,
              checked: true
            }
          }
        }
    },

    loadChart(data, targetId, numAllDetections, isEmpty) {
      // create svg element
      let height = this.chartHeight;
      let padding = 24;
      let width =
        document.getElementById("overviewCol").clientWidth /
          this.selectedVendors.length -
        padding;

      if (width > 0) {
        let svgId = "svg_" + targetId.replace("#", "");
        // remove svg so we don't have doubles of the same chart
        select(targetId).select("svg").remove();

        // add chart
        let svg = select(targetId)
          .append("svg")
          .attr("id", svgId)
          .attr("width", width)
          .attr("height", height);

        if (isEmpty) {
          svg.append("g")
              .append("rect")
              .attr("width", width)
              .attr("x", 0)
              .attr("y", 0)
              .attr("height", height)
              .attr("fill", "#F5F5F5")
              .style("stroke-width", "1")
              .style("stroke", "#E0E0E0");
          return;
        }

        let y = scaleBand().range([0, height]).padding([0.2]);

        let x = scaleLinear().domain([0, numAllDetections]).range([0, width]);

        // color palette = one color per subgroup
        let color = scaleOrdinal()
          .domain(this.evalResultCategoriesNames)
          .range(this.adversaryChartColors);

        let stackedData = stack().keys(this.evalResultCategoriesNames)([data]);

        // random numbers to get position of tooltip correct
        let extraSpaceRightOfTooltip = 65;

        // create tooltip and mouseover and mouseleave functions
        let tooltip = select(targetId)
          .append("div")
          .attr("class", "mk-tooltip--bottom chart-tooltip")
          .style("display", "none")
          .style("position", "absolute")
          .style("padding", "5px")
          .style("opacity", "100%");

        let mouseover = function (d) {
          let hoveredResultCategory = d.target.parentElement.__data__.key;
          let chartBottom =
            d.target.parentElement.getBoundingClientRect().bottom;
          let extraPaddingTop = 8;
          let hoveredValue = data[hoveredResultCategory];
          tooltip
            .style("display", "block")
            .style("top", `${chartBottom + extraPaddingTop + window.scrollY}px`)
            .style("left", `${d.pageX - extraSpaceRightOfTooltip}px`)
            .html(
              `${hoveredValue}/${numAllDetections} ${hoveredResultCategory.toLowerCase()} detections`
            );
        };

        let mouseleave = function () {
          tooltip.style("display", "none");
        };

        let mousemove = function (d) {
          tooltip
            .style("display", "block")
            .style("left", `${d.pageX - extraSpaceRightOfTooltip}px`);
        };

        // Show the bars
        svg
          .append("g")
          .selectAll("g")

          // Enter in the stack data = loop key per key = group per group
          .data(stackedData)
          .enter()
          .append("g")
          .attr("fill", function (d) {
            return color(d.key);
          })
          .style("stroke-width", "0.5")
          .style("stroke", function(d) {
            if (color(d.key) === "#FFFFFF") {
              return "#25333C"
            }
            return color(d.key);
          })
          .selectAll("rect")
          // enter a second time = loop subgroup per subgroup to add all rectangles
          .data(function (d) {
            return d;
          })
          .enter()
          .append("rect")
          .on("mouseenter", mouseover)
          .on("mouseleave", mouseleave)
          .on("mousemove", mousemove)
          .attr("y", function (d) {
            return (this.actionableMetricPresent ? 0 : y(d.data.group));
          })
          .attr("x", function (d) {
            return x(d[0]);
          })
          .attr("width", function (d) {
            return x(d[1]) - x(d[0]);
          })
          .attr("height", (this.actionableMetricPresent ? this.chartHeight : y.bandwidth()));
      }
    },
    loadActionableChart(actionableCount, targetId, numAllActionable, numAllDetections, isEmpty) {
      // create svg element
      let height = 7;
      let padding = 24;
      let width =
        document.getElementById("overviewCol").clientWidth /
          this.selectedVendors.length - padding;
      if (width > 0) {
        let svgId = "svg_" + targetId.replace("#", "");
        // remove svg so we don't have doubles of the same chart
        select(targetId).select("svg").remove();

        if (isEmpty) {
          select(targetId)
              .append("svg")
              .attr("id", svgId)
              .attr("width", width)
              .attr("height", height)
              .append("g")
              .append("rect")
              .attr("width", width)
              .attr("x", 0)
              .attr("y", 0)
              .attr("height", height)
              .attr("fill", "#F5F5F5")
              .style("stroke-width", "1")
              .style("stroke", "#E0E0E0");
          return;
        }

        let x = scaleLinear().domain([0, numAllDetections]).range([0, width]);

        const realWidth = x(numAllActionable);
        x = scaleLinear().domain([0, numAllActionable]).range([0, realWidth]);

        // add chart
        // two rects one after another, one for actionable detections, one for non-actionable detections
        select(targetId)
          .append("svg")
          .attr("id", svgId)
          .attr("width", realWidth)
          .attr("height", height)
          .append("g")
          .selectAll("g")
          .data([actionableCount, numAllActionable - actionableCount])
          .enter()
          .append("rect")
          .attr("y", 0)
          .attr("x", function (d, i) {
            return x(i === 0 ? 0 : actionableCount);
          })
          .attr("width", function (d, i) {
            return x(i === 0 ? actionableCount : numAllActionable) - x(i === 0 ? 0 : actionableCount);
          })
          .attr("height", height)
          .attr("fill", function (d, i) {
            return i === 0 ? "#403386" : "#CFC5EE";
          });
      }
    },
    checkIfChartsOrDetailsVisible() {
      let evaluationDetails = document.getElementById("evaluationDetailsCol");
      let charts = document.getElementById("charts");
      if (evaluationDetails || charts) {
        let chartsTop = window.innerHeight - charts.getBoundingClientRect().top;
        this.chartsOrDetailsVisible = chartsTop > 0;
      } else {
        this.chartsOrDetailsVisible = false;
      }
    },
    handlePageResize() {
      this.renderCharts();
      this.checkIfLegendOverlap();
      if (this.$vuetify.display.mobile) {
        this.selectedVendorsLimit = 1;
        this.selectedVendors.forEach((vendor, idx) => {
          idx !== 0 && (vendor.checked = false);
        });
        this.selectedVendors = this.selectedVendors.slice(0, 1);
        this.expandOverviewCard = false;
      } else {
        this.selectedVendorsLimit = 3;
        this.expandOverviewCard = true;
      }
    },
    handleMobileScroll() {
      if(this.$vuetify.display.mobile) {
        this.handleScroll();
      }
    },
    handleScroll() {
      this.checkIfLegendOverlap();
      this.checkIfChartsOrDetailsVisible();
      this.checkIfEvaluationDetailsVisible();
    },
    checkIfEvaluationDetailsVisible(){
      let evaluationDetails = document.getElementById('evaluationDetailsCol')?.getBoundingClientRect();
      let chartLegend = document.getElementById('chart-legend')?.getBoundingClientRect();
      let scrollToTopBtn = document.getElementById('scroll-to-top-btn')?.getBoundingClientRect();
      if (this.scrollToTopBtnStyle === "" && scrollToTopBtn && chartLegend) {
        let scrollToTopBtnPosition =  chartLegend.height - scrollToTopBtn.height;
        this.scrollToTopBtnStyle = `marginBottom: ${scrollToTopBtnPosition}px;`;
      }
      if (evaluationDetails) {
        let topEvaluationDetails = window.innerHeight - evaluationDetails.top;
        // take margin below button (20%) into account
        let margin = 1 / 5;
        this.isEvaluationDetailsVisible = topEvaluationDetails - window.innerHeight * margin > 0;
      }
    },
    getTotalSubsteps() {
      return this.filteredSubsteps.filter(substep => !substep.Is_Setup && !substep.Capability_Requirements.includes("False Positive")).length;
    },
    getActionablePerStepFromVendor(vendorName) {
      let actionablePerStep = {};
      this.comparisonData.forEach((step) => {
        if (step.checked) {
          let actionableCount = step.Substeps.filter(substep => {
            const substepVendorData = substep.Vendor_Data.find(vendorData => vendorData.Vendor_Name === vendorName);
            if (!substepVendorData || substep.Is_Setup || substep.Capability_Requirements.includes("False Positive")) {
              return false;
            }
            const detectionIsActionable = substepVendorData.Results[0]?.Actionable;
            const includeStep = substep.Include;
            const detectionIsMostSpecific = substepVendorData.Results[0]?.Most_Specific;
            return  detectionIsActionable && includeStep && detectionIsMostSpecific;
          }).length;
          actionablePerStep[step.Step_Num] = actionableCount;
        }
      });
      return actionablePerStep;
    },
    getActionableTotalFromVendor(vendorName){
      return Object.values(this.getActionablePerStepFromVendor(vendorName)).reduce((a, b) => a + b, 0);
    },
    getTotalPossibleActionableForVendor(vendorName) {
      return this.comparisonData.reduce((total, step) => {
        if (!step.checked) {
          return total;
        }
        return total + this.getTotalPossibleActionableForStep(step, vendorName);
      }, 0);
    },
    getTotalPossibleActionableForStep(step, vendorName) {
      return step.Substeps.filter(
        substep => substep.Vendor_Data.find(
          vendor => vendor.Vendor_Name === vendorName &&
          !substep.Is_Setup &&
          !substep.Capability_Requirements.includes("False Positive") &&
          vendor.Results[0].Detection_Type === "Reported" &&
          vendor.Results[0].Most_Specific)
          && substep.Include).length;
    },
    getActionablePerTacticFromVendor(vendorName) {
      let actionablePerTactic = {};
      Object.entries(this.tactics).forEach(([tacticId]) => {
        let actionableCount = this.comparisonData.reduce((total, step) => {
          if (!step.checked) {
            return total;
          }
          return total + step.Substeps.filter((substep) => {
            const vendorData = substep.Vendor_Data.find(vendorData => vendorData.Vendor_Name === vendorName);
            return !substep.Is_Setup &&
              !substep.Capability_Requirements.includes("False Positive") &&
              substep.Tactic.Tactic_Id === tacticId &&
              vendorData.Results[0].Actionable &&
              substep.Include && vendorData.Results[0].Most_Specific}).length
        }, 0);
        actionablePerTactic[tacticId] = actionableCount;
      });
      return actionablePerTactic;
    },
    getTotalPossibleActionableForTactic(tacticId, vendorName) {
      return this.comparisonData.reduce((total, step) => {
        if (!step.checked) {
          return total;
        }
        return total + step.Substeps.filter(
          substep => substep.Tactic.Tactic_Id === tacticId &&
            !substep.Is_Setup &&
            !substep.Capability_Requirements.includes("False Positive") &&
            substep.Vendor_Data.find(
              vendor => vendor.Vendor_Name === vendorName &&
                vendor.Results[0].Detection_Type === "Reported" &&
                vendor.Results[0].Most_Specific) &&
            substep.Include).length;
      }, 0);
    },
    constructAlertData(vendor){
      const alertGroups = ["Critical", "High", "Medium", "Low", "Other"];
      let alertFormFactors = [];
      if (this.selectedEvaluation && this.selectedEvaluation.domain === 'ENTERPRISE') {
        alertFormFactors = ["CONFIGURATION_CHANGE", "INITIAL_RUN"];
      }
      else {
        alertFormFactors = ["EMAIL", "CONSOLE"];
      }
      const data = [];
      alertGroups.forEach(group => {
        const alertGroup = {"group": group};
        alertFormFactors.forEach(formFactor => alertGroup[formFactor] = 0);
        data.push(alertGroup);
      });
      const formFactorMapping = {
        "Configuration Change": "CONFIGURATION_CHANGE",
        "Initial Run": "INITIAL_RUN",
        "Email": "EMAIL",
        "Console": "CONSOLE",
      };
      this.vendorAlertCountDict[vendor].forEach((alert) => {
        let group = alert.severity.charAt(0) + alert.severity.slice(1).toLowerCase();
        let format = formFactorMapping[alert.form_factor] || alert.form_factor;
        let count = alert.count;
        if (group == "None") {
          group = "Other";
        }
        let groupIndex = data.findIndex(d => d.group === group);
        data[groupIndex][format] = count;
      });
      return data;
    },

    loadAlertCharts(vendor) {
      // create svg element
      let height = 200;
      let width = this.chartWidth - 50;
      const margin = { top: 30, right: 30, bottom: 30, left: 45 };
      const targetId = `#alertChart_${vendor}`;
      if (width > 0) {
        // remove svg so we don't have doubles of the same chart
        select(targetId).select("svg").remove();
      }

      let alertFormats, alertCountColors;

      if (this.selectedEvaluation && this.selectedEvaluation.domain === 'ENTERPRISE') {
        alertFormats = ["CONFIGURATION_CHANGE", "INITIAL_RUN"];
        alertCountColors = ["#9EA4A8", "#25333C"];
      } else {
        alertFormats = ["EMAIL", "CONSOLE"];
        alertCountColors = ["#9EA4A8", "#25333C"];
      }

      // add chart
      let svg = select(targetId)
        .append("svg")
        .attr("width", width)
        .attr("height", height);
      const alertSeverities = ["Critical", "High", "Medium", "Low", "Other"];
      let x = scaleBand().domain(alertSeverities).range([margin.left, width]).paddingOuter(0.1).paddingInner(0.7);
      let y = scaleLinear().domain([0, this.alertChartScale]).rangeRound([height - margin.bottom, margin.top]);
      function make_y_gridlines() {
        return axisLeft(y).ticks(5);
      }

      let yAxis = (g) =>
        g.attr('transform', `translate(${margin.left},0)`).call(
          axisLeft(y).tickFormat(function (a) {
            if (a % 100 === 0) {
              return a;
            }
          }),
        );

      const xAxis = (g) =>
        g.attr('transform', `translate(0,${height - margin.bottom + 10})`).call(
          axisBottom(x).tickSize(0),
        );

      let color = scaleOrdinal().domain(alertFormats).range(alertCountColors);
      const data = this.constructAlertData(vendor);
      let stackedData = stack().keys(alertFormats)(data);
      stackedData.map((d) => d.forEach((v) => (v.key = d.key)));

      if (select(targetId).select(".chart-tooltip").node()) {
        select(targetId).select(".chart-tooltip").remove();
      }

      let labelTooltip = select(targetId)
        .append("div")
        .attr("class", "mk-tooltip--top chart-tooltip")
        .style("opacity", "0");

      let tooltip = select(targetId)
        .append("div")
        .attr("class", "mk-tooltip--top chart-tooltip")
        .style("opacity", "0");

      let mouseover = function (d, domain) {
        let rectConsole = d.target.parentElement.parentElement.querySelector("#" + d.target.id);
        const topCategory = domain === 'ENTERPRISE' ? "#INITIAL_RUN_": "#CONSOLE_";
        const topCategoryRect = d.target.parentElement.parentElement.querySelector(topCategory + d.target.__data__.data.group);
        if (topCategoryRect && topCategoryRect.getAttribute("height") > 0){
          rectConsole = topCategoryRect;
        }
        const rectConsoleTop = rectConsole.getBoundingClientRect().top;
        let extraPaddingTop = 105;
        const alertFormats = Object.keys(d.target.__data__.data).filter(key => key !== 'group');

        let tooltipContent = alertFormats.map(format => {
          return `<span class='font-weight-bold'>${d.target.__data__.data[format]}</span> ${d.target.__data__.data.group} ${format.replace('_', ' ').toLowerCase()} alerts`;
        }).join('<br>');

        let totalAlerts = alertFormats.reduce((sum, format) => sum + d.target.__data__.data[format], 0);
        tooltipContent += `<br><span class='font-weight-bold'>${totalAlerts}</span> Total ${d.target.__data__.data.group} alerts`;

        tooltip
          .style("position", "absolute")
          .style("opacity", "1")
          .style("display", "block")
          .style("padding", "5px")
          .style("top", `${rectConsoleTop - extraPaddingTop + window.scrollY}px`)
          .html(tooltipContent);
      };

      let labelMouseLeave = function () {
        labelTooltip.style("opacity", 0);
      };

      let labelMouseOver = function (d, event) {
        let tooltipContent = alertFormats.map(format => {
          return `<span class='font-weight-bold'>${d[format]}</span> ${d.group} ${format.replace('_', ' ').toLowerCase()} alerts`;
        }).join('<br>');

        let totalAlerts = alertFormats.reduce((sum, format) => sum + d[format], 0);
        tooltipContent += `<br><span class='font-weight-bold'>${totalAlerts}</span> Total ${d.group} alerts`;

        labelTooltip
          .style("position", "absolute")
          .style("opacity", "1")
          .style("padding", "5px")
          .style("top", `${document.getElementById(event.target.id).getBoundingClientRect().top -  105 + window.scrollY}px`)
          .html(tooltipContent);
      };

    let mouseleave = function () {
      tooltip
        .style("opacity", "0")
        .style("padding", "0px");
      labelTooltip
        .style("opacity", "0")
        .style("padding", "0px");
      };

    let mousemove = function (d) {
      const tooltipWidth = tooltip.node().getBoundingClientRect().width;
      const rectConsole = d.target; 
      tooltip
        .style("opacity", "1")
        .style("left", `${rectConsole.getBoundingClientRect().right - rectConsole.getBoundingClientRect().width / 2 - tooltipWidth / 2 - 1}px`);
    };

    let labelMouseMove = function(d) {
      const tooltipWidth = labelTooltip.node().getBoundingClientRect().width;
      const rectConsole = d.target;
      labelTooltip
        .style("opacity", "1")
        .style("top", `${rectConsole.getBoundingClientRect().top - 105 + window.scrollY}px`)
        .style("left", `${rectConsole.getBoundingClientRect().right - rectConsole.getBoundingClientRect().width / 2 - tooltipWidth / 2 - 1}px`);
    };

      // Show the bars
      svg
        .append('g')
        .attr('class', 'grid')
        .attr('transform', 'translate(' + margin.left + ', 0)')
        .call(make_y_gridlines().tickSize(-(width - margin.right)).tickFormat(''))
        .selectAll('path').remove();

      svg
        .append('g')
        .selectAll('g')
        .data(stackedData)
        .join('g')
        .attr('fill', (d) => color(d.key))
        .selectAll('rect')
        .data((d) => d)
        .join('rect')
        .attr('id', (d) => d.key + "_" + d.data.group)
        .attr('x', (d) => x(d.data.group))
        .attr('y', (d) => y(d[1]))
        .attr('height', (d) => y(d[0]) - y(d[1]))
        .attr('width', x.bandwidth())
        .on('mouseover', (d)=> mouseover(d, this.selectedEvaluation.domain))
        .on('mouseleave', mouseleave)
        .on('mousemove', mousemove);

      // Add labels on top of each bar in alert chart
      data.forEach(d => {
        const totalAlerts = alertFormats.reduce((sum, format) => sum + d[format], 0);
        svg.append("text")
          .attr("id", `label-${d.group}`)
          .attr("x", x(d.group) + x.bandwidth() / 2)
          .attr("y", y(totalAlerts) - 5)
          .attr("text-anchor", "middle")
          .attr("class", "bar-label")
          .attr("style", "cursor: default;") 
          .text(totalAlerts)
          .on('mouseover', (event) => labelMouseOver(d, event))
          .on('mouseleave', labelMouseLeave)
          .on('mousemove', labelMouseMove);
      });

      svg.append('g').call(yAxis).selectAll("path,line").remove();
      svg.append('g').call(xAxis).selectAll("path,line").remove();
    },
    filterProtectionChartSubsteps(substeps) {
      return substeps.filter(substep => !substep.Is_Setup && !substep.Capability_Requirements.includes("False Positive") && substep.Include);
    }
  },
  mounted() {
    window.addEventListener("resize", this.handlePageResize);
    window.addEventListener("scroll", this.handleMobileScroll);
    if (this.$vuetify.display.mobile) {
      this.selectedVendorsLimit = 1;
      this.expandOverviewCard = false;
    }
    this.selectedEvaluation = this.startingEvaluation;
    if (this.selectedEvaluation) {
      this.selectEvaluation();
    }
    else {
      this.$nextTick(() => {
        this.$refs.evaluationSelect.activate();
      });
    }
  },
  unmounted() {
    window.removeEventListener("resize", this.handlePageResize);
    window.removeEventListener("scroll", this.handleMobileScroll);
  },
};

const _hoisted_1 = /*#__PURE__*/createElementVNode("div", { class: "mk-text--h5" }, "Results", -1 /* HOISTED */);
const _hoisted_2 = { class: "toggle-container" };
const _hoisted_3 = /*#__PURE__*/createElementVNode("span", null, "Evaluation", -1 /* HOISTED */);
const _hoisted_4 = /*#__PURE__*/createElementVNode("span", null, "Scenario", -1 /* HOISTED */);
const _hoisted_5 = { key: 0 };
const _hoisted_6 = { key: 1 };
const _hoisted_7 = { key: 0 };
const _hoisted_8 = { key: 0 };
const _hoisted_9 = { key: 0 };
const _hoisted_10 = { key: 1 };
const _hoisted_11 = /*#__PURE__*/createElementVNode("p", { class: "mk-text--grey60" }, "Evaluation", -1 /* HOISTED */);
const _hoisted_12 = { class: "d-flex align-items-center" };
const _hoisted_13 = { class: "selected-eval-name-year" };
const _hoisted_14 = ["href"];
const _hoisted_15 = ["innerHTML"];
const _hoisted_16 = /*#__PURE__*/createElementVNode("p", { class: "mk-text--grey60" }, "Scenario", -1 /* HOISTED */);
const _hoisted_17 = ["innerHTML"];
const _hoisted_18 = {
  key: 0,
  class: "mt-4 text-left"
};
const _hoisted_19 = ["onMouseenter", "onMouseleave"];
const _hoisted_20 = { class: "step-name-container" };
const _hoisted_21 = ["onMouseenter", "onClick"];
const _hoisted_22 = {
  key: 1,
  class: "text-right float-right mk-text--grey60"
};
const _hoisted_23 = {
  key: 2,
  class: "text-right"
};
const _hoisted_24 = /*#__PURE__*/createElementVNode("span", { class: "mk-text--grey60" }, "Results", -1 /* HOISTED */);
const _hoisted_25 = {
  key: 3,
  class: "text-right"
};
const _hoisted_26 = ["id"];
const _hoisted_27 = ["id"];
const _hoisted_28 = { key: 2 };
const _hoisted_29 = {
  key: 0,
  class: "text-left"
};
const _hoisted_30 = /*#__PURE__*/createElementVNode("span", { class: "mk-text--grey60" }, "Actionable Detections ", -1 /* HOISTED */);
const _hoisted_31 = { key: 1 };
const _hoisted_32 = /*#__PURE__*/createElementVNode("span", { class: "mk-text--grey60" }, " Actionable Detections ", -1 /* HOISTED */);
const _hoisted_33 = /*#__PURE__*/createElementVNode("span", null, [
  /*#__PURE__*/createTextVNode("Actionable detections include some or all of the following as applicable: activity, time, location, users, and context. "),
  /*#__PURE__*/createElementVNode("a", {
    href: "/managed-services/menupass-blackcat/",
    target: "_blank"
  }, "Learn More")
], -1 /* HOISTED */);
const _hoisted_34 = {
  key: 1,
  class: "mt-4 text-left"
};
const _hoisted_35 = { key: 0 };
const _hoisted_36 = { class: "m-spacing--top-3 step-name-div" };
const _hoisted_37 = { class: "step-name-container" };
const _hoisted_38 = { class: "step-name" };
const _hoisted_39 = { class: "text-right" };
const _hoisted_40 = /*#__PURE__*/createElementVNode("span", { class: "mk-text--grey60" }, "Results", -1 /* HOISTED */);
const _hoisted_41 = ["id"];
const _hoisted_42 = ["id"];
const _hoisted_43 = { key: 1 };
const _hoisted_44 = { class: "text-left" };
const _hoisted_45 = /*#__PURE__*/createElementVNode("span", { class: "mk-text--grey60" }, "Actionable Detections ", -1 /* HOISTED */);
const _hoisted_46 = /*#__PURE__*/createElementVNode("span", null, [
  /*#__PURE__*/createTextVNode("Actionable detections include some or all of the following as applicable: activity, time, location, users, and context. "),
  /*#__PURE__*/createElementVNode("a", {
    href: "/managed-services/menupass-blackcat/",
    target: "_blank"
  }, "Learn More")
], -1 /* HOISTED */);
const _hoisted_47 = {
  key: 2,
  class: "text-left"
};
const _hoisted_48 = ["id"];
const _hoisted_49 = ["onMouseenter", "onMouseleave"];
const _hoisted_50 = { class: "step-name-container" };
const _hoisted_51 = ["onMouseenter", "onClick"];
const _hoisted_52 = ["width", "height"];
const _hoisted_53 = ["height", "width"];
const _hoisted_54 = { key: 0 };

function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_progress_circular = resolveComponent("v-progress-circular");
  const _component_v_overlay = resolveComponent("v-overlay");
  const _component_ChartLegend = resolveComponent("ChartLegend");
  const _component_v_btn = resolveComponent("v-btn");
  const _component_v_btn_toggle = resolveComponent("v-btn-toggle");
  const _component_v_divider = resolveComponent("v-divider");
  const _component_VueMultiselect = resolveComponent("VueMultiselect");
  const _component_v_col = resolveComponent("v-col");
  const _component_v_chip = resolveComponent("v-chip");
  const _component_v_row = resolveComponent("v-row");
  const _component_v_icon = resolveComponent("v-icon");
  const _component_v_checkbox = resolveComponent("v-checkbox");
  const _component_Filters = resolveComponent("Filters");
  const _component_v_menu = resolveComponent("v-menu");
  const _component_v_card_text = resolveComponent("v-card-text");
  const _component_v_card = resolveComponent("v-card");
  const _component_VendorLogoAndHoverButtons = resolveComponent("VendorLogoAndHoverButtons");
  const _component_ScenarioSummary = resolveComponent("ScenarioSummary");
  const _component_LinuxChip = resolveComponent("LinuxChip");
  const _component_v_tooltip = resolveComponent("v-tooltip");
  const _component_EvaluationDetails = resolveComponent("EvaluationDetails");

  return (openBlock(), createElementBlock("div", null, [
    createVNode(_component_v_overlay, { "model-value": _ctx.showOverlay }, {
      default: withCtx(() => [
        createVNode(_component_v_progress_circular, {
          color: "white",
          indeterminate: "",
          size: "64"
        })
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["model-value"]),
    createCommentVNode(" chart legend, fixed at the bottom right of the page "),
    (
        _ctx.selectedVendors &&
        _ctx.selectedVendors.length &&
        (!_ctx.$vuetify.display.mobile || _ctx.mobileDetectionKeyExpanded)
      )
      ? (openBlock(), createBlock(_component_ChartLegend, {
          key: 0,
          evalResultCategories: _ctx.evalResultCategories,
          chartColors: _ctx.adversaryChartColors,
          onUpdateLegendExpanded: $options.updateLegendExpanded,
          onUpdateMobileDetectionKeyExpanded: $options.updateMobileDetectionKeyExpanded,
          class: "chart-legend"
        }, null, 8 /* PROPS */, ["evalResultCategories", "chartColors", "onUpdateLegendExpanded", "onUpdateMobileDetectionKeyExpanded"]))
      : createCommentVNode("v-if", true),
    createVNode(Transition, null, {
      default: withCtx(() => [
        (
          _ctx.$vuetify.display.mobile &&
          _ctx.selectedVendors.length &&
          _ctx.chartsOrDetailsVisible &&
          !_ctx.mobileDetectionKeyExpanded
        )
          ? (openBlock(), createBlock(_component_v_btn, {
              key: 0,
              class: "detection-key-mobile fixed-btn",
              color: "primary",
              icon: "mdi-key",
              onClick: _cache[0] || (_cache[0] = $event => (_ctx.mobileDetectionKeyExpanded = true)),
              "data-id": "results.mobiledetectionkeybutton"
            }))
          : createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }),
    createCommentVNode(" Top Row: evaluation, scenario, and adversary selects and overview card "),
    createVNode(_component_v_row, {
      class: normalizeClass(_ctx.$vuetify.display.mobile ? '' : 'flex-nowrap')
    }, {
      default: withCtx(() => [
        createCommentVNode(" evaluation, scenario, and adversary selects "),
        createVNode(_component_v_col, {
          cols: _ctx.$vuetify.display.mobile ? '12' : 'auto',
          class: normalizeClass({'text-left': true, 'fixed-scroll': !_ctx.$vuetify.display.mobile })
        }, {
          default: withCtx(() => [
            _hoisted_1,
            createElementVNode("div", _hoisted_2, [
              createVNode(_component_v_btn_toggle, {
                class: "cohort-or-individual-participant-toggle w-100",
                density: "compact",
                modelValue: _ctx.toggle,
                "onUpdate:modelValue": [
                  _cache[1] || (_cache[1] = $event => ((_ctx.toggle) = $event)),
                  _cache[2] || (_cache[2] = $event => (_ctx.$emit('toggle')))
                ],
                color: "primary"
              }, {
                default: withCtx(() => [
                  createVNode(_component_v_btn, {
                    value: "cohort",
                    class: normalizeClass(_ctx.$vuetify.display.smAndDown ? 'w-50' : '')
                  }, {
                    default: withCtx(() => [
                      createTextVNode("Cohort ")
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["class"]),
                  createVNode(_component_v_btn, {
                    value: "individualParticipant",
                    class: normalizeClass(_ctx.$vuetify.display.smAndDown ? 'w-50' : '')
                  }, {
                    default: withCtx(() => [
                      createTextVNode("Individual ")
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["class"])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["modelValue"])
            ]),
            createVNode(_component_v_divider, { class: "my-3" }),
            _hoisted_3,
            createElementVNode("div", {
              class: normalizeClass(_ctx.$vuetify.display.mobile ? '' : 'width-287')
            }, [
              createVNode(_component_VueMultiselect, {
                ref: "evaluationSelect",
                modelValue: _ctx.selectedEvaluation,
                "onUpdate:modelValue": [
                  _cache[3] || (_cache[3] = $event => ((_ctx.selectedEvaluation) = $event)),
                  $options.selectEvaluation
                ],
                options: $props.evaluations,
                disabled: $props.preview,
                placeholder: "Select evaluation",
                label: "display_name",
                class: "mk-vue-select result-select-menu",
                "data-id": "results.evaluationselect",
                selectLabel: "",
                deselectLabel: "",
                selectedLabel: ""
              }, null, 8 /* PROPS */, ["modelValue", "options", "disabled", "onUpdate:modelValue"])
            ], 2 /* CLASS */),
            createCommentVNode(" a select menu does not appear until the previous menu has a value selected "),
            createElementVNode("div", null, [
              (_ctx.selectedEvaluation && _ctx.scenarioOptions.length > 1)
                ? (openBlock(), createElementBlock("div", {
                    key: 0,
                    class: normalizeClass({
              'text-left m-spacing--top-3': true,
              'width-287': !_ctx.$vuetify.display.mobile
            })
                  }, [
                    _hoisted_4,
                    createVNode(_component_VueMultiselect, {
                      ref: "scenarioSelect",
                      modelValue: _ctx.selectedScenario,
                      "onUpdate:modelValue": [
                        _cache[4] || (_cache[4] = $event => ((_ctx.selectedScenario) = $event)),
                        $options.selectScenario
                      ],
                      options: _ctx.scenarioOptions,
                      placeholder: "Select scenario",
                      class: "mk-vue-select result-select-menu",
                      "data-id": "results.scenarioselect",
                      label: "name",
                      selectLabel: "",
                      deselectLabel: "",
                      selectedLabel: ""
                    }, null, 8 /* PROPS */, ["modelValue", "options", "onUpdate:modelValue"])
                  ], 2 /* CLASS */))
                : createCommentVNode("v-if", true),
              (_ctx.selectedScenario)
                ? (openBlock(), createElementBlock("div", {
                    key: 1,
                    class: normalizeClass({'text-left mt-2': true,  'width-287': !_ctx.$vuetify.display.mobile})
                  }, [
                    (_ctx.$vuetify.display.mobile)
                      ? (openBlock(), createElementBlock("span", _hoisted_5, "Participant"))
                      : (openBlock(), createElementBlock("span", _hoisted_6, "Participant(s)")),
                    createVNode(_component_VueMultiselect, {
                      ref: "vendorMultiselect",
                      options: _ctx.vendorOptions,
                      disabled: $props.preview,
                      placeholder: 
                _ctx.selectedVendors.length
                  ? ''
                  : _ctx.$vuetify.display.mobile
                  ? 'Select participant'
                  : 'Select participant(s)'
              ,
                      onRemove: $options.removeVendor,
                      class: "mk-vue-select--multiple result-select-menu",
                      label: "display_name",
                      selectLabel: "",
                      deselectLabel: "",
                      selectedLabel: "",
                      "close-on-select": false,
                      searchable: false
                    }, {
                      selection: withCtx(({ isOpen }) => [
                        (!isOpen && _ctx.selectedVendors.length)
                          ? (openBlock(), createElementBlock("div", _hoisted_7, [
                              createVNode(_component_v_row, { class: "mk-vue-select-title-row" }, {
                                default: withCtx(() => [
                                  createVNode(_component_v_col, {
                                    class: "mk-vue-select-title",
                                    cols: "8"
                                  }, {
                                    default: withCtx(() => [
                                      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.selectedVendors, (vendor, idx) => {
                                        return (openBlock(), createElementBlock("span", {
                                          key: vendor.name
                                        }, [
                                          createTextVNode(toDisplayString(vendor.display_name) + " ", 1 /* TEXT */),
                                          (idx < _ctx.selectedVendors.length - 1)
                                            ? (openBlock(), createElementBlock("span", _hoisted_8, ", "))
                                            : createCommentVNode("v-if", true)
                                        ]))
                                      }), 128 /* KEYED_FRAGMENT */))
                                    ]),
                                    _: 1 /* STABLE */
                                  }),
                                  createVNode(_component_v_col, { cols: "3" }, {
                                    default: withCtx(() => [
                                      (_ctx.selectedVendors.length > 1)
                                        ? (openBlock(), createElementBlock("span", _hoisted_9, [
                                            createVNode(_component_v_chip, { class: "mk-vue-select-chip" }, {
                                              default: withCtx(() => [
                                                createTextVNode(toDisplayString(_ctx.selectedVendors.length), 1 /* TEXT */)
                                              ]),
                                              _: 1 /* STABLE */
                                            })
                                          ]))
                                        : createCommentVNode("v-if", true)
                                    ]),
                                    _: 1 /* STABLE */
                                  })
                                ]),
                                _: 1 /* STABLE */
                              })
                            ]))
                          : (openBlock(), createElementBlock("div", _hoisted_10, [
                              (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.selectedVendors, (vendor) => {
                                return (openBlock(), createBlock(_component_v_chip, {
                                  class: "mk-vue-select-chip px-2 mx-1 my-1",
                                  key: vendor.name
                                }, {
                                  default: withCtx(() => [
                                    createTextVNode(toDisplayString(vendor.display_name) + " ", 1 /* TEXT */),
                                    createVNode(_component_v_icon, {
                                      onClick: $event => ($options.removeVendor(vendor))
                                    }, {
                                      default: withCtx(() => [
                                        createTextVNode("mdi-close")
                                      ]),
                                      _: 2 /* DYNAMIC */
                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])
                                  ]),
                                  _: 2 /* DYNAMIC */
                                }, 1024 /* DYNAMIC_SLOTS */))
                              }), 128 /* KEYED_FRAGMENT */))
                            ]))
                      ]),
                      option: withCtx(({ option }) => [
                        createVNode(_component_v_checkbox, {
                          modelValue: option.checked,
                          "onUpdate:modelValue": [$event => ((option.checked) = $event), $event => ($options.selectVendorFromCheck(option))],
                          label: option.display_name,
                          class: "mk-checkbox",
                          "data-id": "results.vendorselectcheckbox",
                          disabled: 
                    _ctx.selectedVendors.length >= _ctx.selectedVendorsLimit &&
                    !_ctx.selectedVendors.find((vendor) => vendor.name === option.name)
                  
                        }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "label", "disabled"])
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["options", "disabled", "placeholder", "onRemove"])
                  ], 2 /* CLASS */))
                : createCommentVNode("v-if", true),
              createCommentVNode(" Filtering and results overview "),
              (
              _ctx.selectedVendors &&
              _ctx.selectedVendors.length &&
              !_ctx.$vuetify.display.mobile
            )
                ? (openBlock(), createElementBlock("div", {
                    key: 2,
                    class: normalizeClass({'text-left': true, 'width-287': !_ctx.$vuetify.display.mobile})
                  }, [
                    createVNode(_component_Filters, {
                      evaluationSteps: _ctx.evaluationSteps,
                      selectedEvaluation: _ctx.selectedEvaluation,
                      generateScenarioDetectionChart: $options.generateScenarioDetectionChart,
                      generateScenarioActionableDetectionChart: $options.generateScenarioActionableDetectionChart,
                      generateStepDetectionChart: $options.generateStepDetectionChart,
                      generateStepActionableDetectionChart: $options.generateStepActionableDetectionChart,
                      generateTacticDetectionChart: $options.generateTacticDetectionChart,
                      generateTacticActionableDetectionChart: $options.generateTacticActionableDetectionChart,
                      selectedVendors: _ctx.selectedVendors,
                      filtersTab: _ctx.filtersTab,
                      tactics: _ctx.tactics,
                      filtersUnchecked: _ctx.filtersUnchecked,
                      allModifierTypes: $props.allModifierTypes,
                      selectedScenario: _ctx.selectedScenario,
                      onUpdateTactics: $options.updateTactics,
                      onUpdateFiltersTab: $options.updateFiltersTab,
                      onUpdateFiltersUnchecked: $options.updateFiltersUnchecked,
                      onUpdateShowSetup: _cache[5] || (_cache[5] = value => _ctx.showSetup = value),
                      onUpdateStepChecked: $options.updateStepChecked,
                      onUpdateSubstepChecked: $options.updateSubstepChecked
                    }, null, 8 /* PROPS */, ["evaluationSteps", "selectedEvaluation", "generateScenarioDetectionChart", "generateScenarioActionableDetectionChart", "generateStepDetectionChart", "generateStepActionableDetectionChart", "generateTacticDetectionChart", "generateTacticActionableDetectionChart", "selectedVendors", "filtersTab", "tactics", "filtersUnchecked", "allModifierTypes", "selectedScenario", "onUpdateTactics", "onUpdateFiltersTab", "onUpdateFiltersUnchecked", "onUpdateStepChecked", "onUpdateSubstepChecked"])
                  ], 2 /* CLASS */))
                : createCommentVNode("v-if", true),
              (_ctx.selectedVendors && _ctx.selectedVendors.length && _ctx.$vuetify.display.mobile)
                ? (openBlock(), createBlock(_component_v_menu, {
                    key: 3,
                    scrim: "true",
                    "close-on-content-click": false
                  }, {
                    activator: withCtx(({ props }) => [
                      createElementVNode("div", mergeProps({ class: "enable-mobile-filters" }, props), [
                        createVNode(_component_v_btn, {
                          icon: "",
                          variant: "text"
                        }, {
                          default: withCtx(() => [
                            createVNode(_component_v_icon, null, {
                              default: withCtx(() => [
                                createTextVNode("mdi-filter-variant")
                              ]),
                              _: 1 /* STABLE */
                            })
                          ]),
                          _: 1 /* STABLE */
                        })
                      ], 16 /* FULL_PROPS */)
                    ]),
                    default: withCtx(() => [
                      createElementVNode("div", {
                        class: normalizeClass({'text-left': true, 'width-287': !_ctx.$vuetify.display.mobile, 'mobile-filter-container': true, 'border-radius-top-4': true})
                      }, [
                        createVNode(_component_Filters, {
                          evaluationSteps: _ctx.evaluationSteps,
                          selectedEvaluation: _ctx.selectedEvaluation,
                          generateScenarioDetectionChart: $options.generateScenarioDetectionChart,
                          generateScenarioActionableDetectionChart: $options.generateScenarioActionableDetectionChart,
                          generateStepDetectionChart: $options.generateStepDetectionChart,
                          generateStepActionableDetectionChart: $options.generateStepActionableDetectionChart,
                          generateTacticDetectionChart: $options.generateTacticDetectionChart,
                          generateTacticActionableDetectionChart: $options.generateTacticActionableDetectionChart,
                          selectedVendors: _ctx.selectedVendors,
                          filtersTab: _ctx.filtersTab,
                          tactics: _ctx.tactics,
                          filtersUnchecked: _ctx.filtersUnchecked,
                          allModifierTypes: $props.allModifierTypes,
                          selectedScenario: _ctx.selectedScenario,
                          onUpdateTactics: $options.updateTactics,
                          onUpdateFiltersTab: $options.updateFiltersTab,
                          onUpdateFiltersUnchecked: $options.updateFiltersUnchecked,
                          onUpdateShowSetup: _cache[6] || (_cache[6] = value => _ctx.showSetup = value),
                          onUpdateStepChecked: $options.updateStepChecked,
                          onUpdateSubstepChecked: $options.updateSubstepChecked
                        }, null, 8 /* PROPS */, ["evaluationSteps", "selectedEvaluation", "generateScenarioDetectionChart", "generateScenarioActionableDetectionChart", "generateStepDetectionChart", "generateStepActionableDetectionChart", "generateTacticDetectionChart", "generateTacticActionableDetectionChart", "selectedVendors", "filtersTab", "tactics", "filtersUnchecked", "allModifierTypes", "selectedScenario", "onUpdateTactics", "onUpdateFiltersTab", "onUpdateFiltersUnchecked", "onUpdateStepChecked", "onUpdateSubstepChecked"])
                      ], 2 /* CLASS */)
                    ]),
                    _: 1 /* STABLE */
                  }))
                : createCommentVNode("v-if", true)
            ])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["cols", "class"]),
        createVNode(_component_v_col, {
          id: "overviewCol",
          class: normalizeClass({'overview-col': true, 'fixed-scroll': !_ctx.$vuetify.display.mobile }),
          onScroll: $options.handleScroll
        }, {
          default: withCtx(() => [
            (
            _ctx.selectedEvaluation &&
            _ctx.selectedScenario &&
            (!_ctx.$vuetify.display.mobile || _ctx.selectedVendors.length)
          )
              ? (openBlock(), createBlock(_component_v_card, {
                  key: 0,
                  color: "white"
                }, {
                  default: withCtx(() => [
                    createVNode(_component_v_card_text, { class: "m-spacing--top-6 m-spacing--left-4 m-spacing--right-4" }, {
                      default: withCtx(() => [
                        createVNode(_component_v_row, null, {
                          default: withCtx(() => [
                            createCommentVNode(" left side of card: evaluation information "),
                            createVNode(_component_v_col, {
                              class: "text-left c-spacing--bottom-2",
                              cols: _ctx.$vuetify.display.mobile ? '12' : '6'
                            }, {
                              default: withCtx(() => [
                                _hoisted_11,
                                createElementVNode("div", _hoisted_12, [
                                  createElementVNode("p", _hoisted_13, toDisplayString(_ctx.selectedEvaluation.display_name) + " (" + toDisplayString($options.getYear(_ctx.selectedEvaluation)) + ") ", 1 /* TEXT */),
                                  createElementVNode("a", {
                                    "data-id": "results.overviewcard.learnmorelink",
                                    class: normalizeClass([{
                      'mk-link--no-text-decoration': true,
                      'mk-text--hover': !$props.preview,
                      'mk-link--disabled': $props.preview,
                    }, "overview-button"]),
                                    href: `/${this.route.params.domain}/${_ctx.selectedEvaluation.name}/`,
                                    target: "_blank",
                                    rel: "noopener noreferrer"
                                  }, " Overview ", 10 /* CLASS, PROPS */, _hoisted_14)
                                ]),
                                createElementVNode("p", {
                                  class: normalizeClass({
                    'mk-text--light scenario-description-container': true,
                    'p--nowrap': !_ctx.expandOverviewCard,
                  }),
                                  innerHTML: _ctx.selectedEvaluation.description
                                }, null, 10 /* CLASS, PROPS */, _hoisted_15)
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["cols"]),
                            createCommentVNode(" right side of card: scenario information "),
                            createVNode(_component_v_col, {
                              class: "text-left c-spacing--bottom-2",
                              cols: _ctx.$vuetify.display.mobile ? '12' : '6'
                            }, {
                              default: withCtx(() => [
                                _hoisted_16,
                                createElementVNode("p", {
                                  style: normalizeStyle({visibility: _ctx.scenarioOptions.length > 1 ? 'visible' : 'hidden'}),
                                  class: "mk-text--fontsize-18"
                                }, toDisplayString(_ctx.selectedScenario.name), 5 /* TEXT, STYLE */),
                                createElementVNode("p", {
                                  class: normalizeClass({
                    'mk-text--light': true,
                    'p--nowrap': !_ctx.expandOverviewCard,
                  }),
                                  innerHTML: _ctx.selectedScenario.description
                                }, null, 10 /* CLASS, PROPS */, _hoisted_17)
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["cols"])
                          ]),
                          _: 1 /* STABLE */
                        }),
                        createCommentVNode(" bottom of card: read more "),
                        createVNode(_component_v_row, null, {
                          default: withCtx(() => [
                            createVNode(_component_v_col, { class: "c-spacing--top-2" }, {
                              default: withCtx(() => [
                                (!_ctx.expandOverviewCard)
                                  ? (openBlock(), createElementBlock("span", {
                                      key: 0,
                                      onClick: _cache[7] || (_cache[7] = $event => (_ctx.expandOverviewCard = true)),
                                      class: "c-text--primary mk-text--hover-no-underline",
                                      "data-id": "results.overviewcard.expandbutton"
                                    }, " Expand "))
                                  : (openBlock(), createElementBlock("span", {
                                      key: 1,
                                      onClick: _cache[8] || (_cache[8] = $event => (_ctx.expandOverviewCard = false)),
                                      class: "c-text--primary mk-text--hover-no-underline",
                                      "data-id": "results.overviewcard.collapsebutton"
                                    }, " Collapse "))
                              ]),
                              _: 1 /* STABLE */
                            })
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                }))
              : createCommentVNode("v-if", true),
            createCommentVNode(" vendor results visualizations "),
            (_ctx.selectedEvaluation && (!_ctx.selectedScenario || !Object.keys(_ctx.selectedScenario).length))
              ? (openBlock(), createBlock(_component_v_row, {
                  key: 1,
                  class: "mt-7"
                }, {
                  default: withCtx(() => [
                    createVNode(_component_v_col, { class: "text-center" }, {
                      default: withCtx(() => [
                        createTextVNode("No scenario selected")
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                }))
              : createCommentVNode("v-if", true),
            (_ctx.selectedScenario && !_ctx.selectedVendors.length)
              ? (openBlock(), createBlock(_component_v_row, {
                  key: 2,
                  class: "mt-7"
                }, {
                  default: withCtx(() => [
                    createVNode(_component_v_col, { class: "text-center" }, {
                      default: withCtx(() => [
                        createTextVNode("No participants selected")
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                }))
              : (openBlock(), createBlock(_component_v_row, {
                  key: 3,
                  class: "mt-6"
                }, {
                  default: withCtx(() => [
                    (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.selectedVendors, (vendor, index) => {
                      return (openBlock(), createBlock(_component_v_col, {
                        key: vendor.name,
                        cols: 12 / _ctx.selectedVendors.length
                      }, {
                        default: withCtx(() => [
                          (
                (_ctx.selectedScenario.scenario_type === 'PROTECTION' || _ctx.breachScreenshots[vendor.name])
                && _ctx.selectedScenario
              )
                            ? (openBlock(), createBlock(_component_VendorLogoAndHoverButtons, {
                                key: 0,
                                vendorsHoverDict: _ctx.vendorsHoverDict,
                                selectedEvaluation: _ctx.selectedEvaluation,
                                removeVendor: $options.removeVendor,
                                vendor: vendor,
                                selectedScenario: _ctx.selectedScenario,
                                breachScreenshots: 
                _ctx.selectedScenario.scenario_type === 'DETECTION'?
                _ctx.breachScreenshots[vendor.name][`Scenario_${_ctx.selectedScenario.number}`] :
                []
              ,
                                vendorLogoUrl: $props.vendorLogoUrl,
                                screenshotUrl: $props.vendorSummaryScreenshotUrl,
                                preview: $props.preview,
                                archiveUrl: _ctx.archiveUrls[vendor.name],
                                isEnriched: _ctx.vendorEnrichedDict[vendor.name],
                                enrichedCriteria: _ctx.vendorEnrichedCriteriaDict[vendor.name],
                                scenarioMetricPreview: false,
                                onUpdateVendorDisclaimerExpanded: $options.updateVendorDisclaimerExpanded
                              }, null, 8 /* PROPS */, ["vendorsHoverDict", "selectedEvaluation", "removeVendor", "vendor", "selectedScenario", "breachScreenshots", "vendorLogoUrl", "screenshotUrl", "preview", "archiveUrl", "isEnriched", "enrichedCriteria", "onUpdateVendorDisclaimerExpanded"]))
                            : createCommentVNode("v-if", true),
                          createVNode(_component_v_row, {
                            style: normalizeStyle(
                _ctx.selectedEvaluation.name == 'turla' &&
                vendor.name !== 'microsoft'
                  ? `margin-top:${_ctx.summaryChartMarginTop}px;`
                  : ''
              ),
                            id: "charts"
                          }, {
                            default: withCtx(() => [
                              (!(vendor.name === 'checkpoint' && _ctx.selectedEvaluation.name === 'er6' && _ctx.selectedScenario.scenario_type === 'PROTECTION'))
                                ? (openBlock(), createBlock(_component_v_col, { key: 0 }, {
                                    default: withCtx(() => [
                                      createCommentVNode(" entire scenario detection summary "),
                                      createVNode(_component_ScenarioSummary, {
                                        vendor: vendor,
                                        index: index,
                                        tactics: _ctx.tactics,
                                        stepsRendered: $options.stepsRendered,
                                        filtersUnchecked: _ctx.filtersUnchecked,
                                        actionableMetricPresent: $options.actionableMetricPresent,
                                        chartHeight: $options.chartHeight,
                                        vendorMTTDDict: _ctx.vendorMTTDDict,
                                        averageScenarioMTTD: _ctx.averageScenarioMTTD,
                                        scenarioMetricPreview: false,
                                        getTotalSubsteps: $options.getTotalSubsteps,
                                        getActionableTotalFromVendor: $options.getActionableTotalFromVendor,
                                        getTotalPossibleActionableForVendor: $options.getTotalPossibleActionableForVendor,
                                        preview: $props.preview,
                                        scenarioName: _ctx.selectedScenario.name,
                                        amountSelectedVendors: _ctx.selectedVendors.length,
                                        selectedScenario: _ctx.selectedScenario,
                                        noiseMetricPresent: $options.noiseMetricPresent,
                                        noiseData: $options.vendorNameToNoiseData[vendor.name],
                                        selectedEvaluation: _ctx.selectedEvaluation
                                      }, null, 8 /* PROPS */, ["vendor", "index", "tactics", "stepsRendered", "filtersUnchecked", "actionableMetricPresent", "chartHeight", "vendorMTTDDict", "averageScenarioMTTD", "getTotalSubsteps", "getActionableTotalFromVendor", "getTotalPossibleActionableForVendor", "preview", "scenarioName", "amountSelectedVendors", "selectedScenario", "noiseMetricPresent", "noiseData", "selectedEvaluation"]),
                                      createCommentVNode(" detection summary for each step "),
                                      createElementVNode("div", {
                                        class: normalizeClass({'text-left mk-text--h2 my-7': true, 'invisible': index != 0})
                                      }, "Step Summary", 2 /* CLASS */),
                                      (
                    $options.stepsRendered &&
                    _ctx.filtersTab === 'steps' &&
                    _ctx.selectedScenario.scenario_type === 'DETECTION'
                  )
                                        ? (openBlock(), createElementBlock("div", _hoisted_18, [
                                            createTextVNode(" Step Detections "),
                                            (openBlock(true), createElementBlock(Fragment, null, renderList($options.filteredSteps, (step) => {
                                              return (openBlock(), createElementBlock("div", {
                                                key: step.Step_Num
                                              }, [
                                                createElementVNode("div", {
                                                  class: "step-name-div m-spacing--top-3",
                                                  onMouseenter: $event => (_ctx.vendorsHoverDict[vendor.name].steps[step.Step_Num] = true),
                                                  onMouseleave: $event => (_ctx.vendorsHoverDict[vendor.name].steps[step.Step_Num] = false)
                                                }, [
                                                  createElementVNode("div", _hoisted_20, [
                                                    createElementVNode("span", {
                                                      class: normalizeClass(step.Substeps.some((substep) =>substep.Capability_Requirements.includes('Linux Capability')) ? 'step-name--linux' : 'step-name')
                                                    }, toDisplayString(step.Step_Num) + " - " + toDisplayString(step.Step_Name), 3 /* TEXT, CLASS */),
                                                    (step.Substeps.some((substep) => substep.Capability_Requirements.includes('Linux Capability')))
                                                      ? (openBlock(), createBlock(_component_LinuxChip, {
                                                          key: 0,
                                                          tooltipText: $options.getTooltipText(step)
                                                        }, null, 8 /* PROPS */, ["tooltipText"]))
                                                      : createCommentVNode("v-if", true)
                                                  ]),
                                                  (
                          _ctx.vendorsHoverDict[vendor.name].steps[step.Step_Num]
                        )
                                                    ? (openBlock(), createElementBlock("span", {
                                                        key: 0,
                                                        onMouseenter: $event => (_ctx.vendorsHoverDict[vendor.name].steps[step.Step_Num] = true),
                                                        class: "text-right c-text--cursor-pointer jump-to-icon mk-text--grey60 material-symbols-rounded m-spacing--right-3",
                                                        onClick: $event => ($options.scrollToStep(step.Step_Num)),
                                                        "data-id": "results.jumptostepbutton"
                                                      }, " move_down ", 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_21))
                                                    : createCommentVNode("v-if", true),
                                                  (!$options.isSetupStep(step) && !$options.isOnlySetupSubstepsIncluded(step))
                                                    ? (openBlock(), createElementBlock("div", _hoisted_22, toDisplayString($options.substepTotalPerStep[step.Step_Num]) + " Results", 1 /* TEXT */))
                                                    : ($options.isOnlySetupSubstepsIncluded(step))
                                                      ? (openBlock(), createElementBlock("span", _hoisted_23, [
                                                          createTextVNode(" 0 "),
                                                          _hoisted_24
                                                        ]))
                                                      : (openBlock(), createElementBlock("span", _hoisted_25, "   Setup Step "))
                                                ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_19),
                                                (!$options.isSetupStep(step))
                                                  ? (openBlock(), createElementBlock("div", {
                                                      key: 0,
                                                      class: "text-left",
                                                      id: `stepDetectionChart_${step.Step_Num}_${vendor.name}`,
                                                      style: normalizeStyle(this.actionableMetricPresent && `height: ${$options.chartHeight}px;`),
                                                      ref_for: true,
                                                      ref: `stepDetectionChart_${step.Step_Num}_${vendor.name}`
                                                    }, null, 12 /* STYLE, PROPS */, _hoisted_26))
                                                  : createCommentVNode("v-if", true),
                                                (
                        _ctx.selectedScenario.scenario_type === 'DETECTION' &&
                        $options.actionableMetricPresent && !$options.isSetupStep(step)
                      )
                                                  ? (openBlock(), createElementBlock("div", {
                                                      key: 1,
                                                      class: "text-left",
                                                      id: `stepActionableDetectionChart_${step.Step_Num}_${vendor.name}`,
                                                      ref_for: true,
                                                      ref: `stepActionableDetectionChart_${step.Step_Num}_${vendor.name}`
                                                    }, null, 8 /* PROPS */, _hoisted_27))
                                                  : createCommentVNode("v-if", true),
                                                ($options.actionableMetricPresent && !$options.isSetupStep(step))
                                                  ? (openBlock(), createElementBlock("div", _hoisted_28, [
                                                      (!$options.isOnlySetupSubstepsIncluded(step))
                                                        ? (openBlock(), createElementBlock("span", _hoisted_29, [
                                                            createTextVNode(toDisplayString($options.getActionablePerStepFromVendor(vendor.name)[step.Step_Num]) + "/" + toDisplayString($options.getTotalPossibleActionableForStep(step, vendor.name)) + " ", 1 /* TEXT */),
                                                            _hoisted_30
                                                          ]))
                                                        : (openBlock(), createElementBlock("span", _hoisted_31, [
                                                            createTextVNode(" 0 "),
                                                            _hoisted_32
                                                          ])),
                                                      createVNode(_component_v_tooltip, {
                                                        "content-class": "mk-tooltip--allow-pointer-events",
                                                        location: "top"
                                                      }, {
                                                        activator: withCtx(({ props }) => [
                                                          createVNode(_component_v_icon, mergeProps({ color: "grey" }, props, { size: "15px" }), {
                                                            default: withCtx(() => [
                                                              createTextVNode(" mdi-information-outline ")
                                                            ]),
                                                            _: 2 /* DYNAMIC */
                                                          }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */)
                                                        ]),
                                                        default: withCtx(() => [
                                                          _hoisted_33
                                                        ]),
                                                        _: 1 /* STABLE */
                                                      })
                                                    ]))
                                                  : createCommentVNode("v-if", true)
                                              ]))
                                            }), 128 /* KEYED_FRAGMENT */))
                                          ]))
                                        : (_ctx.filtersTab === 'tactics' &&
                            _ctx.filtersUnchecked.tacticsUnchecked.length < Object.keys(_ctx.tactics).length &&
                            _ctx.selectedScenario.scenario_type === 'DETECTION')
                                          ? (openBlock(), createElementBlock("div", _hoisted_34, [
                                              createTextVNode(" Tactic Detection "),
                                              (openBlock(true), createElementBlock(Fragment, null, renderList(Object.keys(_ctx.tactics), (tactic) => {
                                                return (openBlock(), createElementBlock("div", { key: tactic }, [
                                                  (
                        !_ctx.filtersUnchecked.tacticsUnchecked.includes(tactic) &&
                        !_ctx.tacticsNotShown.includes(tactic)
                      )
                                                    ? (openBlock(), createElementBlock("div", _hoisted_35, [
                                                        createElementVNode("div", _hoisted_36, [
                                                          createElementVNode("span", _hoisted_37, [
                                                            createElementVNode("span", _hoisted_38, toDisplayString(_ctx.tactics[tactic].name) + " (" + toDisplayString(tactic) + ")", 1 /* TEXT */)
                                                          ]),
                                                          createElementVNode("span", _hoisted_39, [
                                                            createTextVNode(toDisplayString($options.substepTotalPerTactic[tactic]) + " ", 1 /* TEXT */),
                                                            _hoisted_40
                                                          ])
                                                        ]),
                                                        createElementVNode("div", {
                                                          class: "text-left",
                                                          id: `tacticDetectionChart_${tactic}_${vendor.name}`,
                                                          style: normalizeStyle(this.actionableMetricPresent && `height: ${$options.chartHeight}px;`),
                                                          ref_for: true,
                                                          ref: `tacticDetectionChart_${tactic}_${vendor.name}`
                                                        }, null, 12 /* STYLE, PROPS */, _hoisted_41),
                                                        (_ctx.selectedScenario && _ctx.selectedScenario.scenario_type === 'DETECTION' && $options.actionableMetricPresent)
                                                          ? (openBlock(), createElementBlock("div", {
                                                              key: 0,
                                                              class: "text-left",
                                                              id: `tacticActionableDetectionChart_${tactic}_${vendor.name}`,
                                                              ref_for: true,
                                                              ref: `tacticActionableDetectionChart_${tactic}_${vendor.name}`
                                                            }, null, 8 /* PROPS */, _hoisted_42))
                                                          : createCommentVNode("v-if", true),
                                                        ($options.actionableMetricPresent)
                                                          ? (openBlock(), createElementBlock("div", _hoisted_43, [
                                                              createElementVNode("span", _hoisted_44, [
                                                                createTextVNode(toDisplayString($options.getActionablePerTacticFromVendor(vendor.name)[tactic]) + "/" + toDisplayString($options.getTotalPossibleActionableForTactic(tactic, vendor.name)) + " ", 1 /* TEXT */),
                                                                _hoisted_45
                                                              ]),
                                                              createVNode(_component_v_tooltip, {
                                                                "content-class": "mk-tooltip--allow-pointer-events",
                                                                location: "top"
                                                              }, {
                                                                activator: withCtx(({ props }) => [
                                                                  createVNode(_component_v_icon, mergeProps({ color: "grey" }, props, { size: "15px" }), {
                                                                    default: withCtx(() => [
                                                                      createTextVNode(" mdi-information-outline ")
                                                                    ]),
                                                                    _: 2 /* DYNAMIC */
                                                                  }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */)
                                                                ]),
                                                                default: withCtx(() => [
                                                                  _hoisted_46
                                                                ]),
                                                                _: 1 /* STABLE */
                                                              })
                                                            ]))
                                                          : createCommentVNode("v-if", true)
                                                      ]))
                                                    : createCommentVNode("v-if", true)
                                                ]))
                                              }), 128 /* KEYED_FRAGMENT */))
                                            ]))
                                          : (_ctx.selectedScenario.scenario_type === 'PROTECTION')
                                            ? (openBlock(), createElementBlock("div", _hoisted_47, [
                                                createTextVNode(" Test Detection "),
                                                (openBlock(true), createElementBlock(Fragment, null, renderList($options.filteredSteps, (step) => {
                                                  return (openBlock(), createElementBlock("div", {
                                                    class: "text-left",
                                                    key: step.Step_Num,
                                                    id: `testChart_${step.Step_Num}`
                                                  }, [
                                                    createElementVNode("div", {
                                                      class: "text-left step-name-div",
                                                      onMouseenter: $event => (_ctx.vendorsHoverDict[vendor.name].steps[step.Step_Num] = true),
                                                      onMouseleave: $event => (_ctx.vendorsHoverDict[vendor.name].steps[step.Step_Num] = false)
                                                    }, [
                                                      createElementVNode("span", _hoisted_50, [
                                                        createElementVNode("span", {
                                                          class: normalizeClass(step.Substeps.some((substep) => substep.Capability_Requirements.includes('Linux Capability')) ? 'step-name--linux' : 'step-name')
                                                        }, toDisplayString(step.Step_Num) + " - " + toDisplayString(step.Step_Name), 3 /* TEXT, CLASS */),
                                                        (step.Substeps.some((substep) => substep.Capability_Requirements.includes('Linux Capability')))
                                                          ? (openBlock(), createBlock(_component_LinuxChip, {
                                                              key: 0,
                                                              tooltipText: $options.getTooltipText(step)
                                                            }, null, 8 /* PROPS */, ["tooltipText"]))
                                                          : createCommentVNode("v-if", true)
                                                      ]),
                                                      (_ctx.vendorsHoverDict[vendor.name].steps[step.Step_Num])
                                                        ? (openBlock(), createElementBlock("span", {
                                                            key: 0,
                                                            onMouseenter: $event => (_ctx.vendorsHoverDict[vendor.name].steps[step.Step_Num] = true),
                                                            class: "text-right c-text--cursor-pointer jump-to-icon mk-text--grey60 material-symbols-rounded",
                                                            "data-id": "results.jumptostepbutton",
                                                            onClick: $event => ($options.scrollToStep(step.Step_Num))
                                                          }, "move_down", 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_51))
                                                        : createCommentVNode("v-if", true)
                                                    ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_49),
                                                    createCommentVNode(" 6 added in to prevent overflow "),
                                                    (openBlock(true), createElementBlock(Fragment, null, renderList($options.filterProtectionChartSubsteps(step.Substeps), (substep) => {
                                                      return (openBlock(), createElementBlock("span", {
                                                        key: substep.Substep
                                                      }, [
                                                        createVNode(_component_v_tooltip, {
                                                          location: $options.getLocation(step),
                                                          "content-class": $options.getContentClass(step)
                                                        }, {
                                                          activator: withCtx(({ props }) => [
                                                            (openBlock(), createElementBlock("svg", mergeProps(props, {
                                                              width: $options.chartWidth / $options.maxSubstepsInTest - 6,
                                                              height: $options.chartHeight,
                                                              class: "mr-1",
                                                              style: $options.getProtectionChartColor(vendor.name, substep) === '#FFFFFF' ? 'border: 1px solid #25333C' : ''
                                                            }), [
                                                              (openBlock(), createElementBlock("rect", {
                                                                key: substep.Substep,
                                                                height: $options.chartHeight,
                                                                width: $options.chartWidth / $options.maxSubstepsInTest,
                                                                style: normalizeStyle(`fill:${$options.getProtectionChartColor(vendor.name,substep)}`)
                                                              }, null, 12 /* STYLE, PROPS */, _hoisted_53))
                                                            ], 16 /* FULL_PROPS */, _hoisted_52))
                                                          ]),
                                                          default: withCtx(() => [
                                                            createElementVNode("div", null, [
                                                              createElementVNode("div", null, toDisplayString(substep.Technique.Technique_Name) + " (" + toDisplayString(substep.Technique.Technique_Id) + ") ", 1 /* TEXT */),
                                                              (substep.Vendor_Data.find((substepVendor) => substepVendor.Vendor_Name === vendor.name))
                                                                ? (openBlock(), createElementBlock("div", _hoisted_54, toDisplayString($options.getProtectionType(vendor, substep)), 1 /* TEXT */))
                                                                : createCommentVNode("v-if", true)
                                                            ])
                                                          ]),
                                                          _: 2 /* DYNAMIC */
                                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["location", "content-class"])
                                                      ]))
                                                    }), 128 /* KEYED_FRAGMENT */))
                                                  ], 8 /* PROPS */, _hoisted_48))
                                                }), 128 /* KEYED_FRAGMENT */))
                                              ]))
                                            : createCommentVNode("v-if", true)
                                    ]),
                                    _: 2 /* DYNAMIC */
                                  }, 1024 /* DYNAMIC_SLOTS */))
                                : createCommentVNode("v-if", true)
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["style"])
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["cols"]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]),
                  _: 1 /* STABLE */
                })),
            (_ctx.selectedScenario)
              ? (openBlock(), createBlock(_component_EvaluationDetails, {
                  key: 4,
                  selectedVendors: _ctx.selectedVendors,
                  comparisonData: _ctx.comparisonData,
                  evaluationSteps: _ctx.evaluationSteps,
                  evalResultCategoriesNames: _ctx.evalResultCategoriesNames,
                  adversaryChartColors: _ctx.adversaryChartColors,
                  selectedScenario: _ctx.selectedScenario,
                  selectedEvaluation: _ctx.selectedEvaluation,
                  checkIfStepProtected: $options.checkIfStepProtected,
                  getTooltipText: $options.getTooltipText,
                  screenshotUrl: $props.screenshotUrl,
                  preview: $props.preview,
                  showSetup: _ctx.showSetup,
                  isScrollToTopBtnDisplayed: _ctx.isEvaluationDetailsVisible && !_ctx.chartLegendScrollToTopOverlap
                }, null, 8 /* PROPS */, ["selectedVendors", "comparisonData", "evaluationSteps", "evalResultCategoriesNames", "adversaryChartColors", "selectedScenario", "selectedEvaluation", "checkIfStepProtected", "getTooltipText", "screenshotUrl", "preview", "showSetup", "isScrollToTopBtnDisplayed"]))
              : createCommentVNode("v-if", true)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["class", "onScroll"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["class"])
  ]))
}
var IndividualParticipantResults = /*#__PURE__*/_export_sfc(_sfc_main$1, [['render',_sfc_render],['__file',"/home/runner/work/evals-website/evals-website/packages/enterprise-results/src/IndividualParticipantResults.vue"]]);

var css_248z$1 = "";
styleInject(css_248z$1);

const _sfc_main = {
  __name: 'Results',
  props: {
  allModifierTypes: Array,
  allResultCategories: Array,
  preview: Boolean,
  startingEvaluation: Object,
  startingScenario: Object,
  startingVendors: Object,
  domain: String,
  evaluations: Array,
  vendorLogoUrl: String,
  screenshotUrl: String,
  vendorSummaryScreenshotUrl: String,
  setup: Boolean,
  arcadeStepsData: Object,
},
  setup(__props) {



const route = useRoute();
const router = useRouter();

const cohortOrIndividualParticipantToggle = ref("cohort");

watch(cohortOrIndividualParticipantToggle, (_, oldVal) => {
  if(!oldVal) {
    let query = router.query.value;
    query.view = cohortOrIndividualParticipantToggle.value;
    router.push({query: query});
  }
  else {
    let query = {view: cohortOrIndividualParticipantToggle.value};
    if(route.query.evaluation) {
      query.evaluation = route.query.evaluation;
    }
    router.push({query: query});
  }
});

onMounted(() => {
  const view = route.query.view;
  if(view === 'cohort' || view === 'individualParticipant') {
    cohortOrIndividualParticipantToggle.value = view;
  }
  else cohortOrIndividualParticipantToggle.value = "cohort";
});

return (_ctx, _cache) => {
  return (openBlock(), createElementBlock("div", null, [
    (cohortOrIndividualParticipantToggle.value === 'individualParticipant')
      ? (openBlock(), createBlock(IndividualParticipantResults, {
          key: 0,
          allModifierTypes: __props.allModifierTypes,
          allResultCategories: __props.allResultCategories,
          preview: __props.preview,
          startingEvaluation: __props.startingEvaluation,
          startingScenario: __props.startingScenario,
          startingVendors: __props.startingVendors,
          domain: __props.domain,
          evaluations: __props.evaluations,
          vendorLogoUrl: __props.vendorLogoUrl,
          screenshotUrl: __props.screenshotUrl,
          vendorSummaryScreenshotUrl: __props.vendorSummaryScreenshotUrl,
          setup: __props.setup,
          arcadeStepsData: __props.arcadeStepsData,
          onToggle: _cache[0] || (_cache[0] = $event => (cohortOrIndividualParticipantToggle.value='cohort')),
          class: "px-7"
        }, null, 8 /* PROPS */, ["allModifierTypes", "allResultCategories", "preview", "startingEvaluation", "startingScenario", "startingVendors", "domain", "evaluations", "vendorLogoUrl", "screenshotUrl", "vendorSummaryScreenshotUrl", "setup", "arcadeStepsData"]))
      : (__props.evaluations.length)
        ? (openBlock(), createBlock(GroupCohort, {
            key: 1,
            evaluations: __props.evaluations,
            onToggle: _cache[1] || (_cache[1] = $event => (cohortOrIndividualParticipantToggle.value='individualParticipant'))
          }, null, 8 /* PROPS */, ["evaluations"]))
        : createCommentVNode("v-if", true)
  ]))
}
}

};
var Results = /*#__PURE__*/_export_sfc(_sfc_main, [['__file',"/home/runner/work/evals-website/evals-website/packages/enterprise-results/src/Results.vue"]]);

var css_248z = "";
styleInject(css_248z);

// Import vue component
// Declare install function executed by Vue.use()
function install(Vue) {
  if (install.installed) return;
  install.installed = true;
  Vue.component('Results', Results);
  Vue.component('ScenarioSummary', ScenarioSummary);
  Vue.component('VendorLogoAndHoverButtons', VendorLogoAndHover);
}

// Create module definition for Vue.use()
const plugin = {
  install
};

// Auto-install when vue is found (eg. in browser via <script> tag)
let GlobalVue = null;
if (typeof window !== 'undefined') {
  GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
  GlobalVue = global.Vue;
}
if (GlobalVue) {
  GlobalVue.use(plugin);
}

export { ScenarioSummary, VendorLogoAndHoverButtons, Results as default, install };
